var ls = Object.defineProperty;
var fs = (r, e, t) => e in r ? ls(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var mt = (r, e, t) => fs(r, typeof e != "symbol" ? e + "" : e, t);
var Qr = function(r, e) {
  return Qr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
    t.__proto__ = n;
  } || function(t, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
  }, Qr(r, e);
};
function ds(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Qr(r, e);
  function t() {
    this.constructor = r;
  }
  r.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
var Sr = "Invariant Violation", Gn = Object.setPrototypeOf, hs = Gn === void 0 ? function(r, e) {
  return r.__proto__ = e, r;
} : Gn, B = (
  /** @class */
  function(r) {
    ds(e, r);
    function e(t) {
      t === void 0 && (t = Sr);
      var n = r.call(this, typeof t == "number" ? Sr + ": " + t + " (see https://github.com/apollographql/invariant-packages)" : t) || this;
      return n.framesToPop = 1, n.name = Sr, hs(n, e.prototype), n;
    }
    return e;
  }(Error)
);
function E(r, e) {
  if (!r)
    throw new B(e);
}
var Gi = ["debug", "log", "warn", "error", "silent"], ps = Gi.indexOf("log");
function Ht(r) {
  return function() {
    if (Gi.indexOf(r) >= ps) {
      var e = console[r] || console.log;
      return e.apply(console, arguments);
    }
  };
}
(function(r) {
  r.debug = Ht("debug"), r.log = Ht("log"), r.warn = Ht("warn"), r.error = Ht("error");
})(E || (E = {}));
function he(r) {
  try {
    return r();
  } catch {
  }
}
const Jn = he(function() {
  return globalThis;
}) || he(function() {
  return window;
}) || he(function() {
  return self;
}) || he(function() {
  return global;
}) || he(function() {
  return he.constructor("return this")();
});
var Hn = "__", Yn = [Hn, Hn].join("DEV");
function ys() {
  try {
    return !!__DEV__;
  } catch {
    return Object.defineProperty(Jn, Yn, {
      value: he(function() {
        return process.env.NODE_ENV;
      }) !== "production",
      enumerable: !1,
      configurable: !0,
      writable: !0
    }), Jn[Yn];
  }
}
const Or = ys();
function Pe(r) {
  try {
    return r();
  } catch {
  }
}
var Br = Pe(function() {
  return globalThis;
}) || Pe(function() {
  return window;
}) || Pe(function() {
  return self;
}) || Pe(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
Pe(function() {
  return Pe.constructor("return this")();
}), Zr = !1;
function vs() {
  Br && !Pe(function() {
    return process.env.NODE_ENV;
  }) && !Pe(function() {
    return process;
  }) && (Object.defineProperty(Br, "process", {
    value: {
      env: {
        // This default needs to be "production" instead of "development", to
        // avoid the problem https://github.com/graphql/graphql-js/pull/2894
        // will eventually solve, once merged and released.
        NODE_ENV: "production"
      }
    },
    // Let anyone else change global.process as they see fit, but hide it from
    // Object.keys(global) enumeration.
    configurable: !0,
    enumerable: !1,
    writable: !0
  }), Zr = !0);
}
vs();
function Kn() {
  Zr && (delete Br.process, Zr = !1);
}
var ms = typeof Symbol == "function" && Symbol.toStringTag != null ? Symbol.toStringTag : "@@toStringTag", Ji = Object.freeze({
  // Name
  NAME: "Name",
  // Document
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  // Fragments
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  // Values
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  // Directives
  DIRECTIVE: "Directive",
  // Types
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType",
  // Type System Definitions
  SCHEMA_DEFINITION: "SchemaDefinition",
  OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
  // Type Definitions
  SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
  OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
  FIELD_DEFINITION: "FieldDefinition",
  INPUT_VALUE_DEFINITION: "InputValueDefinition",
  INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
  UNION_TYPE_DEFINITION: "UnionTypeDefinition",
  ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
  ENUM_VALUE_DEFINITION: "EnumValueDefinition",
  INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
  // Directive Definitions
  DIRECTIVE_DEFINITION: "DirectiveDefinition",
  // Type System Extensions
  SCHEMA_EXTENSION: "SchemaExtension",
  // Type Extensions
  SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
  OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
  INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
  UNION_TYPE_EXTENSION: "UnionTypeExtension",
  ENUM_TYPE_EXTENSION: "EnumTypeExtension",
  INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
});
function gs(r, e) {
  var t = !!r;
  if (!t)
    throw new Error("Unexpected invariant triggered.");
}
var Ur = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : void 0;
function Hi(r) {
  var e = r.prototype.toJSON;
  typeof e == "function" || gs(0), r.prototype.inspect = e, Ur && (r.prototype[Ur] = e);
}
var bs = /* @__PURE__ */ function() {
  function r(t, n, i) {
    this.start = t.start, this.end = n.end, this.startToken = t, this.endToken = n, this.source = i;
  }
  var e = r.prototype;
  return e.toJSON = function() {
    return {
      start: this.start,
      end: this.end
    };
  }, r;
}();
Hi(bs);
var _s = /* @__PURE__ */ function() {
  function r(t, n, i, a, s, o, c) {
    this.kind = t, this.start = n, this.end = i, this.line = a, this.column = s, this.value = c, this.prev = o, this.next = null;
  }
  var e = r.prototype;
  return e.toJSON = function() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }, r;
}();
Hi(_s);
function Xn(r) {
  return r != null && typeof r.kind == "string";
}
function Xt(r) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Xt = function(t) {
    return typeof t;
  } : Xt = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xt(r);
}
var ws = 10, Yi = 2;
function Ki(r) {
  return yr(r, []);
}
function yr(r, e) {
  switch (Xt(r)) {
    case "string":
      return JSON.stringify(r);
    case "function":
      return r.name ? "[function ".concat(r.name, "]") : "[function]";
    case "object":
      return r === null ? "null" : ks(r, e);
    default:
      return String(r);
  }
}
function ks(r, e) {
  if (e.indexOf(r) !== -1)
    return "[Circular]";
  var t = [].concat(e, [r]), n = Os(r);
  if (n !== void 0) {
    var i = n.call(r);
    if (i !== r)
      return typeof i == "string" ? i : yr(i, t);
  } else if (Array.isArray(r))
    return Ss(r, t);
  return Es(r, t);
}
function Es(r, e) {
  var t = Object.keys(r);
  if (t.length === 0)
    return "{}";
  if (e.length > Yi)
    return "[" + xs(r) + "]";
  var n = t.map(function(i) {
    var a = yr(r[i], e);
    return i + ": " + a;
  });
  return "{ " + n.join(", ") + " }";
}
function Ss(r, e) {
  if (r.length === 0)
    return "[]";
  if (e.length > Yi)
    return "[Array]";
  for (var t = Math.min(ws, r.length), n = r.length - t, i = [], a = 0; a < t; ++a)
    i.push(yr(r[a], e));
  return n === 1 ? i.push("... 1 more item") : n > 1 && i.push("... ".concat(n, " more items")), "[" + i.join(", ") + "]";
}
function Os(r) {
  var e = r[String(Ur)];
  if (typeof e == "function")
    return e;
  if (typeof r.inspect == "function")
    return r.inspect;
}
function xs(r) {
  var e = Object.prototype.toString.call(r).replace(/^\[object /, "").replace(/]$/, "");
  if (e === "Object" && typeof r.constructor == "function") {
    var t = r.constructor.name;
    if (typeof t == "string" && t !== "")
      return t;
  }
  return e;
}
function xr(r, e) {
  var t = !!r;
  if (!t)
    throw new Error(e);
}
function Ts(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, n.key, n);
  }
}
function Ds(r, e, t) {
  return e && Ts(r.prototype, e), r;
}
var Is = /* @__PURE__ */ function() {
  function r(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "GraphQL request", n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
      line: 1,
      column: 1
    };
    typeof e == "string" || xr(0, "Body must be a string. Received: ".concat(Ki(e), ".")), this.body = e, this.name = t, this.locationOffset = n, this.locationOffset.line > 0 || xr(0, "line in locationOffset is 1-indexed and must be positive."), this.locationOffset.column > 0 || xr(0, "column in locationOffset is 1-indexed and must be positive.");
  }
  return Ds(r, [{
    key: ms,
    get: function() {
      return "Source";
    }
  }]), r;
}();
function Rs(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = r.indexOf(`
`) === -1, i = r[0] === " " || r[0] === "	", a = r[r.length - 1] === '"', s = r[r.length - 1] === "\\", o = !n || a || s || t, c = "";
  return o && !(n && i) && (c += `
` + e), c += e ? r.replace(/\n/g, `
` + e) : r, o && (c += `
`), '"""' + c.replace(/"""/g, '\\"""') + '"""';
}
var js = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"],
  InterfaceTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, gn = Object.freeze({});
function Te(r, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : js, n = void 0, i = Array.isArray(r), a = [r], s = -1, o = [], c = void 0, u = void 0, f = void 0, d = [], h = [], p = r;
  do {
    s++;
    var m = s === a.length, v = m && o.length !== 0;
    if (m) {
      if (u = h.length === 0 ? void 0 : d[d.length - 1], c = f, f = h.pop(), v) {
        if (i)
          c = c.slice();
        else {
          for (var b = {}, k = 0, I = Object.keys(c); k < I.length; k++) {
            var _ = I[k];
            b[_] = c[_];
          }
          c = b;
        }
        for (var S = 0, N = 0; N < o.length; N++) {
          var j = o[N][0], D = o[N][1];
          i && (j -= S), i && D === null ? (c.splice(j, 1), S++) : c[j] = D;
        }
      }
      s = n.index, a = n.keys, o = n.edits, i = n.inArray, n = n.prev;
    } else {
      if (u = f ? i ? s : a[s] : void 0, c = f ? f[u] : p, c == null)
        continue;
      f && d.push(u);
    }
    var R = void 0;
    if (!Array.isArray(c)) {
      if (!Xn(c))
        throw new Error("Invalid AST Node: ".concat(Ki(c), "."));
      var z = Cs(e, c.kind, m);
      if (z) {
        if (R = z.call(e, c, u, f, d, h), R === gn)
          break;
        if (R === !1) {
          if (!m) {
            d.pop();
            continue;
          }
        } else if (R !== void 0 && (o.push([u, R]), !m))
          if (Xn(R))
            c = R;
          else {
            d.pop();
            continue;
          }
      }
    }
    if (R === void 0 && v && o.push([u, c]), m)
      d.pop();
    else {
      var Z;
      n = {
        inArray: i,
        index: s,
        keys: a,
        edits: o,
        prev: n
      }, i = Array.isArray(c), a = i ? c : (Z = t[c.kind]) !== null && Z !== void 0 ? Z : [], s = -1, o = [], f && h.push(f), f = c;
    }
  } while (n !== void 0);
  return o.length !== 0 && (p = o[o.length - 1][1]), p;
}
function Cs(r, e, t) {
  var n = r[e];
  if (n) {
    if (!t && typeof n == "function")
      return n;
    var i = t ? n.leave : n.enter;
    if (typeof i == "function")
      return i;
  } else {
    var a = t ? r.leave : r.enter;
    if (a) {
      if (typeof a == "function")
        return a;
      var s = a[e];
      if (typeof s == "function")
        return s;
    }
  }
}
function Xi(r) {
  return Te(r, {
    leave: Ns
  });
}
var As = 80, Ns = {
  Name: function(e) {
    return e.value;
  },
  Variable: function(e) {
    return "$" + e.name;
  },
  // Document
  Document: function(e) {
    return x(e.definitions, `

`) + `
`;
  },
  OperationDefinition: function(e) {
    var t = e.operation, n = e.name, i = J("(", x(e.variableDefinitions, ", "), ")"), a = x(e.directives, " "), s = e.selectionSet;
    return !n && !a && !i && t === "query" ? s : x([t, x([n, i]), a, s], " ");
  },
  VariableDefinition: function(e) {
    var t = e.variable, n = e.type, i = e.defaultValue, a = e.directives;
    return t + ": " + n + J(" = ", i) + J(" ", x(a, " "));
  },
  SelectionSet: function(e) {
    var t = e.selections;
    return ye(t);
  },
  Field: function(e) {
    var t = e.alias, n = e.name, i = e.arguments, a = e.directives, s = e.selectionSet, o = J("", t, ": ") + n, c = o + J("(", x(i, ", "), ")");
    return c.length > As && (c = o + J(`(
`, er(x(i, `
`)), `
)`)), x([c, x(a, " "), s], " ");
  },
  Argument: function(e) {
    var t = e.name, n = e.value;
    return t + ": " + n;
  },
  // Fragments
  FragmentSpread: function(e) {
    var t = e.name, n = e.directives;
    return "..." + t + J(" ", x(n, " "));
  },
  InlineFragment: function(e) {
    var t = e.typeCondition, n = e.directives, i = e.selectionSet;
    return x(["...", J("on ", t), x(n, " "), i], " ");
  },
  FragmentDefinition: function(e) {
    var t = e.name, n = e.typeCondition, i = e.variableDefinitions, a = e.directives, s = e.selectionSet;
    return (
      // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(t).concat(J("(", x(i, ", "), ")"), " ") + "on ".concat(n, " ").concat(J("", x(a, " "), " ")) + s
    );
  },
  // Value
  IntValue: function(e) {
    var t = e.value;
    return t;
  },
  FloatValue: function(e) {
    var t = e.value;
    return t;
  },
  StringValue: function(e, t) {
    var n = e.value, i = e.block;
    return i ? Rs(n, t === "description" ? "" : "  ") : JSON.stringify(n);
  },
  BooleanValue: function(e) {
    var t = e.value;
    return t ? "true" : "false";
  },
  NullValue: function() {
    return "null";
  },
  EnumValue: function(e) {
    var t = e.value;
    return t;
  },
  ListValue: function(e) {
    var t = e.values;
    return "[" + x(t, ", ") + "]";
  },
  ObjectValue: function(e) {
    var t = e.fields;
    return "{" + x(t, ", ") + "}";
  },
  ObjectField: function(e) {
    var t = e.name, n = e.value;
    return t + ": " + n;
  },
  // Directive
  Directive: function(e) {
    var t = e.name, n = e.arguments;
    return "@" + t + J("(", x(n, ", "), ")");
  },
  // Type
  NamedType: function(e) {
    var t = e.name;
    return t;
  },
  ListType: function(e) {
    var t = e.type;
    return "[" + t + "]";
  },
  NonNullType: function(e) {
    var t = e.type;
    return t + "!";
  },
  // Type System Definitions
  SchemaDefinition: pe(function(r) {
    var e = r.directives, t = r.operationTypes;
    return x(["schema", x(e, " "), ye(t)], " ");
  }),
  OperationTypeDefinition: function(e) {
    var t = e.operation, n = e.type;
    return t + ": " + n;
  },
  ScalarTypeDefinition: pe(function(r) {
    var e = r.name, t = r.directives;
    return x(["scalar", e, x(t, " ")], " ");
  }),
  ObjectTypeDefinition: pe(function(r) {
    var e = r.name, t = r.interfaces, n = r.directives, i = r.fields;
    return x(["type", e, J("implements ", x(t, " & ")), x(n, " "), ye(i)], " ");
  }),
  FieldDefinition: pe(function(r) {
    var e = r.name, t = r.arguments, n = r.type, i = r.directives;
    return e + (ei(t) ? J(`(
`, er(x(t, `
`)), `
)`) : J("(", x(t, ", "), ")")) + ": " + n + J(" ", x(i, " "));
  }),
  InputValueDefinition: pe(function(r) {
    var e = r.name, t = r.type, n = r.defaultValue, i = r.directives;
    return x([e + ": " + t, J("= ", n), x(i, " ")], " ");
  }),
  InterfaceTypeDefinition: pe(function(r) {
    var e = r.name, t = r.interfaces, n = r.directives, i = r.fields;
    return x(["interface", e, J("implements ", x(t, " & ")), x(n, " "), ye(i)], " ");
  }),
  UnionTypeDefinition: pe(function(r) {
    var e = r.name, t = r.directives, n = r.types;
    return x(["union", e, x(t, " "), n && n.length !== 0 ? "= " + x(n, " | ") : ""], " ");
  }),
  EnumTypeDefinition: pe(function(r) {
    var e = r.name, t = r.directives, n = r.values;
    return x(["enum", e, x(t, " "), ye(n)], " ");
  }),
  EnumValueDefinition: pe(function(r) {
    var e = r.name, t = r.directives;
    return x([e, x(t, " ")], " ");
  }),
  InputObjectTypeDefinition: pe(function(r) {
    var e = r.name, t = r.directives, n = r.fields;
    return x(["input", e, x(t, " "), ye(n)], " ");
  }),
  DirectiveDefinition: pe(function(r) {
    var e = r.name, t = r.arguments, n = r.repeatable, i = r.locations;
    return "directive @" + e + (ei(t) ? J(`(
`, er(x(t, `
`)), `
)`) : J("(", x(t, ", "), ")")) + (n ? " repeatable" : "") + " on " + x(i, " | ");
  }),
  SchemaExtension: function(e) {
    var t = e.directives, n = e.operationTypes;
    return x(["extend schema", x(t, " "), ye(n)], " ");
  },
  ScalarTypeExtension: function(e) {
    var t = e.name, n = e.directives;
    return x(["extend scalar", t, x(n, " ")], " ");
  },
  ObjectTypeExtension: function(e) {
    var t = e.name, n = e.interfaces, i = e.directives, a = e.fields;
    return x(["extend type", t, J("implements ", x(n, " & ")), x(i, " "), ye(a)], " ");
  },
  InterfaceTypeExtension: function(e) {
    var t = e.name, n = e.interfaces, i = e.directives, a = e.fields;
    return x(["extend interface", t, J("implements ", x(n, " & ")), x(i, " "), ye(a)], " ");
  },
  UnionTypeExtension: function(e) {
    var t = e.name, n = e.directives, i = e.types;
    return x(["extend union", t, x(n, " "), i && i.length !== 0 ? "= " + x(i, " | ") : ""], " ");
  },
  EnumTypeExtension: function(e) {
    var t = e.name, n = e.directives, i = e.values;
    return x(["extend enum", t, x(n, " "), ye(i)], " ");
  },
  InputObjectTypeExtension: function(e) {
    var t = e.name, n = e.directives, i = e.fields;
    return x(["extend input", t, x(n, " "), ye(i)], " ");
  }
};
function pe(r) {
  return function(e) {
    return x([e.description, r(e)], `
`);
  };
}
function x(r) {
  var e, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return (e = r == null ? void 0 : r.filter(function(n) {
    return n;
  }).join(t)) !== null && e !== void 0 ? e : "";
}
function ye(r) {
  return J(`{
`, er(x(r, `
`)), `
}`);
}
function J(r, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  return e != null && e !== "" ? r + e + t : "";
}
function er(r) {
  return J("  ", r.replace(/\n/g, `
  `));
}
function Ps(r) {
  return r.indexOf(`
`) !== -1;
}
function ei(r) {
  return r != null && r.some(Ps);
}
function Fs() {
  return Kn();
}
function Ms() {
  __DEV__ ? E(typeof Or == "boolean", Or) : E(typeof Or == "boolean", 38);
}
Fs();
Ms();
var zr = function(r, e) {
  return zr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
    t.__proto__ = n;
  } || function(t, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
  }, zr(r, e);
};
function be(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  zr(r, e);
  function t() {
    this.constructor = r;
  }
  r.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
var y = function() {
  return y = Object.assign || function(e) {
    for (var t, n = 1, i = arguments.length; n < i; n++) {
      t = arguments[n];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, y.apply(this, arguments);
};
function lt(r, e) {
  var t = {};
  for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}
function Fe(r, e, t, n) {
  function i(a) {
    return a instanceof t ? a : new t(function(s) {
      s(a);
    });
  }
  return new (t || (t = Promise))(function(a, s) {
    function o(f) {
      try {
        u(n.next(f));
      } catch (d) {
        s(d);
      }
    }
    function c(f) {
      try {
        u(n.throw(f));
      } catch (d) {
        s(d);
      }
    }
    function u(f) {
      f.done ? a(f.value) : i(f.value).then(o, c);
    }
    u((n = n.apply(r, [])).next());
  });
}
function Me(r, e) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, s;
  return s = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function o(u) {
    return function(f) {
      return c([u, f]);
    };
  }
  function c(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (a = u[0] & 2 ? i.return : u[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, u[1])).done) return a;
      switch (i = 0, a && (u = [u[0] & 2, a.value]), u[0]) {
        case 0:
        case 1:
          a = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!a || u[1] > a[0] && u[1] < a[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < a[1]) {
            t.label = a[1], a = u;
            break;
          }
          if (a && t.label < a[2]) {
            t.label = a[2], t.ops.push(u);
            break;
          }
          a[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = e.call(r, t);
    } catch (f) {
      u = [6, f], i = 0;
    } finally {
      n = a = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function ir(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, a; n < i; n++)
    (a || !(n in e)) && (a || (a = Array.prototype.slice.call(e, 0, n)), a[n] = e[n]);
  return r.concat(a || Array.prototype.slice.call(e));
}
function vr(r, e) {
  var t = r.directives;
  return !t || !t.length ? !0 : qs(t).every(function(n) {
    var i = n.directive, a = n.ifArgument, s = !1;
    return a.value.kind === "Variable" ? (s = e && e[a.value.name.value], __DEV__ ? E(s !== void 0, "Invalid variable referenced in @".concat(i.name.value, " directive.")) : E(s !== void 0, 39)) : s = a.value.value, i.name.value === "skip" ? !s : s;
  });
}
function bn(r, e, t) {
  var n = new Set(r), i = n.size;
  return Te(e, {
    Directive: function(a) {
      if (n.delete(a.name.value) && (!t || !n.size))
        return gn;
    }
  }), t ? !n.size : n.size < i;
}
function Vs(r) {
  return r && bn(["client", "export"], r, !0);
}
function Ls(r) {
  var e = r.name.value;
  return e === "skip" || e === "include";
}
function qs(r) {
  var e = [];
  return r && r.length && r.forEach(function(t) {
    if (Ls(t)) {
      var n = t.arguments, i = t.name.value;
      __DEV__ ? E(n && n.length === 1, "Incorrect number of arguments for the @".concat(i, " directive.")) : E(n && n.length === 1, 40);
      var a = n[0];
      __DEV__ ? E(a.name && a.name.value === "if", "Invalid argument for the @".concat(i, " directive.")) : E(a.name && a.name.value === "if", 41);
      var s = a.value;
      __DEV__ ? E(s && (s.kind === "Variable" || s.kind === "BooleanValue"), "Argument for the @".concat(i, " directive must be a variable or a boolean value.")) : E(s && (s.kind === "Variable" || s.kind === "BooleanValue"), 42), e.push({ directive: t, ifArgument: a });
    }
  }), e;
}
function Qs(r, e) {
  var t = e, n = [];
  r.definitions.forEach(function(a) {
    if (a.kind === "OperationDefinition")
      throw __DEV__ ? new B("Found a ".concat(a.operation, " operation").concat(a.name ? " named '".concat(a.name.value, "'") : "", ". ") + "No operations are allowed when using a fragment as a query. Only fragments are allowed.") : new B(43);
    a.kind === "FragmentDefinition" && n.push(a);
  }), typeof t > "u" && (__DEV__ ? E(n.length === 1, "Found ".concat(n.length, " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.")) : E(n.length === 1, 44), t = n[0].name.value);
  var i = y(y({}, r), { definitions: ir([
    {
      kind: "OperationDefinition",
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: t
            }
          }
        ]
      }
    }
  ], r.definitions, !0) });
  return i;
}
function _n(r) {
  r === void 0 && (r = []);
  var e = {};
  return r.forEach(function(t) {
    e[t.name.value] = t;
  }), e;
}
function wn(r, e) {
  switch (r.kind) {
    case "InlineFragment":
      return r;
    case "FragmentSpread": {
      var t = r.name.value;
      if (typeof e == "function")
        return e(t);
      var n = e && e[t];
      return __DEV__ ? E(n, "No fragment named ".concat(t)) : E(n, 45), n || null;
    }
    default:
      return null;
  }
}
function Y(r) {
  return r !== null && typeof r == "object";
}
function ot(r) {
  return { __ref: String(r) };
}
function U(r) {
  return !!(r && typeof r == "object" && typeof r.__ref == "string");
}
function Bs(r) {
  return Y(r) && r.kind === "Document" && Array.isArray(r.definitions);
}
function Zs(r) {
  return r.kind === "StringValue";
}
function Us(r) {
  return r.kind === "BooleanValue";
}
function zs(r) {
  return r.kind === "IntValue";
}
function $s(r) {
  return r.kind === "FloatValue";
}
function Ws(r) {
  return r.kind === "Variable";
}
function Gs(r) {
  return r.kind === "ObjectValue";
}
function Js(r) {
  return r.kind === "ListValue";
}
function Hs(r) {
  return r.kind === "EnumValue";
}
function Ys(r) {
  return r.kind === "NullValue";
}
function ft(r, e, t, n) {
  if (zs(t) || $s(t))
    r[e.value] = Number(t.value);
  else if (Us(t) || Zs(t))
    r[e.value] = t.value;
  else if (Gs(t)) {
    var i = {};
    t.fields.map(function(s) {
      return ft(i, s.name, s.value, n);
    }), r[e.value] = i;
  } else if (Ws(t)) {
    var a = (n || {})[t.name.value];
    r[e.value] = a;
  } else if (Js(t))
    r[e.value] = t.values.map(function(s) {
      var o = {};
      return ft(o, e, s, n), o[e.value];
    });
  else if (Hs(t))
    r[e.value] = t.value;
  else if (Ys(t))
    r[e.value] = null;
  else
    throw __DEV__ ? new B('The inline argument "'.concat(e.value, '" of kind "').concat(t.kind, '"') + "is not supported. Use variables instead of inline arguments to overcome this limitation.") : new B(54);
}
function Ks(r, e) {
  var t = null;
  r.directives && (t = {}, r.directives.forEach(function(i) {
    t[i.name.value] = {}, i.arguments && i.arguments.forEach(function(a) {
      var s = a.name, o = a.value;
      return ft(t[i.name.value], s, o, e);
    });
  }));
  var n = null;
  return r.arguments && r.arguments.length && (n = {}, r.arguments.forEach(function(i) {
    var a = i.name, s = i.value;
    return ft(n, a, s, e);
  })), kn(r.name.value, n, t);
}
var Xs = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export"
], kn = Object.assign(function(r, e, t) {
  if (e && t && t.connection && t.connection.key)
    if (t.connection.filter && t.connection.filter.length > 0) {
      var n = t.connection.filter ? t.connection.filter : [];
      n.sort();
      var i = {};
      return n.forEach(function(o) {
        i[o] = e[o];
      }), "".concat(t.connection.key, "(").concat(gt(i), ")");
    } else
      return t.connection.key;
  var a = r;
  if (e) {
    var s = gt(e);
    a += "(".concat(s, ")");
  }
  return t && Object.keys(t).forEach(function(o) {
    Xs.indexOf(o) === -1 && (t[o] && Object.keys(t[o]).length ? a += "@".concat(o, "(").concat(gt(t[o]), ")") : a += "@".concat(o));
  }), a;
}, {
  setStringify: function(r) {
    var e = gt;
    return gt = r, e;
  }
}), gt = function(e) {
  return JSON.stringify(e, eo);
};
function eo(r, e) {
  return Y(e) && !Array.isArray(e) && (e = Object.keys(e).sort().reduce(function(t, n) {
    return t[n] = e[n], t;
  }, {})), e;
}
function mr(r, e) {
  if (r.arguments && r.arguments.length) {
    var t = {};
    return r.arguments.forEach(function(n) {
      var i = n.name, a = n.value;
      return ft(t, i, a, e);
    }), t;
  }
  return null;
}
function Je(r) {
  return r.alias ? r.alias.value : r.name.value;
}
function $r(r, e, t) {
  if (typeof r.__typename == "string")
    return r.__typename;
  for (var n = 0, i = e.selections; n < i.length; n++) {
    var a = i[n];
    if (je(a)) {
      if (a.name.value === "__typename")
        return r[Je(a)];
    } else {
      var s = $r(r, wn(a, t).selectionSet, t);
      if (typeof s == "string")
        return s;
    }
  }
}
function je(r) {
  return r.kind === "Field";
}
function ea(r) {
  return r.kind === "InlineFragment";
}
function gr(r) {
  __DEV__ ? E(r && r.kind === "Document", 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql') : E(r && r.kind === "Document", 46);
  var e = r.definitions.filter(function(t) {
    return t.kind !== "FragmentDefinition";
  }).map(function(t) {
    if (t.kind !== "OperationDefinition")
      throw __DEV__ ? new B('Schema type definitions not allowed in queries. Found: "'.concat(t.kind, '"')) : new B(47);
    return t;
  });
  return __DEV__ ? E(e.length <= 1, "Ambiguous GraphQL document: contains ".concat(e.length, " operations")) : E(e.length <= 1, 48), r;
}
function zt(r) {
  return gr(r), r.definitions.filter(function(e) {
    return e.kind === "OperationDefinition";
  })[0];
}
function Wr(r) {
  return r.definitions.filter(function(e) {
    return e.kind === "OperationDefinition" && e.name;
  }).map(function(e) {
    return e.name.value;
  })[0] || null;
}
function En(r) {
  return r.definitions.filter(function(e) {
    return e.kind === "FragmentDefinition";
  });
}
function ta(r) {
  var e = zt(r);
  return __DEV__ ? E(e && e.operation === "query", "Must contain a query definition.") : E(e && e.operation === "query", 49), e;
}
function to(r) {
  __DEV__ ? E(r.kind === "Document", 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql') : E(r.kind === "Document", 50), __DEV__ ? E(r.definitions.length <= 1, "Fragment must have exactly one definition.") : E(r.definitions.length <= 1, 51);
  var e = r.definitions[0];
  return __DEV__ ? E(e.kind === "FragmentDefinition", "Must be a fragment definition.") : E(e.kind === "FragmentDefinition", 52), e;
}
function br(r) {
  gr(r);
  for (var e, t = 0, n = r.definitions; t < n.length; t++) {
    var i = n[t];
    if (i.kind === "OperationDefinition") {
      var a = i.operation;
      if (a === "query" || a === "mutation" || a === "subscription")
        return i;
    }
    i.kind === "FragmentDefinition" && !e && (e = i);
  }
  if (e)
    return e;
  throw __DEV__ ? new B("Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.") : new B(53);
}
function Sn(r) {
  var e = /* @__PURE__ */ Object.create(null), t = r && r.variableDefinitions;
  return t && t.length && t.forEach(function(n) {
    n.defaultValue && ft(e, n.variable.name, n.defaultValue);
  }), e;
}
function ti(r, e, t) {
  var n = 0;
  return r.forEach(function(i, a) {
    e.call(this, i, a, r) && (r[n++] = i);
  }, t), r.length = n, r;
}
var ri = {
  kind: "Field",
  name: {
    kind: "Name",
    value: "__typename"
  }
};
function ra(r, e) {
  return !r || r.selectionSet.selections.every(function(t) {
    return t.kind === "FragmentSpread" && ra(e[t.name.value], e);
  });
}
function On(r) {
  return ra(zt(r) || to(r), _n(En(r))) ? null : r;
}
function ni(r) {
  return function(t) {
    return r.some(function(n) {
      return n.name && n.name === t.name.value || n.test && n.test(t);
    });
  };
}
function na(r, e) {
  var t = /* @__PURE__ */ Object.create(null), n = [], i = /* @__PURE__ */ Object.create(null), a = [], s = On(Te(e, {
    Variable: {
      enter: function(o, c, u) {
        u.kind !== "VariableDefinition" && (t[o.name.value] = !0);
      }
    },
    Field: {
      enter: function(o) {
        if (r && o.directives) {
          var c = r.some(function(u) {
            return u.remove;
          });
          if (c && o.directives && o.directives.some(ni(r)))
            return o.arguments && o.arguments.forEach(function(u) {
              u.value.kind === "Variable" && n.push({
                name: u.value.name.value
              });
            }), o.selectionSet && ia(o.selectionSet).forEach(function(u) {
              a.push({
                name: u.name.value
              });
            }), null;
        }
      }
    },
    FragmentSpread: {
      enter: function(o) {
        i[o.name.value] = !0;
      }
    },
    Directive: {
      enter: function(o) {
        if (ni(r)(o))
          return null;
      }
    }
  }));
  return s && ti(n, function(o) {
    return !!o.name && !t[o.name];
  }).length && (s = ao(n, s)), s && ti(a, function(o) {
    return !!o.name && !i[o.name];
  }).length && (s = so(a, s)), s;
}
var xn = Object.assign(function(r) {
  return Te(r, {
    SelectionSet: {
      enter: function(e, t, n) {
        if (!(n && n.kind === "OperationDefinition")) {
          var i = e.selections;
          if (i) {
            var a = i.some(function(o) {
              return je(o) && (o.name.value === "__typename" || o.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!a) {
              var s = n;
              if (!(je(s) && s.directives && s.directives.some(function(o) {
                return o.name.value === "export";
              })))
                return y(y({}, e), { selections: ir(ir([], i, !0), [ri], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(r) {
    return r === ri;
  }
}), ro = {
  test: function(r) {
    var e = r.name.value === "connection";
    return e && (!r.arguments || !r.arguments.some(function(t) {
      return t.name.value === "key";
    })) && __DEV__ && E.warn("Removing an @connection directive even though it does not have a key. You may want to use the key parameter to specify a store key."), e;
  }
};
function no(r) {
  return na([ro], gr(r));
}
function io(r) {
  return function(t) {
    return r.some(function(n) {
      return t.value && t.value.kind === "Variable" && t.value.name && (n.name === t.value.name.value || n.test && n.test(t));
    });
  };
}
function ao(r, e) {
  var t = io(r);
  return On(Te(e, {
    OperationDefinition: {
      enter: function(n) {
        return y(y({}, n), { variableDefinitions: n.variableDefinitions ? n.variableDefinitions.filter(function(i) {
          return !r.some(function(a) {
            return a.name === i.variable.name.value;
          });
        }) : [] });
      }
    },
    Field: {
      enter: function(n) {
        var i = r.some(function(s) {
          return s.remove;
        });
        if (i) {
          var a = 0;
          if (n.arguments && n.arguments.forEach(function(s) {
            t(s) && (a += 1);
          }), a === 1)
            return null;
        }
      }
    },
    Argument: {
      enter: function(n) {
        if (t(n))
          return null;
      }
    }
  }));
}
function so(r, e) {
  function t(n) {
    if (r.some(function(i) {
      return i.name === n.name.value;
    }))
      return null;
  }
  return On(Te(e, {
    FragmentSpread: { enter: t },
    FragmentDefinition: { enter: t }
  }));
}
function ia(r) {
  var e = [];
  return r.selections.forEach(function(t) {
    (je(t) || ea(t)) && t.selectionSet ? ia(t.selectionSet).forEach(function(n) {
      return e.push(n);
    }) : t.kind === "FragmentSpread" && e.push(t);
  }), e;
}
function oo(r) {
  var e = br(r), t = e.operation;
  if (t === "query")
    return r;
  var n = Te(r, {
    OperationDefinition: {
      enter: function(i) {
        return y(y({}, i), { operation: "query" });
      }
    }
  });
  return n;
}
function uo(r) {
  gr(r);
  var e = na([
    {
      test: function(t) {
        return t.name.value === "client";
      },
      remove: !0
    }
  ], r);
  return e && (e = Te(e, {
    FragmentDefinition: {
      enter: function(t) {
        if (t.selectionSet) {
          var n = t.selectionSet.selections.every(function(i) {
            return je(i) && i.name.value === "__typename";
          });
          if (n)
            return null;
        }
      }
    }
  })), e;
}
var co = Object.prototype.hasOwnProperty;
function ii() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r[e] = arguments[e];
  return Tn(r);
}
function Tn(r) {
  var e = r[0] || {}, t = r.length;
  if (t > 1)
    for (var n = new He(), i = 1; i < t; ++i)
      e = n.merge(e, r[i]);
  return e;
}
var lo = function(r, e, t) {
  return this.merge(r[t], e[t]);
}, He = function() {
  function r(e) {
    e === void 0 && (e = lo), this.reconciler = e, this.isObject = Y, this.pastCopies = /* @__PURE__ */ new Set();
  }
  return r.prototype.merge = function(e, t) {
    for (var n = this, i = [], a = 2; a < arguments.length; a++)
      i[a - 2] = arguments[a];
    return Y(t) && Y(e) ? (Object.keys(t).forEach(function(s) {
      if (co.call(e, s)) {
        var o = e[s];
        if (t[s] !== o) {
          var c = n.reconciler.apply(n, ir([e, t, s], i, !1));
          c !== o && (e = n.shallowCopyForMerge(e), e[s] = c);
        }
      } else
        e = n.shallowCopyForMerge(e), e[s] = t[s];
    }), e) : t;
  }, r.prototype.shallowCopyForMerge = function(e) {
    return Y(e) && (this.pastCopies.has(e) || (Array.isArray(e) ? e = e.slice(0) : e = y({ __proto__: Object.getPrototypeOf(e) }, e), this.pastCopies.add(e))), e;
  }, r;
}();
function fo(r, e) {
  var t = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = ho(r)) || e) {
    t && (r = t);
    var n = 0;
    return function() {
      return n >= r.length ? { done: !0 } : { done: !1, value: r[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ho(r, e) {
  if (r) {
    if (typeof r == "string") return ai(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set") return Array.from(r);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return ai(r, e);
  }
}
function ai(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, n = new Array(e); t < e; t++)
    n[t] = r[t];
  return n;
}
function si(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, n.key, n);
  }
}
function Dn(r, e, t) {
  return e && si(r.prototype, e), t && si(r, t), Object.defineProperty(r, "prototype", { writable: !1 }), r;
}
var In = function() {
  return typeof Symbol == "function";
}, Rn = function(r) {
  return In() && !!Symbol[r];
}, jn = function(r) {
  return Rn(r) ? Symbol[r] : "@@" + r;
};
In() && !Rn("observable") && (Symbol.observable = Symbol("observable"));
var po = jn("iterator"), Gr = jn("observable"), aa = jn("species");
function ar(r, e) {
  var t = r[e];
  if (t != null) {
    if (typeof t != "function") throw new TypeError(t + " is not a function");
    return t;
  }
}
function bt(r) {
  var e = r.constructor;
  return e !== void 0 && (e = e[aa], e === null && (e = void 0)), e !== void 0 ? e : G;
}
function yo(r) {
  return r instanceof G;
}
function dt(r) {
  dt.log ? dt.log(r) : setTimeout(function() {
    throw r;
  });
}
function tr(r) {
  Promise.resolve().then(function() {
    try {
      r();
    } catch (e) {
      dt(e);
    }
  });
}
function sa(r) {
  var e = r._cleanup;
  if (e !== void 0 && (r._cleanup = void 0, !!e))
    try {
      if (typeof e == "function")
        e();
      else {
        var t = ar(e, "unsubscribe");
        t && t.call(e);
      }
    } catch (n) {
      dt(n);
    }
}
function Jr(r) {
  r._observer = void 0, r._queue = void 0, r._state = "closed";
}
function vo(r) {
  var e = r._queue;
  if (e) {
    r._queue = void 0, r._state = "ready";
    for (var t = 0; t < e.length && (oa(r, e[t].type, e[t].value), r._state !== "closed"); ++t)
      ;
  }
}
function oa(r, e, t) {
  r._state = "running";
  var n = r._observer;
  try {
    var i = ar(n, e);
    switch (e) {
      case "next":
        i && i.call(n, t);
        break;
      case "error":
        if (Jr(r), i) i.call(n, t);
        else throw t;
        break;
      case "complete":
        Jr(r), i && i.call(n);
        break;
    }
  } catch (a) {
    dt(a);
  }
  r._state === "closed" ? sa(r) : r._state === "running" && (r._state = "ready");
}
function Tr(r, e, t) {
  if (r._state !== "closed") {
    if (r._state === "buffering") {
      r._queue.push({
        type: e,
        value: t
      });
      return;
    }
    if (r._state !== "ready") {
      r._state = "buffering", r._queue = [{
        type: e,
        value: t
      }], tr(function() {
        return vo(r);
      });
      return;
    }
    oa(r, e, t);
  }
}
var mo = /* @__PURE__ */ function() {
  function r(t, n) {
    this._cleanup = void 0, this._observer = t, this._queue = void 0, this._state = "initializing";
    var i = new go(this);
    try {
      this._cleanup = n.call(void 0, i);
    } catch (a) {
      i.error(a);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var e = r.prototype;
  return e.unsubscribe = function() {
    this._state !== "closed" && (Jr(this), sa(this));
  }, Dn(r, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), r;
}(), go = /* @__PURE__ */ function() {
  function r(t) {
    this._subscription = t;
  }
  var e = r.prototype;
  return e.next = function(n) {
    Tr(this._subscription, "next", n);
  }, e.error = function(n) {
    Tr(this._subscription, "error", n);
  }, e.complete = function() {
    Tr(this._subscription, "complete");
  }, Dn(r, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), r;
}(), G = /* @__PURE__ */ function() {
  function r(t) {
    if (!(this instanceof r)) throw new TypeError("Observable cannot be called as a function");
    if (typeof t != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = t;
  }
  var e = r.prototype;
  return e.subscribe = function(n) {
    return (typeof n != "object" || n === null) && (n = {
      next: n,
      error: arguments[1],
      complete: arguments[2]
    }), new mo(n, this._subscriber);
  }, e.forEach = function(n) {
    var i = this;
    return new Promise(function(a, s) {
      if (typeof n != "function") {
        s(new TypeError(n + " is not a function"));
        return;
      }
      function o() {
        c.unsubscribe(), a();
      }
      var c = i.subscribe({
        next: function(u) {
          try {
            n(u, o);
          } catch (f) {
            s(f), c.unsubscribe();
          }
        },
        error: s,
        complete: a
      });
    });
  }, e.map = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = bt(this);
    return new a(function(s) {
      return i.subscribe({
        next: function(o) {
          try {
            o = n(o);
          } catch (c) {
            return s.error(c);
          }
          s.next(o);
        },
        error: function(o) {
          s.error(o);
        },
        complete: function() {
          s.complete();
        }
      });
    });
  }, e.filter = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = bt(this);
    return new a(function(s) {
      return i.subscribe({
        next: function(o) {
          try {
            if (!n(o)) return;
          } catch (c) {
            return s.error(c);
          }
          s.next(o);
        },
        error: function(o) {
          s.error(o);
        },
        complete: function() {
          s.complete();
        }
      });
    });
  }, e.reduce = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = bt(this), s = arguments.length > 1, o = !1, c = arguments[1], u = c;
    return new a(function(f) {
      return i.subscribe({
        next: function(d) {
          var h = !o;
          if (o = !0, !h || s)
            try {
              u = n(u, d);
            } catch (p) {
              return f.error(p);
            }
          else
            u = d;
        },
        error: function(d) {
          f.error(d);
        },
        complete: function() {
          if (!o && !s) return f.error(new TypeError("Cannot reduce an empty sequence"));
          f.next(u), f.complete();
        }
      });
    });
  }, e.concat = function() {
    for (var n = this, i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    var o = bt(this);
    return new o(function(c) {
      var u, f = 0;
      function d(h) {
        u = h.subscribe({
          next: function(p) {
            c.next(p);
          },
          error: function(p) {
            c.error(p);
          },
          complete: function() {
            f === a.length ? (u = void 0, c.complete()) : d(o.from(a[f++]));
          }
        });
      }
      return d(n), function() {
        u && (u.unsubscribe(), u = void 0);
      };
    });
  }, e.flatMap = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = bt(this);
    return new a(function(s) {
      var o = [], c = i.subscribe({
        next: function(f) {
          if (n)
            try {
              f = n(f);
            } catch (h) {
              return s.error(h);
            }
          var d = a.from(f).subscribe({
            next: function(h) {
              s.next(h);
            },
            error: function(h) {
              s.error(h);
            },
            complete: function() {
              var h = o.indexOf(d);
              h >= 0 && o.splice(h, 1), u();
            }
          });
          o.push(d);
        },
        error: function(f) {
          s.error(f);
        },
        complete: function() {
          u();
        }
      });
      function u() {
        c.closed && o.length === 0 && s.complete();
      }
      return function() {
        o.forEach(function(f) {
          return f.unsubscribe();
        }), c.unsubscribe();
      };
    });
  }, e[Gr] = function() {
    return this;
  }, r.from = function(n) {
    var i = typeof this == "function" ? this : r;
    if (n == null) throw new TypeError(n + " is not an object");
    var a = ar(n, Gr);
    if (a) {
      var s = a.call(n);
      if (Object(s) !== s) throw new TypeError(s + " is not an object");
      return yo(s) && s.constructor === i ? s : new i(function(o) {
        return s.subscribe(o);
      });
    }
    if (Rn("iterator") && (a = ar(n, po), a))
      return new i(function(o) {
        tr(function() {
          if (!o.closed) {
            for (var c = fo(a.call(n)), u; !(u = c()).done; ) {
              var f = u.value;
              if (o.next(f), o.closed) return;
            }
            o.complete();
          }
        });
      });
    if (Array.isArray(n))
      return new i(function(o) {
        tr(function() {
          if (!o.closed) {
            for (var c = 0; c < n.length; ++c)
              if (o.next(n[c]), o.closed) return;
            o.complete();
          }
        });
      });
    throw new TypeError(n + " is not observable");
  }, r.of = function() {
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    var s = typeof this == "function" ? this : r;
    return new s(function(o) {
      tr(function() {
        if (!o.closed) {
          for (var c = 0; c < i.length; ++c)
            if (o.next(i[c]), o.closed) return;
          o.complete();
        }
      });
    });
  }, Dn(r, null, [{
    key: aa,
    get: function() {
      return this;
    }
  }]), r;
}();
In() && Object.defineProperty(G, Symbol("extensions"), {
  value: {
    symbol: Gr,
    hostReportError: dt
  },
  configurable: !0
});
function bo(r) {
  var e, t = r.Symbol;
  if (typeof t == "function")
    if (t.observable)
      e = t.observable;
    else {
      typeof t.for == "function" ? e = t.for("https://github.com/benlesh/symbol-observable") : e = t("https://github.com/benlesh/symbol-observable");
      try {
        t.observable = e;
      } catch {
      }
    }
  else
    e = "@@observable";
  return e;
}
var rt;
typeof self < "u" ? rt = self : typeof window < "u" ? rt = window : typeof global < "u" ? rt = global : typeof module < "u" ? rt = module : rt = Function("return this")();
bo(rt);
var oi = G.prototype, ui = "@@observable";
oi[ui] || (oi[ui] = function() {
  return this;
});
var _o = Object.prototype.toString;
function Cn(r) {
  return Hr(r);
}
function Hr(r, e) {
  switch (_o.call(r)) {
    case "[object Array]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(r))
        return e.get(r);
      var t = r.slice(0);
      return e.set(r, t), t.forEach(function(i, a) {
        t[a] = Hr(i, e);
      }), t;
    }
    case "[object Object]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(r))
        return e.get(r);
      var n = Object.create(Object.getPrototypeOf(r));
      return e.set(r, n), Object.keys(r).forEach(function(i) {
        n[i] = Hr(r[i], e);
      }), n;
    }
    default:
      return r;
  }
}
function wo(r) {
  var e = /* @__PURE__ */ new Set([r]);
  return e.forEach(function(t) {
    Y(t) && ko(t) === t && Object.getOwnPropertyNames(t).forEach(function(n) {
      Y(t[n]) && e.add(t[n]);
    });
  }), r;
}
function ko(r) {
  if (__DEV__ && !Object.isFrozen(r))
    try {
      Object.freeze(r);
    } catch (e) {
      if (e instanceof TypeError)
        return null;
      throw e;
    }
  return r;
}
function Yr(r) {
  return __DEV__ && wo(r), r;
}
function xt(r, e, t) {
  var n = [];
  r.forEach(function(i) {
    return i[e] && n.push(i);
  }), n.forEach(function(i) {
    return i[e](t);
  });
}
function Dr(r, e, t) {
  return new G(function(n) {
    var i = n.next, a = n.error, s = n.complete, o = 0, c = !1, u = {
      then: function(p) {
        return new Promise(function(m) {
          return m(p());
        });
      }
    };
    function f(p, m) {
      return p ? function(v) {
        ++o;
        var b = function() {
          return p(v);
        };
        u = u.then(b, b).then(function(k) {
          --o, i && i.call(n, k), c && d.complete();
        }, function(k) {
          throw --o, k;
        }).catch(function(k) {
          a && a.call(n, k);
        });
      } : function(v) {
        return m && m.call(n, v);
      };
    }
    var d = {
      next: f(e, i),
      error: f(t, a),
      complete: function() {
        c = !0, o || s && s.call(n);
      }
    }, h = r.subscribe(d);
    return function() {
      return h.unsubscribe();
    };
  });
}
var et = typeof WeakMap == "function" && he(function() {
  return navigator.product;
}) !== "ReactNative", Eo = typeof WeakSet == "function", ua = typeof Symbol == "function" && typeof Symbol.for == "function", _r = ua && Symbol.asyncIterator;
he(function() {
  return window.document.createElement;
});
he(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function ca(r) {
  function e(t) {
    Object.defineProperty(r, t, { value: G });
  }
  return ua && Symbol.species && e(Symbol.species), e("@@species"), r;
}
function ci(r) {
  return r && typeof r.then == "function";
}
var Et = function(r) {
  be(e, r);
  function e(t) {
    var n = r.call(this, function(i) {
      return n.addObserver(i), function() {
        return n.removeObserver(i);
      };
    }) || this;
    return n.observers = /* @__PURE__ */ new Set(), n.promise = new Promise(function(i, a) {
      n.resolve = i, n.reject = a;
    }), n.handlers = {
      next: function(i) {
        n.sub !== null && (n.latest = ["next", i], n.notify("next", i), xt(n.observers, "next", i));
      },
      error: function(i) {
        var a = n.sub;
        a !== null && (a && setTimeout(function() {
          return a.unsubscribe();
        }), n.sub = null, n.latest = ["error", i], n.reject(i), n.notify("error", i), xt(n.observers, "error", i));
      },
      complete: function() {
        var i = n.sub;
        if (i !== null) {
          var a = n.sources.shift();
          a ? ci(a) ? a.then(function(s) {
            return n.sub = s.subscribe(n.handlers);
          }) : n.sub = a.subscribe(n.handlers) : (i && setTimeout(function() {
            return i.unsubscribe();
          }), n.sub = null, n.latest && n.latest[0] === "next" ? n.resolve(n.latest[1]) : n.resolve(), n.notify("complete"), xt(n.observers, "complete"));
        }
      }
    }, n.nextResultListeners = /* @__PURE__ */ new Set(), n.cancel = function(i) {
      n.reject(i), n.sources = [], n.handlers.complete();
    }, n.promise.catch(function(i) {
    }), typeof t == "function" && (t = [new G(t)]), ci(t) ? t.then(function(i) {
      return n.start(i);
    }, n.handlers.error) : n.start(t), n;
  }
  return e.prototype.start = function(t) {
    this.sub === void 0 && (this.sources = Array.from(t), this.handlers.complete());
  }, e.prototype.deliverLastMessage = function(t) {
    if (this.latest) {
      var n = this.latest[0], i = t[n];
      i && i.call(t, this.latest[1]), this.sub === null && n === "next" && t.complete && t.complete();
    }
  }, e.prototype.addObserver = function(t) {
    this.observers.has(t) || (this.deliverLastMessage(t), this.observers.add(t));
  }, e.prototype.removeObserver = function(t) {
    this.observers.delete(t) && this.observers.size < 1 && this.handlers.complete();
  }, e.prototype.notify = function(t, n) {
    var i = this.nextResultListeners;
    i.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), i.forEach(function(a) {
      return a(t, n);
    }));
  }, e.prototype.beforeNext = function(t) {
    var n = !1;
    this.nextResultListeners.add(function(i, a) {
      n || (n = !0, t(i, a));
    });
  }, e;
}(G);
ca(Et);
function Ee(r) {
  return Array.isArray(r) && r.length > 0;
}
function rr(r) {
  return r.errors && r.errors.length > 0 || !1;
}
function wr() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r[e] = arguments[e];
  var t = /* @__PURE__ */ Object.create(null);
  return r.forEach(function(n) {
    n && Object.keys(n).forEach(function(i) {
      var a = n[i];
      a !== void 0 && (t[i] = a);
    });
  }), t;
}
var li = /* @__PURE__ */ new Map();
function Kr(r) {
  var e = li.get(r) || 1;
  return li.set(r, e + 1), "".concat(r, ":").concat(e, ":").concat(Math.random().toString(36).slice(2));
}
function So(r) {
  var e = Kr("stringifyForDisplay");
  return JSON.stringify(r, function(t, n) {
    return n === void 0 ? e : n;
  }).split(JSON.stringify(e)).join("<undefined>");
}
function Ir(r, e) {
  return wr(r, e, e.variables && {
    variables: y(y({}, r && r.variables), e.variables)
  });
}
function fi(r) {
  return new G(function(e) {
    e.error(r);
  });
}
var Xr = function(r, e, t) {
  var n = new Error(t);
  throw n.name = "ServerError", n.response = r, n.statusCode = r.status, n.result = e, n;
};
function Oo(r) {
  for (var e = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], t = 0, n = Object.keys(r); t < n.length; t++) {
    var i = n[t];
    if (e.indexOf(i) < 0)
      throw __DEV__ ? new B("illegal argument: ".concat(i)) : new B(26);
  }
  return r;
}
function xo(r, e) {
  var t = y({}, r), n = function(a) {
    typeof a == "function" ? t = y(y({}, t), a(t)) : t = y(y({}, t), a);
  }, i = function() {
    return y({}, t);
  };
  return Object.defineProperty(e, "setContext", {
    enumerable: !1,
    value: n
  }), Object.defineProperty(e, "getContext", {
    enumerable: !1,
    value: i
  }), e;
}
function To(r) {
  var e = {
    variables: r.variables || {},
    extensions: r.extensions || {},
    operationName: r.operationName,
    query: r.query
  };
  return e.operationName || (e.operationName = typeof e.query != "string" ? Wr(e.query) || void 0 : ""), e;
}
function di(r, e) {
  return e ? e(r) : G.of();
}
function _t(r) {
  return typeof r == "function" ? new Ue(r) : r;
}
function Yt(r) {
  return r.request.length <= 1;
}
var Do = function(r) {
  be(e, r);
  function e(t, n) {
    var i = r.call(this, t) || this;
    return i.link = n, i;
  }
  return e;
}(Error), Ue = function() {
  function r(e) {
    e && (this.request = e);
  }
  return r.empty = function() {
    return new r(function() {
      return G.of();
    });
  }, r.from = function(e) {
    return e.length === 0 ? r.empty() : e.map(_t).reduce(function(t, n) {
      return t.concat(n);
    });
  }, r.split = function(e, t, n) {
    var i = _t(t), a = _t(n || new r(di));
    return Yt(i) && Yt(a) ? new r(function(s) {
      return e(s) ? i.request(s) || G.of() : a.request(s) || G.of();
    }) : new r(function(s, o) {
      return e(s) ? i.request(s, o) || G.of() : a.request(s, o) || G.of();
    });
  }, r.execute = function(e, t) {
    return e.request(xo(t.context, To(Oo(t)))) || G.of();
  }, r.concat = function(e, t) {
    var n = _t(e);
    if (Yt(n))
      return __DEV__ && E.warn(new Do("You are calling concat on a terminating link, which will have no effect", n)), n;
    var i = _t(t);
    return Yt(i) ? new r(function(a) {
      return n.request(a, function(s) {
        return i.request(s) || G.of();
      }) || G.of();
    }) : new r(function(a, s) {
      return n.request(a, function(o) {
        return i.request(o, s) || G.of();
      }) || G.of();
    });
  }, r.prototype.split = function(e, t, n) {
    return this.concat(r.split(e, t, n || new r(di)));
  }, r.prototype.concat = function(e) {
    return r.concat(this, e);
  }, r.prototype.request = function(e, t) {
    throw __DEV__ ? new B("request is not implemented") : new B(21);
  }, r.prototype.onError = function(e, t) {
    if (t && t.error)
      return t.error(e), !1;
    throw e;
  }, r.prototype.setOnError = function(e) {
    return this.onError = e, this;
  }, r;
}(), Io = Ue.from, Ro = Ue.split, en = Ue.execute, jo = "3.7.0";
function Co(r) {
  return !!r.body;
}
function Ao(r) {
  return !!r.getReader;
}
function No(r) {
  return !!(_r && r[Symbol.asyncIterator]);
}
function Po(r) {
  return !!r.stream;
}
function Fo(r) {
  return !!r.arrayBuffer;
}
function Mo(r) {
  return !!r.pipe;
}
function Vo(r) {
  var e, t = r[Symbol.asyncIterator]();
  return e = {
    next: function() {
      return t.next();
    }
  }, e[Symbol.asyncIterator] = function() {
    return this;
  }, e;
}
function Lo(r) {
  var e = null, t = null, n = !1, i = [], a = [];
  function s(d) {
    if (!t) {
      if (a.length) {
        var h = a.shift();
        if (Array.isArray(h) && h[0])
          return h[0]({ value: d, done: !1 });
      }
      i.push(d);
    }
  }
  function o(d) {
    t = d;
    var h = a.slice();
    h.forEach(function(p) {
      p[1](d);
    }), !e || e();
  }
  function c() {
    n = !0;
    var d = a.slice();
    d.forEach(function(h) {
      h[0]({ value: void 0, done: !0 });
    }), !e || e();
  }
  e = function() {
    e = null, r.removeListener("data", s), r.removeListener("error", o), r.removeListener("end", c), r.removeListener("finish", c), r.removeListener("close", c);
  }, r.on("data", s), r.on("error", o), r.on("end", c), r.on("finish", c), r.on("close", c);
  function u() {
    return new Promise(function(d, h) {
      if (t)
        return h(t);
      if (i.length)
        return d({ value: i.shift(), done: !1 });
      if (n)
        return d({ value: void 0, done: !0 });
      a.push([d, h]);
    });
  }
  var f = {
    next: function() {
      return u();
    }
  };
  return _r && (f[Symbol.asyncIterator] = function() {
    return this;
  }), f;
}
function qo(r) {
  var e = !1, t = {
    next: function() {
      return e ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (e = !0, new Promise(function(n, i) {
        r.then(function(a) {
          n({ value: a, done: !1 });
        }).catch(i);
      }));
    }
  };
  return _r && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function hi(r) {
  var e = {
    next: function() {
      return r.read();
    }
  };
  return _r && (e[Symbol.asyncIterator] = function() {
    return this;
  }), e;
}
function Qo(r) {
  var e = r;
  if (Co(r) && (e = r.body), No(e))
    return Vo(e);
  if (Ao(e))
    return hi(e.getReader());
  if (Po(e))
    return hi(e.stream().getReader());
  if (Fo(e))
    return qo(e.arrayBuffer());
  if (Mo(e))
    return Lo(e);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var pi = Object.prototype.hasOwnProperty;
function Bo(r, e) {
  var t, n, i;
  return Fe(this, void 0, void 0, function() {
    var a, s, o, c, u, f, d, h, p, m, v, b, k, I, _, S, N, j, D, R;
    return Me(this, function(z) {
      switch (z.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          a = new TextDecoder("utf-8"), s = (t = r.headers) === null || t === void 0 ? void 0 : t.get("content-type"), o = "boundary=", c = s != null && s.includes(o) ? s == null ? void 0 : s.substring((s == null ? void 0 : s.indexOf(o)) + o.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", u = "--".concat(c), f = "", d = Qo(r), h = !0, z.label = 1;
        case 1:
          return h ? [4, d.next()] : [3, 3];
        case 2:
          for (p = z.sent(), m = p.value, v = p.done, b = typeof m == "string" ? m : a.decode(m), h = !v, f += b, k = f.indexOf(u); k > -1; ) {
            if (I = void 0, R = [
              f.slice(0, k),
              f.slice(k + u.length)
            ], I = R[0], f = R[1], I.trim()) {
              if (_ = I.indexOf(`\r
\r
`), S = Zo(I.slice(0, _)), N = S["content-type"], N && N.toLowerCase().indexOf("application/json") === -1)
                throw new Error("Unsupported patch content type: application/json is required.");
              j = I.slice(_);
              try {
                D = la(r, j.replace(`\r
`, "")), (Object.keys(D).length > 1 || "data" in D || "incremental" in D || "errors" in D) && ((n = e.next) === null || n === void 0 || n.call(e, D));
              } catch (Z) {
                An(Z, e);
              }
            }
            k = f.indexOf(u);
          }
          return [3, 1];
        case 3:
          return (i = e.complete) === null || i === void 0 || i.call(e), [2];
      }
    });
  });
}
function Zo(r) {
  var e = {};
  return r.split(`
`).forEach(function(t) {
    var n = t.indexOf(":");
    if (n > -1) {
      var i = t.slice(0, n).trim().toLowerCase(), a = t.slice(n + 1).trim();
      e[i] = a;
    }
  }), e;
}
function la(r, e) {
  if (r.status >= 300) {
    var t = function() {
      try {
        return JSON.parse(e);
      } catch {
        return e;
      }
    };
    Xr(r, t(), "Response not successful: Received status code ".concat(r.status));
  }
  try {
    return JSON.parse(e);
  } catch (i) {
    var n = i;
    throw n.name = "ServerParseError", n.response = r, n.statusCode = r.status, n.bodyText = e, n;
  }
}
function An(r, e) {
  var t, n;
  r.name !== "AbortError" && (r.result && r.result.errors && r.result.data && ((t = e.next) === null || t === void 0 || t.call(e, r.result)), (n = e.error) === null || n === void 0 || n.call(e, r));
}
function Uo(r, e, t) {
  zo(e)(r).then(function(n) {
    var i, a;
    (i = t.next) === null || i === void 0 || i.call(t, n), (a = t.complete) === null || a === void 0 || a.call(t);
  }).catch(function(n) {
    return An(n, t);
  });
}
function zo(r) {
  return function(e) {
    return e.text().then(function(t) {
      return la(e, t);
    }).then(function(t) {
      return e.status >= 300 && Xr(e, t, "Response not successful: Received status code ".concat(e.status)), !Array.isArray(t) && !pi.call(t, "data") && !pi.call(t, "errors") && Xr(e, t, "Server response was missing for query '".concat(Array.isArray(r) ? r.map(function(n) {
        return n.operationName;
      }) : r.operationName, "'.")), t;
    });
  };
}
var tn = function(r, e) {
  var t;
  try {
    t = JSON.stringify(r);
  } catch (i) {
    var n = __DEV__ ? new B("Network request failed. ".concat(e, " is not serializable: ").concat(i.message)) : new B(23);
    throw n.parseError = i, n;
  }
  return t;
}, $o = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, Wo = {
  accept: "*/*",
  "content-type": "application/json"
}, Go = {
  method: "POST"
}, Jo = {
  http: $o,
  headers: Wo,
  options: Go
}, Ho = function(r, e) {
  return e(r);
};
function Yo(r, e) {
  for (var t = [], n = 2; n < arguments.length; n++)
    t[n - 2] = arguments[n];
  var i = {}, a = {};
  t.forEach(function(d) {
    i = y(y(y({}, i), d.options), { headers: y(y({}, i.headers), d.headers) }), d.credentials && (i.credentials = d.credentials), a = y(y({}, a), d.http);
  }), i.headers = Ko(i.headers, a.preserveHeaderCase);
  var s = r.operationName, o = r.extensions, c = r.variables, u = r.query, f = { operationName: s, variables: c };
  return a.includeExtensions && (f.extensions = o), a.includeQuery && (f.query = e(u, Xi)), {
    options: i,
    body: f
  };
}
function Ko(r, e) {
  if (!e) {
    var t = /* @__PURE__ */ Object.create(null);
    return Object.keys(Object(r)).forEach(function(a) {
      t[a.toLowerCase()] = r[a];
    }), t;
  }
  var n = /* @__PURE__ */ Object.create(null);
  Object.keys(Object(r)).forEach(function(a) {
    n[a.toLowerCase()] = { originalName: a, value: r[a] };
  });
  var i = /* @__PURE__ */ Object.create(null);
  return Object.keys(n).forEach(function(a) {
    i[n[a].originalName] = n[a].value;
  }), i;
}
var Xo = function(r) {
  if (!r && typeof fetch > "u")
    throw __DEV__ ? new B(`
"fetch" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:

import fetch from 'cross-fetch';
import { ApolloClient, HttpLink } from '@apollo/client';
const client = new ApolloClient({
  link: new HttpLink({ uri: '/graphql', fetch })
});
    `) : new B(22);
}, eu = function() {
  if (typeof AbortController > "u")
    return { controller: !1, signal: !1 };
  var r = new AbortController(), e = r.signal;
  return { controller: r, signal: e };
}, tu = function(r, e) {
  var t = r.getContext(), n = t.uri;
  return n || (typeof e == "function" ? e(r) : e || "/graphql");
};
function ru(r, e) {
  var t = [], n = function(d, h) {
    t.push("".concat(d, "=").concat(encodeURIComponent(h)));
  };
  if ("query" in e && n("query", e.query), e.operationName && n("operationName", e.operationName), e.variables) {
    var i = void 0;
    try {
      i = tn(e.variables, "Variables map");
    } catch (d) {
      return { parseError: d };
    }
    n("variables", i);
  }
  if (e.extensions) {
    var a = void 0;
    try {
      a = tn(e.extensions, "Extensions map");
    } catch (d) {
      return { parseError: d };
    }
    n("extensions", a);
  }
  var s = "", o = r, c = r.indexOf("#");
  c !== -1 && (s = r.substr(c), o = r.substr(0, c));
  var u = o.indexOf("?") === -1 ? "?" : "&", f = o + u + t.join("&") + s;
  return { newURI: f };
}
var yi = he(function() {
  return fetch;
}), nu = function(r) {
  r === void 0 && (r = {});
  var e = r.uri, t = e === void 0 ? "/graphql" : e, n = r.fetch, i = r.print, a = i === void 0 ? Ho : i, s = r.includeExtensions, o = r.preserveHeaderCase, c = r.useGETForQueries, u = r.includeUnusedVariables, f = u === void 0 ? !1 : u, d = lt(r, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  __DEV__ && Xo(n || yi);
  var h = {
    http: { includeExtensions: s, preserveHeaderCase: o },
    options: d.fetchOptions,
    credentials: d.credentials,
    headers: d.headers
  };
  return new Ue(function(p) {
    var m = tu(p, t), v = p.getContext(), b = {};
    if (v.clientAwareness) {
      var k = v.clientAwareness, I = k.name, _ = k.version;
      I && (b["apollographql-client-name"] = I), _ && (b["apollographql-client-version"] = _);
    }
    var S = y(y({}, b), v.headers), N = {
      http: v.http,
      options: v.fetchOptions,
      credentials: v.credentials,
      headers: S
    }, j = Yo(p, a, Jo, h, N), D = j.options, R = j.body;
    if (R.variables && !f) {
      var z = new Set(Object.keys(R.variables));
      Te(p.query, {
        Variable: function(q, we, V) {
          V && V.kind !== "VariableDefinition" && z.delete(q.name.value);
        }
      }), z.size && (R.variables = y({}, R.variables), z.forEach(function(q) {
        delete R.variables[q];
      }));
    }
    var Z;
    if (!D.signal) {
      var _e = eu(), De = _e.controller, ue = _e.signal;
      Z = De, Z && (D.signal = ue);
    }
    var F = function(q) {
      return q.kind === "OperationDefinition" && q.operation === "mutation";
    };
    if (c && !p.query.definitions.some(F) && (D.method = "GET"), bn(["defer"], p.query) && (D.headers.accept = "multipart/mixed; deferSpec=20220824, application/json"), D.method === "GET") {
      var K = ru(m, R), $ = K.newURI, L = K.parseError;
      if (L)
        return fi(L);
      m = $;
    } else
      try {
        D.body = tn(R, "Payload");
      } catch (q) {
        return fi(q);
      }
    return new G(function(q) {
      var we = n || he(function() {
        return fetch;
      }) || yi;
      return we(m, D).then(function(V) {
        var ke;
        p.setContext({ response: V });
        var Ae = (ke = V.headers) === null || ke === void 0 ? void 0 : ke.get("content-type");
        return Ae !== null && /^multipart\/mixed/i.test(Ae) ? Bo(V, q) : Uo(V, p, q);
      }).catch(function(V) {
        return An(V, q);
      }), function() {
        Z && Z.abort();
      };
    });
  });
}, fa = function(r) {
  be(e, r);
  function e(t) {
    t === void 0 && (t = {});
    var n = r.call(this, nu(t).request) || this;
    return n.options = t, n;
  }
  return e;
}(Ue), da = Object.prototype, vi = da.toString, iu = da.hasOwnProperty, mi = Function.prototype.toString, rn = /* @__PURE__ */ new Map();
function re(r, e) {
  try {
    return nn(r, e);
  } finally {
    rn.clear();
  }
}
function nn(r, e) {
  if (r === e)
    return !0;
  var t = vi.call(r), n = vi.call(e);
  if (t !== n)
    return !1;
  switch (t) {
    case "[object Array]":
      if (r.length !== e.length)
        return !1;
    // Fall through to object case...
    case "[object Object]": {
      if (bi(r, e))
        return !0;
      var i = gi(r), a = gi(e), s = i.length;
      if (s !== a.length)
        return !1;
      for (var o = 0; o < s; ++o)
        if (!iu.call(e, i[o]))
          return !1;
      for (var o = 0; o < s; ++o) {
        var c = i[o];
        if (!nn(r[c], e[c]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return r.name === e.name && r.message === e.message;
    case "[object Number]":
      if (r !== r)
        return e !== e;
    // Fall through to shared +a === +b case...
    case "[object Boolean]":
    case "[object Date]":
      return +r == +e;
    case "[object RegExp]":
    case "[object String]":
      return r == "" + e;
    case "[object Map]":
    case "[object Set]": {
      if (r.size !== e.size)
        return !1;
      if (bi(r, e))
        return !0;
      for (var u = r.entries(), f = t === "[object Map]"; ; ) {
        var d = u.next();
        if (d.done)
          break;
        var h = d.value, p = h[0], m = h[1];
        if (!e.has(p) || f && !nn(m, e.get(p)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    // Buffer, in Node.js.
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      r = new Uint8Array(r), e = new Uint8Array(e);
    // Fall through...
    case "[object DataView]": {
      var v = r.byteLength;
      if (v === e.byteLength)
        for (; v-- && r[v] === e[v]; )
          ;
      return v === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      var b = mi.call(r);
      return b !== mi.call(e) ? !1 : !ou(b, su);
    }
  }
  return !1;
}
function gi(r) {
  return Object.keys(r).filter(au, r);
}
function au(r) {
  return this[r] !== void 0;
}
var su = "{ [native code] }";
function ou(r, e) {
  var t = r.length - e.length;
  return t >= 0 && r.indexOf(e, t) === t;
}
function bi(r, e) {
  var t = rn.get(r);
  if (t) {
    if (t.has(e))
      return !0;
  } else
    rn.set(r, t = /* @__PURE__ */ new Set());
  return t.add(e), !1;
}
function uu(r) {
  return !!r.incremental;
}
var cu = function() {
  return /* @__PURE__ */ Object.create(null);
}, ha = Array.prototype, lu = ha.forEach, fu = ha.slice, $t = (
  /** @class */
  function() {
    function r(e, t) {
      e === void 0 && (e = !0), t === void 0 && (t = cu), this.weakness = e, this.makeData = t;
    }
    return r.prototype.lookup = function() {
      for (var e = [], t = 0; t < arguments.length; t++)
        e[t] = arguments[t];
      return this.lookupArray(e);
    }, r.prototype.lookupArray = function(e) {
      var t = this;
      return lu.call(e, function(n) {
        return t = t.getChildTrie(n);
      }), t.data || (t.data = this.makeData(fu.call(e)));
    }, r.prototype.getChildTrie = function(e) {
      var t = this.weakness && du(e) ? this.weak || (this.weak = /* @__PURE__ */ new WeakMap()) : this.strong || (this.strong = /* @__PURE__ */ new Map()), n = t.get(e);
      return n || t.set(e, n = new r(this.weakness, this.makeData)), n;
    }, r;
  }()
);
function du(r) {
  switch (typeof r) {
    case "object":
      if (r === null)
        break;
    // Fall through to return true...
    case "function":
      return !0;
  }
  return !1;
}
var ae = null, _i = {}, hu = 1, pu = function() {
  return (
    /** @class */
    function() {
      function r() {
        this.id = [
          "slot",
          hu++,
          Date.now(),
          Math.random().toString(36).slice(2)
        ].join(":");
      }
      return r.prototype.hasValue = function() {
        for (var e = ae; e; e = e.parent)
          if (this.id in e.slots) {
            var t = e.slots[this.id];
            if (t === _i)
              break;
            return e !== ae && (ae.slots[this.id] = t), !0;
          }
        return ae && (ae.slots[this.id] = _i), !1;
      }, r.prototype.getValue = function() {
        if (this.hasValue())
          return ae.slots[this.id];
      }, r.prototype.withValue = function(e, t, n, i) {
        var a, s = (a = {
          __proto__: null
        }, a[this.id] = e, a), o = ae;
        ae = { parent: o, slots: s };
        try {
          return t.apply(i, n);
        } finally {
          ae = o;
        }
      }, r.bind = function(e) {
        var t = ae;
        return function() {
          var n = ae;
          try {
            return ae = t, e.apply(this, arguments);
          } finally {
            ae = n;
          }
        };
      }, r.noContext = function(e, t, n) {
        if (ae) {
          var i = ae;
          try {
            return ae = null, e.apply(n, t);
          } finally {
            ae = i;
          }
        } else
          return e.apply(n, t);
      }, r;
    }()
  );
}, Rr = "@wry/context:Slot", jr = Array, Nn = jr[Rr] || function() {
  var r = pu();
  try {
    Object.defineProperty(jr, Rr, {
      value: jr[Rr] = r,
      enumerable: !1,
      writable: !1,
      configurable: !1
    });
  } finally {
    return r;
  }
}();
Nn.bind;
Nn.noContext;
function yu() {
}
var vu = (
  /** @class */
  function() {
    function r(e, t) {
      e === void 0 && (e = 1 / 0), t === void 0 && (t = yu), this.max = e, this.dispose = t, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
    }
    return r.prototype.has = function(e) {
      return this.map.has(e);
    }, r.prototype.get = function(e) {
      var t = this.getNode(e);
      return t && t.value;
    }, r.prototype.getNode = function(e) {
      var t = this.map.get(e);
      if (t && t !== this.newest) {
        var n = t.older, i = t.newer;
        i && (i.older = n), n && (n.newer = i), t.older = this.newest, t.older.newer = t, t.newer = null, this.newest = t, t === this.oldest && (this.oldest = i);
      }
      return t;
    }, r.prototype.set = function(e, t) {
      var n = this.getNode(e);
      return n ? n.value = t : (n = {
        key: e,
        value: t,
        newer: null,
        older: this.newest
      }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.map.set(e, n), n.value);
    }, r.prototype.clean = function() {
      for (; this.oldest && this.map.size > this.max; )
        this.delete(this.oldest.key);
    }, r.prototype.delete = function(e) {
      var t = this.map.get(e);
      return t ? (t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.map.delete(e), this.dispose(t.value, e), !0) : !1;
    }, r;
  }()
), kr = new Nn(), Cr, mu = Object.prototype.hasOwnProperty, Pn = (Cr = Array.from, Cr === void 0 ? function(r) {
  var e = [];
  return r.forEach(function(t) {
    return e.push(t);
  }), e;
} : Cr);
function Fn(r) {
  var e = r.unsubscribe;
  typeof e == "function" && (r.unsubscribe = void 0, e());
}
var It = [], gu = 100;
function ht(r, e) {
  if (!r)
    throw new Error(e || "assertion failure");
}
function bu(r, e) {
  var t = r.length;
  return (
    // Unknown values are not equal to each other.
    t > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    t === e.length && // The underlying value or exception must be the same.
    r[t - 1] === e[t - 1]
  );
}
function pa(r) {
  switch (r.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return r[0];
    case 2:
      throw r[1];
  }
}
function _u(r) {
  return r.slice(0);
}
var wu = (
  /** @class */
  function() {
    function r(e) {
      this.fn = e, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++r.count;
    }
    return r.prototype.peek = function() {
      if (this.value.length === 1 && !Ve(this))
        return wi(this), this.value[0];
    }, r.prototype.recompute = function(e) {
      return ht(!this.recomputing, "already recomputing"), wi(this), Ve(this) ? ku(this, e) : pa(this.value);
    }, r.prototype.setDirty = function() {
      this.dirty || (this.dirty = !0, this.value.length = 0, ya(this), Fn(this));
    }, r.prototype.dispose = function() {
      var e = this;
      this.setDirty(), _a(this), Mn(this, function(t, n) {
        t.setDirty(), wa(t, e);
      });
    }, r.prototype.forget = function() {
      this.dispose();
    }, r.prototype.dependOn = function(e) {
      e.add(this), this.deps || (this.deps = It.pop() || /* @__PURE__ */ new Set()), this.deps.add(e);
    }, r.prototype.forgetDeps = function() {
      var e = this;
      this.deps && (Pn(this.deps).forEach(function(t) {
        return t.delete(e);
      }), this.deps.clear(), It.push(this.deps), this.deps = null);
    }, r.count = 0, r;
  }()
);
function wi(r) {
  var e = kr.getValue();
  if (e)
    return r.parents.add(e), e.childValues.has(r) || e.childValues.set(r, []), Ve(r) ? ma(e, r) : ga(e, r), e;
}
function ku(r, e) {
  return _a(r), kr.withValue(r, Eu, [r, e]), Ou(r, e) && Su(r), pa(r.value);
}
function Eu(r, e) {
  r.recomputing = !0, r.value.length = 0;
  try {
    r.value[0] = r.fn.apply(null, e);
  } catch (t) {
    r.value[1] = t;
  }
  r.recomputing = !1;
}
function Ve(r) {
  return r.dirty || !!(r.dirtyChildren && r.dirtyChildren.size);
}
function Su(r) {
  r.dirty = !1, !Ve(r) && va(r);
}
function ya(r) {
  Mn(r, ma);
}
function va(r) {
  Mn(r, ga);
}
function Mn(r, e) {
  var t = r.parents.size;
  if (t)
    for (var n = Pn(r.parents), i = 0; i < t; ++i)
      e(n[i], r);
}
function ma(r, e) {
  ht(r.childValues.has(e)), ht(Ve(e));
  var t = !Ve(r);
  if (!r.dirtyChildren)
    r.dirtyChildren = It.pop() || /* @__PURE__ */ new Set();
  else if (r.dirtyChildren.has(e))
    return;
  r.dirtyChildren.add(e), t && ya(r);
}
function ga(r, e) {
  ht(r.childValues.has(e)), ht(!Ve(e));
  var t = r.childValues.get(e);
  t.length === 0 ? r.childValues.set(e, _u(e.value)) : bu(t, e.value) || r.setDirty(), ba(r, e), !Ve(r) && va(r);
}
function ba(r, e) {
  var t = r.dirtyChildren;
  t && (t.delete(e), t.size === 0 && (It.length < gu && It.push(t), r.dirtyChildren = null));
}
function _a(r) {
  r.childValues.size > 0 && r.childValues.forEach(function(e, t) {
    wa(r, t);
  }), r.forgetDeps(), ht(r.dirtyChildren === null);
}
function wa(r, e) {
  e.parents.delete(r), r.childValues.delete(e), ba(r, e);
}
function Ou(r, e) {
  if (typeof r.subscribe == "function")
    try {
      Fn(r), r.unsubscribe = r.subscribe.apply(null, e);
    } catch {
      return r.setDirty(), !1;
    }
  return !0;
}
var xu = {
  setDirty: !0,
  dispose: !0,
  forget: !0
};
function ka(r) {
  var e = /* @__PURE__ */ new Map();
  function t(n) {
    var i = kr.getValue();
    if (i) {
      var a = e.get(n);
      a || e.set(n, a = /* @__PURE__ */ new Set()), i.dependOn(a);
    }
  }
  return t.dirty = function(i, a) {
    var s = e.get(i);
    if (s) {
      var o = a && mu.call(xu, a) ? a : "setDirty";
      Pn(s).forEach(function(c) {
        return c[o]();
      }), e.delete(i), Fn(s);
    }
  }, t;
}
function Ea() {
  var r = new $t(typeof WeakMap == "function");
  return function() {
    return r.lookupArray(arguments);
  };
}
Ea();
var Ar = /* @__PURE__ */ new Set();
function sr(r, e) {
  e === void 0 && (e = /* @__PURE__ */ Object.create(null));
  var t = new vu(e.max || Math.pow(2, 16), function(u) {
    return u.dispose();
  }), n = e.keyArgs, i = e.makeCacheKey || Ea(), a = function() {
    var u = i.apply(null, n ? n.apply(null, arguments) : arguments);
    if (u === void 0)
      return r.apply(null, arguments);
    var f = t.get(u);
    f || (t.set(u, f = new wu(r)), f.subscribe = e.subscribe, f.forget = function() {
      return t.delete(u);
    });
    var d = f.recompute(Array.prototype.slice.call(arguments));
    return t.set(u, f), Ar.add(t), kr.hasValue() || (Ar.forEach(function(h) {
      return h.clean();
    }), Ar.clear()), d;
  };
  Object.defineProperty(a, "size", {
    get: function() {
      return t.map.size;
    },
    configurable: !1,
    enumerable: !1
  });
  function s(u) {
    var f = t.get(u);
    f && f.setDirty();
  }
  a.dirtyKey = s, a.dirty = function() {
    s(i.apply(null, arguments));
  };
  function o(u) {
    var f = t.get(u);
    if (f)
      return f.peek();
  }
  a.peekKey = o, a.peek = function() {
    return o(i.apply(null, arguments));
  };
  function c(u) {
    return t.delete(u);
  }
  return a.forgetKey = c, a.forget = function() {
    return c(i.apply(null, arguments));
  }, a.makeCacheKey = i, a.getKey = n ? function() {
    return i.apply(null, n.apply(null, arguments));
  } : i, Object.freeze(a);
}
var Tu = function() {
  function r() {
    this.getFragmentDoc = sr(Qs);
  }
  return r.prototype.batch = function(e) {
    var t = this, n = typeof e.optimistic == "string" ? e.optimistic : e.optimistic === !1 ? null : void 0, i;
    return this.performTransaction(function() {
      return i = e.update(t);
    }, n), i;
  }, r.prototype.recordOptimisticTransaction = function(e, t) {
    this.performTransaction(e, t);
  }, r.prototype.transformDocument = function(e) {
    return e;
  }, r.prototype.transformForLink = function(e) {
    return e;
  }, r.prototype.identify = function(e) {
  }, r.prototype.gc = function() {
    return [];
  }, r.prototype.modify = function(e) {
    return !1;
  }, r.prototype.readQuery = function(e, t) {
    return t === void 0 && (t = !!e.optimistic), this.read(y(y({}, e), { rootId: e.id || "ROOT_QUERY", optimistic: t }));
  }, r.prototype.readFragment = function(e, t) {
    return t === void 0 && (t = !!e.optimistic), this.read(y(y({}, e), { query: this.getFragmentDoc(e.fragment, e.fragmentName), rootId: e.id, optimistic: t }));
  }, r.prototype.writeQuery = function(e) {
    var t = e.id, n = e.data, i = lt(e, ["id", "data"]);
    return this.write(Object.assign(i, {
      dataId: t || "ROOT_QUERY",
      result: n
    }));
  }, r.prototype.writeFragment = function(e) {
    var t = e.id, n = e.data, i = e.fragment, a = e.fragmentName, s = lt(e, ["id", "data", "fragment", "fragmentName"]);
    return this.write(Object.assign(s, {
      query: this.getFragmentDoc(i, a),
      dataId: t,
      result: n
    }));
  }, r.prototype.updateQuery = function(e, t) {
    return this.batch({
      update: function(n) {
        var i = n.readQuery(e), a = t(i);
        return a == null ? i : (n.writeQuery(y(y({}, e), { data: a })), a);
      }
    });
  }, r.prototype.updateFragment = function(e, t) {
    return this.batch({
      update: function(n) {
        var i = n.readFragment(e), a = t(i);
        return a == null ? i : (n.writeFragment(y(y({}, e), { data: a })), a);
      }
    });
  }, r;
}(), Sa = function(r) {
  be(e, r);
  function e(t, n, i, a) {
    var s, o = r.call(this, t) || this;
    if (o.message = t, o.path = n, o.query = i, o.variables = a, Array.isArray(o.path)) {
      o.missing = o.message;
      for (var c = o.path.length - 1; c >= 0; --c)
        o.missing = (s = {}, s[o.path[c]] = o.missing, s);
    } else
      o.missing = o.path;
    return o.__proto__ = e.prototype, o;
  }
  return e;
}(Error), te = Object.prototype.hasOwnProperty;
function wt(r) {
  return r == null;
}
var ee = Array.isArray;
function Oa(r, e) {
  var t = r.__typename, n = r.id, i = r._id;
  if (typeof t == "string" && (e && (e.keyObject = wt(n) ? wt(i) ? void 0 : { _id: i } : { id: n }), wt(n) && !wt(i) && (n = i), !wt(n)))
    return "".concat(t, ":").concat(typeof n == "number" || typeof n == "string" ? n : JSON.stringify(n));
}
var xa = {
  dataIdFromObject: Oa,
  addTypename: !0,
  resultCaching: !0,
  canonizeResults: !1
};
function Du(r) {
  return wr(xa, r);
}
function Ta(r) {
  var e = r.canonizeResults;
  return e === void 0 ? xa.canonizeResults : e;
}
function Iu(r, e) {
  return U(e) ? r.get(e.__ref, "__typename") : e && e.__typename;
}
var Da = /^[_a-z][_0-9a-z]*/i;
function Le(r) {
  var e = r.match(Da);
  return e ? e[0] : r;
}
function an(r, e, t) {
  return Y(e) ? ee(e) ? e.every(function(n) {
    return an(r, n, t);
  }) : r.selections.every(function(n) {
    if (je(n) && vr(n, t)) {
      var i = Je(n);
      return te.call(e, i) && (!n.selectionSet || an(n.selectionSet, e[i], t));
    }
    return !0;
  }) : !1;
}
function it(r) {
  return Y(r) && !U(r) && !ee(r);
}
function Ru() {
  return new He();
}
function Ia(r, e) {
  var t = _n(En(r));
  return {
    fragmentMap: t,
    lookupFragment: function(n) {
      var i = t[n];
      return !i && e && (i = e.lookup(n)), i || null;
    }
  };
}
var nr = /* @__PURE__ */ Object.create(null), Nr = function() {
  return nr;
}, ki = /* @__PURE__ */ Object.create(null), Rt = function() {
  function r(e, t) {
    var n = this;
    this.policies = e, this.group = t, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(i, a) {
      return Yr(U(i) ? n.get(i.__ref, a) : i && i[a]);
    }, this.canRead = function(i) {
      return U(i) ? n.has(i.__ref) : typeof i == "object";
    }, this.toReference = function(i, a) {
      if (typeof i == "string")
        return ot(i);
      if (U(i))
        return i;
      var s = n.policies.identify(i)[0];
      if (s) {
        var o = ot(s);
        return a && n.merge(s, i), o;
      }
    };
  }
  return r.prototype.toObject = function() {
    return y({}, this.data);
  }, r.prototype.has = function(e) {
    return this.lookup(e, !0) !== void 0;
  }, r.prototype.get = function(e, t) {
    if (this.group.depend(e, t), te.call(this.data, e)) {
      var n = this.data[e];
      if (n && te.call(n, t))
        return n[t];
    }
    if (t === "__typename" && te.call(this.policies.rootTypenamesById, e))
      return this.policies.rootTypenamesById[e];
    if (this instanceof Ne)
      return this.parent.get(e, t);
  }, r.prototype.lookup = function(e, t) {
    if (t && this.group.depend(e, "__exists"), te.call(this.data, e))
      return this.data[e];
    if (this instanceof Ne)
      return this.parent.lookup(e, t);
    if (this.policies.rootTypenamesById[e])
      return /* @__PURE__ */ Object.create(null);
  }, r.prototype.merge = function(e, t) {
    var n = this, i;
    U(e) && (e = e.__ref), U(t) && (t = t.__ref);
    var a = typeof e == "string" ? this.lookup(i = e) : e, s = typeof t == "string" ? this.lookup(i = t) : t;
    if (s) {
      __DEV__ ? E(typeof i == "string", "store.merge expects a string ID") : E(typeof i == "string", 1);
      var o = new He(Cu).merge(a, s);
      if (this.data[i] = o, o !== a && (delete this.refs[i], this.group.caching)) {
        var c = /* @__PURE__ */ Object.create(null);
        a || (c.__exists = 1), Object.keys(s).forEach(function(u) {
          if (!a || a[u] !== o[u]) {
            c[u] = 1;
            var f = Le(u);
            f !== u && !n.policies.hasKeyArgs(o.__typename, f) && (c[f] = 1), o[u] === void 0 && !(n instanceof Ne) && delete o[u];
          }
        }), c.__typename && !(a && a.__typename) && this.policies.rootTypenamesById[i] === o.__typename && delete c.__typename, Object.keys(c).forEach(function(u) {
          return n.group.dirty(i, u);
        });
      }
    }
  }, r.prototype.modify = function(e, t) {
    var n = this, i = this.lookup(e);
    if (i) {
      var a = /* @__PURE__ */ Object.create(null), s = !1, o = !0, c = {
        DELETE: nr,
        INVALIDATE: ki,
        isReference: U,
        toReference: this.toReference,
        canRead: this.canRead,
        readField: function(u, f) {
          return n.policies.readField(typeof u == "string" ? {
            fieldName: u,
            from: f || ot(e)
          } : u, { store: n });
        }
      };
      if (Object.keys(i).forEach(function(u) {
        var f = Le(u), d = i[u];
        if (d !== void 0) {
          var h = typeof t == "function" ? t : t[u] || t[f];
          if (h) {
            var p = h === Nr ? nr : h(Yr(d), y(y({}, c), { fieldName: f, storeFieldName: u, storage: n.getStorage(e, u) }));
            p === ki ? n.group.dirty(e, u) : (p === nr && (p = void 0), p !== d && (a[u] = p, s = !0, d = p));
          }
          d !== void 0 && (o = !1);
        }
      }), s)
        return this.merge(e, a), o && (this instanceof Ne ? this.data[e] = void 0 : delete this.data[e], this.group.dirty(e, "__exists")), !0;
    }
    return !1;
  }, r.prototype.delete = function(e, t, n) {
    var i, a = this.lookup(e);
    if (a) {
      var s = this.getFieldValue(a, "__typename"), o = t && n ? this.policies.getStoreFieldName({ typename: s, fieldName: t, args: n }) : t;
      return this.modify(e, o ? (i = {}, i[o] = Nr, i) : Nr);
    }
    return !1;
  }, r.prototype.evict = function(e, t) {
    var n = !1;
    return e.id && (te.call(this.data, e.id) && (n = this.delete(e.id, e.fieldName, e.args)), this instanceof Ne && this !== t && (n = this.parent.evict(e, t) || n), (e.fieldName || n) && this.group.dirty(e.id, e.fieldName || "__exists")), n;
  }, r.prototype.clear = function() {
    this.replace(null);
  }, r.prototype.extract = function() {
    var e = this, t = this.toObject(), n = [];
    return this.getRootIdSet().forEach(function(i) {
      te.call(e.policies.rootTypenamesById, i) || n.push(i);
    }), n.length && (t.__META = { extraRootIds: n.sort() }), t;
  }, r.prototype.replace = function(e) {
    var t = this;
    if (Object.keys(this.data).forEach(function(a) {
      e && te.call(e, a) || t.delete(a);
    }), e) {
      var n = e.__META, i = lt(e, ["__META"]);
      Object.keys(i).forEach(function(a) {
        t.merge(a, i[a]);
      }), n && n.extraRootIds.forEach(this.retain, this);
    }
  }, r.prototype.retain = function(e) {
    return this.rootIds[e] = (this.rootIds[e] || 0) + 1;
  }, r.prototype.release = function(e) {
    if (this.rootIds[e] > 0) {
      var t = --this.rootIds[e];
      return t || delete this.rootIds[e], t;
    }
    return 0;
  }, r.prototype.getRootIdSet = function(e) {
    return e === void 0 && (e = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(e.add, e), this instanceof Ne ? this.parent.getRootIdSet(e) : Object.keys(this.policies.rootTypenamesById).forEach(e.add, e), e;
  }, r.prototype.gc = function() {
    var e = this, t = this.getRootIdSet(), n = this.toObject();
    t.forEach(function(s) {
      te.call(n, s) && (Object.keys(e.findChildRefIds(s)).forEach(t.add, t), delete n[s]);
    });
    var i = Object.keys(n);
    if (i.length) {
      for (var a = this; a instanceof Ne; )
        a = a.parent;
      i.forEach(function(s) {
        return a.delete(s);
      });
    }
    return i;
  }, r.prototype.findChildRefIds = function(e) {
    if (!te.call(this.refs, e)) {
      var t = this.refs[e] = /* @__PURE__ */ Object.create(null), n = this.data[e];
      if (!n)
        return t;
      var i = /* @__PURE__ */ new Set([n]);
      i.forEach(function(a) {
        U(a) && (t[a.__ref] = !0), Y(a) && Object.keys(a).forEach(function(s) {
          var o = a[s];
          Y(o) && i.add(o);
        });
      });
    }
    return this.refs[e];
  }, r.prototype.makeCacheKey = function() {
    return this.group.keyMaker.lookupArray(arguments);
  }, r;
}(), Ra = function() {
  function r(e, t) {
    t === void 0 && (t = null), this.caching = e, this.parent = t, this.d = null, this.resetCaching();
  }
  return r.prototype.resetCaching = function() {
    this.d = this.caching ? ka() : null, this.keyMaker = new $t(et);
  }, r.prototype.depend = function(e, t) {
    if (this.d) {
      this.d(Pr(e, t));
      var n = Le(t);
      n !== t && this.d(Pr(e, n)), this.parent && this.parent.depend(e, t);
    }
  }, r.prototype.dirty = function(e, t) {
    this.d && this.d.dirty(Pr(e, t), t === "__exists" ? "forget" : "setDirty");
  }, r;
}();
function Pr(r, e) {
  return e + "#" + r;
}
function Ei(r, e) {
  Tt(r) && r.group.depend(e, "__exists");
}
(function(r) {
  var e = function(t) {
    be(n, t);
    function n(i) {
      var a = i.policies, s = i.resultCaching, o = s === void 0 ? !0 : s, c = i.seed, u = t.call(this, a, new Ra(o)) || this;
      return u.stump = new ju(u), u.storageTrie = new $t(et), c && u.replace(c), u;
    }
    return n.prototype.addLayer = function(i, a) {
      return this.stump.addLayer(i, a);
    }, n.prototype.removeLayer = function() {
      return this;
    }, n.prototype.getStorage = function() {
      return this.storageTrie.lookupArray(arguments);
    }, n;
  }(r);
  r.Root = e;
})(Rt || (Rt = {}));
var Ne = function(r) {
  be(e, r);
  function e(t, n, i, a) {
    var s = r.call(this, n.policies, a) || this;
    return s.id = t, s.parent = n, s.replay = i, s.group = a, i(s), s;
  }
  return e.prototype.addLayer = function(t, n) {
    return new e(t, this, n, this.group);
  }, e.prototype.removeLayer = function(t) {
    var n = this, i = this.parent.removeLayer(t);
    return t === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(a) {
      var s = n.data[a], o = i.lookup(a);
      o ? s ? s !== o && Object.keys(s).forEach(function(c) {
        re(s[c], o[c]) || n.group.dirty(a, c);
      }) : (n.group.dirty(a, "__exists"), Object.keys(o).forEach(function(c) {
        n.group.dirty(a, c);
      })) : n.delete(a);
    }), i) : i === this.parent ? this : i.addLayer(this.id, this.replay);
  }, e.prototype.toObject = function() {
    return y(y({}, this.parent.toObject()), this.data);
  }, e.prototype.findChildRefIds = function(t) {
    var n = this.parent.findChildRefIds(t);
    return te.call(this.data, t) ? y(y({}, n), r.prototype.findChildRefIds.call(this, t)) : n;
  }, e.prototype.getStorage = function() {
    for (var t = this.parent; t.parent; )
      t = t.parent;
    return t.getStorage.apply(t, arguments);
  }, e;
}(Rt), ju = function(r) {
  be(e, r);
  function e(t) {
    return r.call(this, "EntityStore.Stump", t, function() {
    }, new Ra(t.group.caching, t.group)) || this;
  }
  return e.prototype.removeLayer = function() {
    return this;
  }, e.prototype.merge = function() {
    return this.parent.merge.apply(this.parent, arguments);
  }, e;
}(Ne);
function Cu(r, e, t) {
  var n = r[t], i = e[t];
  return re(n, i) ? n : i;
}
function Tt(r) {
  return !!(r instanceof Rt && r.group.caching);
}
function Au(r) {
  return Y(r) ? ee(r) ? r.slice(0) : y({ __proto__: Object.getPrototypeOf(r) }, r) : r;
}
var sn = function() {
  function r() {
    this.known = new (Eo ? WeakSet : Set)(), this.pool = new $t(et), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
  }
  return r.prototype.isKnown = function(e) {
    return Y(e) && this.known.has(e);
  }, r.prototype.pass = function(e) {
    if (Y(e)) {
      var t = Au(e);
      return this.passes.set(t, e), t;
    }
    return e;
  }, r.prototype.admit = function(e) {
    var t = this;
    if (Y(e)) {
      var n = this.passes.get(e);
      if (n)
        return n;
      var i = Object.getPrototypeOf(e);
      switch (i) {
        case Array.prototype: {
          if (this.known.has(e))
            return e;
          var a = e.map(this.admit, this), s = this.pool.lookupArray(a);
          return s.array || (this.known.add(s.array = a), __DEV__ && Object.freeze(a)), s.array;
        }
        case null:
        case Object.prototype: {
          if (this.known.has(e))
            return e;
          var o = Object.getPrototypeOf(e), c = [o], u = this.sortedKeys(e);
          c.push(u.json);
          var f = c.length;
          u.sorted.forEach(function(p) {
            c.push(t.admit(e[p]));
          });
          var s = this.pool.lookupArray(c);
          if (!s.object) {
            var d = s.object = Object.create(o);
            this.known.add(d), u.sorted.forEach(function(p, m) {
              d[p] = c[f + m];
            }), __DEV__ && Object.freeze(d);
          }
          return s.object;
        }
      }
    }
    return e;
  }, r.prototype.sortedKeys = function(e) {
    var t = Object.keys(e), n = this.pool.lookupArray(t);
    if (!n.keys) {
      t.sort();
      var i = JSON.stringify(t);
      (n.keys = this.keysByJSON.get(i)) || this.keysByJSON.set(i, n.keys = { sorted: t, json: i });
    }
    return n.keys;
  }, r;
}(), We = Object.assign(function(r) {
  if (Y(r)) {
    on === void 0 && Si();
    var e = on.admit(r), t = un.get(e);
    return t === void 0 && un.set(e, t = JSON.stringify(e)), t;
  }
  return JSON.stringify(r);
}, {
  reset: Si
}), on, un;
function Si() {
  on = new sn(), un = new (et ? WeakMap : Map)();
}
function Oi(r) {
  return [
    r.selectionSet,
    r.objectOrReference,
    r.context,
    r.context.canonizeResults
  ];
}
var Nu = function() {
  function r(e) {
    var t = this;
    this.knownResults = new (et ? WeakMap : Map)(), this.config = wr(e, {
      addTypename: e.addTypename !== !1,
      canonizeResults: Ta(e)
    }), this.canon = e.canon || new sn(), this.executeSelectionSet = sr(function(n) {
      var i, a = n.context.canonizeResults, s = Oi(n);
      s[3] = !a;
      var o = (i = t.executeSelectionSet).peek.apply(i, s);
      return o ? a ? y(y({}, o), { result: t.canon.admit(o.result) }) : o : (Ei(n.context.store, n.enclosingRef.__ref), t.execSelectionSetImpl(n));
    }, {
      max: this.config.resultCacheMaxSize,
      keyArgs: Oi,
      makeCacheKey: function(n, i, a, s) {
        if (Tt(a.store))
          return a.store.makeCacheKey(n, U(i) ? i.__ref : i, a.varString, s);
      }
    }), this.executeSubSelectedArray = sr(function(n) {
      return Ei(n.context.store, n.enclosingRef.__ref), t.execSubSelectedArrayImpl(n);
    }, {
      max: this.config.resultCacheMaxSize,
      makeCacheKey: function(n) {
        var i = n.field, a = n.array, s = n.context;
        if (Tt(s.store))
          return s.store.makeCacheKey(i, a, s.varString);
      }
    });
  }
  return r.prototype.resetCanon = function() {
    this.canon = new sn();
  }, r.prototype.diffQueryAgainstStore = function(e) {
    var t = e.store, n = e.query, i = e.rootId, a = i === void 0 ? "ROOT_QUERY" : i, s = e.variables, o = e.returnPartialData, c = o === void 0 ? !0 : o, u = e.canonizeResults, f = u === void 0 ? this.config.canonizeResults : u, d = this.config.cache.policies;
    s = y(y({}, Sn(ta(n))), s);
    var h = ot(a), p = this.executeSelectionSet({
      selectionSet: br(n).selectionSet,
      objectOrReference: h,
      enclosingRef: h,
      context: y({ store: t, query: n, policies: d, variables: s, varString: We(s), canonizeResults: f }, Ia(n, this.config.fragments))
    }), m;
    if (p.missing && (m = [new Sa(Pu(p.missing), p.missing, n, s)], !c))
      throw m[0];
    return {
      result: p.result,
      complete: !m,
      missing: m
    };
  }, r.prototype.isFresh = function(e, t, n, i) {
    if (Tt(i.store) && this.knownResults.get(e) === n) {
      var a = this.executeSelectionSet.peek(n, t, i, this.canon.isKnown(e));
      if (a && e === a.result)
        return !0;
    }
    return !1;
  }, r.prototype.execSelectionSetImpl = function(e) {
    var t = this, n = e.selectionSet, i = e.objectOrReference, a = e.enclosingRef, s = e.context;
    if (U(i) && !s.policies.rootTypenamesById[i.__ref] && !s.store.has(i.__ref))
      return {
        result: this.canon.empty,
        missing: "Dangling reference to missing ".concat(i.__ref, " object")
      };
    var o = s.variables, c = s.policies, u = s.store, f = u.getFieldValue(i, "__typename"), d = [], h, p = new He();
    this.config.addTypename && typeof f == "string" && !c.rootIdsByTypename[f] && d.push({ __typename: f });
    function m(_, S) {
      var N;
      return _.missing && (h = p.merge(h, (N = {}, N[S] = _.missing, N))), _.result;
    }
    var v = new Set(n.selections);
    v.forEach(function(_) {
      var S, N;
      if (vr(_, o))
        if (je(_)) {
          var j = c.readField({
            fieldName: _.name.value,
            field: _,
            variables: s.variables,
            from: i
          }, s), D = Je(_);
          j === void 0 ? xn.added(_) || (h = p.merge(h, (S = {}, S[D] = "Can't find field '".concat(_.name.value, "' on ").concat(U(i) ? i.__ref + " object" : "object " + JSON.stringify(i, null, 2)), S))) : ee(j) ? j = m(t.executeSubSelectedArray({
            field: _,
            array: j,
            enclosingRef: a,
            context: s
          }), D) : _.selectionSet ? j != null && (j = m(t.executeSelectionSet({
            selectionSet: _.selectionSet,
            objectOrReference: j,
            enclosingRef: U(j) ? j : a,
            context: s
          }), D)) : s.canonizeResults && (j = t.canon.pass(j)), j !== void 0 && d.push((N = {}, N[D] = j, N));
        } else {
          var R = wn(_, s.lookupFragment);
          if (!R && _.kind === Ji.FRAGMENT_SPREAD)
            throw __DEV__ ? new B("No fragment named ".concat(_.name.value)) : new B(5);
          R && c.fragmentMatches(R, f) && R.selectionSet.selections.forEach(v.add, v);
        }
    });
    var b = Tn(d), k = { result: b, missing: h }, I = s.canonizeResults ? this.canon.admit(k) : Yr(k);
    return I.result && this.knownResults.set(I.result, n), I;
  }, r.prototype.execSubSelectedArrayImpl = function(e) {
    var t = this, n = e.field, i = e.array, a = e.enclosingRef, s = e.context, o, c = new He();
    function u(f, d) {
      var h;
      return f.missing && (o = c.merge(o, (h = {}, h[d] = f.missing, h))), f.result;
    }
    return n.selectionSet && (i = i.filter(s.store.canRead)), i = i.map(function(f, d) {
      return f === null ? null : ee(f) ? u(t.executeSubSelectedArray({
        field: n,
        array: f,
        enclosingRef: a,
        context: s
      }), d) : n.selectionSet ? u(t.executeSelectionSet({
        selectionSet: n.selectionSet,
        objectOrReference: f,
        enclosingRef: U(f) ? f : a,
        context: s
      }), d) : (__DEV__ && Fu(s.store, n, f), f);
    }), {
      result: s.canonizeResults ? this.canon.admit(i) : i,
      missing: o
    };
  }, r;
}();
function Pu(r) {
  try {
    JSON.stringify(r, function(e, t) {
      if (typeof t == "string")
        throw t;
      return t;
    });
  } catch (e) {
    return e;
  }
}
function Fu(r, e, t) {
  if (!e.selectionSet) {
    var n = /* @__PURE__ */ new Set([t]);
    n.forEach(function(i) {
      Y(i) && (__DEV__ ? E(!U(i), "Missing selection set for object of type ".concat(Iu(r, i), " returned for query field ").concat(e.name.value)) : E(!U(i), 6), Object.values(i).forEach(n.add, n));
    });
  }
}
var se = null, xi = {}, Mu = 1, Vu = function() {
  return (
    /** @class */
    function() {
      function r() {
        this.id = [
          "slot",
          Mu++,
          Date.now(),
          Math.random().toString(36).slice(2)
        ].join(":");
      }
      return r.prototype.hasValue = function() {
        for (var e = se; e; e = e.parent)
          if (this.id in e.slots) {
            var t = e.slots[this.id];
            if (t === xi)
              break;
            return e !== se && (se.slots[this.id] = t), !0;
          }
        return se && (se.slots[this.id] = xi), !1;
      }, r.prototype.getValue = function() {
        if (this.hasValue())
          return se.slots[this.id];
      }, r.prototype.withValue = function(e, t, n, i) {
        var a, s = (a = {
          __proto__: null
        }, a[this.id] = e, a), o = se;
        se = { parent: o, slots: s };
        try {
          return t.apply(i, n);
        } finally {
          se = o;
        }
      }, r.bind = function(e) {
        var t = se;
        return function() {
          var n = se;
          try {
            return se = t, e.apply(this, arguments);
          } finally {
            se = n;
          }
        };
      }, r.noContext = function(e, t, n) {
        if (se) {
          var i = se;
          try {
            return se = null, e.apply(n, t);
          } finally {
            se = i;
          }
        } else
          return e.apply(n, t);
      }, r;
    }()
  );
};
function Ti(r) {
  try {
    return r();
  } catch {
  }
}
var Fr = "@wry/context:Slot", Lu = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  Ti(function() {
    return globalThis;
  }) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  Ti(function() {
    return global;
  }) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), Di = Lu, Vn = Di[Fr] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[Fr] || function(r) {
  try {
    Object.defineProperty(Di, Fr, {
      value: r,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return r;
  }
}(Vu());
Vn.bind;
Vn.noContext;
var Ln = new Vn(), Ii = /* @__PURE__ */ new WeakMap();
function Dt(r) {
  var e = Ii.get(r);
  return e || Ii.set(r, e = {
    vars: /* @__PURE__ */ new Set(),
    dep: ka()
  }), e;
}
function Ri(r) {
  Dt(r).vars.forEach(function(e) {
    return e.forgetCache(r);
  });
}
function qu(r) {
  Dt(r).vars.forEach(function(e) {
    return e.attachCache(r);
  });
}
function Qu(r) {
  var e = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new Set(), n = function(a) {
    if (arguments.length > 0) {
      if (r !== a) {
        r = a, e.forEach(function(c) {
          Dt(c).dep.dirty(n), Bu(c);
        });
        var s = Array.from(t);
        t.clear(), s.forEach(function(c) {
          return c(r);
        });
      }
    } else {
      var o = Ln.getValue();
      o && (i(o), Dt(o).dep(n));
    }
    return r;
  };
  n.onNextChange = function(a) {
    return t.add(a), function() {
      t.delete(a);
    };
  };
  var i = n.attachCache = function(a) {
    return e.add(a), Dt(a).vars.add(n), n;
  };
  return n.forgetCache = function(a) {
    return e.delete(a);
  }, n;
}
function Bu(r) {
  r.broadcastWatches && r.broadcastWatches();
}
var ji = /* @__PURE__ */ Object.create(null);
function qn(r) {
  var e = JSON.stringify(r);
  return ji[e] || (ji[e] = /* @__PURE__ */ Object.create(null));
}
function Ci(r) {
  var e = qn(r);
  return e.keyFieldsFn || (e.keyFieldsFn = function(t, n) {
    var i = function(s, o) {
      return n.readField(o, s);
    }, a = n.keyObject = Qn(r, function(s) {
      var o = ut(n.storeObject, s, i);
      return o === void 0 && t !== n.storeObject && te.call(t, s[0]) && (o = ut(t, s, Ca)), __DEV__ ? E(o !== void 0, "Missing field '".concat(s.join("."), "' while extracting keyFields from ").concat(JSON.stringify(t))) : E(o !== void 0, 2), o;
    });
    return "".concat(n.typename, ":").concat(JSON.stringify(a));
  });
}
function Ai(r) {
  var e = qn(r);
  return e.keyArgsFn || (e.keyArgsFn = function(t, n) {
    var i = n.field, a = n.variables, s = n.fieldName, o = Qn(r, function(u) {
      var f = u[0], d = f.charAt(0);
      if (d === "@") {
        if (i && Ee(i.directives)) {
          var h = f.slice(1), p = i.directives.find(function(k) {
            return k.name.value === h;
          }), m = p && mr(p, a);
          return m && ut(m, u.slice(1));
        }
        return;
      }
      if (d === "$") {
        var v = f.slice(1);
        if (a && te.call(a, v)) {
          var b = u.slice(0);
          return b[0] = v, ut(a, b);
        }
        return;
      }
      if (t)
        return ut(t, u);
    }), c = JSON.stringify(o);
    return (t || c !== "{}") && (s += ":" + c), s;
  });
}
function Qn(r, e) {
  var t = new He();
  return ja(r).reduce(function(n, i) {
    var a, s = e(i);
    if (s !== void 0) {
      for (var o = i.length - 1; o >= 0; --o)
        s = (a = {}, a[i[o]] = s, a);
      n = t.merge(n, s);
    }
    return n;
  }, /* @__PURE__ */ Object.create(null));
}
function ja(r) {
  var e = qn(r);
  if (!e.paths) {
    var t = e.paths = [], n = [];
    r.forEach(function(i, a) {
      ee(i) ? (ja(i).forEach(function(s) {
        return t.push(n.concat(s));
      }), n.length = 0) : (n.push(i), ee(r[a + 1]) || (t.push(n.slice(0)), n.length = 0));
    });
  }
  return e.paths;
}
function Ca(r, e) {
  return r[e];
}
function ut(r, e, t) {
  return t = t || Ca, Aa(e.reduce(function n(i, a) {
    return ee(i) ? i.map(function(s) {
      return n(s, a);
    }) : i && t(i, a);
  }, r));
}
function Aa(r) {
  return Y(r) ? ee(r) ? r.map(Aa) : Qn(Object.keys(r).sort(), function(e) {
    return ut(r, e);
  }) : r;
}
kn.setStringify(We);
function cn(r) {
  return r.args !== void 0 ? r.args : r.field ? mr(r.field, r.variables) : null;
}
var Zu = function() {
}, Ni = function(r, e) {
  return e.fieldName;
}, Pi = function(r, e, t) {
  var n = t.mergeObjects;
  return n(r, e);
}, Fi = function(r, e) {
  return e;
}, Uu = function() {
  function r(e) {
    this.config = e, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = y({ dataIdFromObject: Oa }, e), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), e.possibleTypes && this.addPossibleTypes(e.possibleTypes), e.typePolicies && this.addTypePolicies(e.typePolicies);
  }
  return r.prototype.identify = function(e, t) {
    var n, i = this, a = t && (t.typename || ((n = t.storeObject) === null || n === void 0 ? void 0 : n.__typename)) || e.__typename;
    if (a === this.rootTypenamesById.ROOT_QUERY)
      return ["ROOT_QUERY"];
    for (var s = t && t.storeObject || e, o = y(y({}, t), { typename: a, storeObject: s, readField: t && t.readField || function() {
      var h = Bn(arguments, s);
      return i.readField(h, {
        store: i.cache.data,
        variables: h.variables
      });
    } }), c, u = a && this.getTypePolicy(a), f = u && u.keyFn || this.config.dataIdFromObject; f; ) {
      var d = f(e, o);
      if (ee(d))
        f = Ci(d);
      else {
        c = d;
        break;
      }
    }
    return c = c ? String(c) : void 0, o.keyObject ? [c, o.keyObject] : [c];
  }, r.prototype.addTypePolicies = function(e) {
    var t = this;
    Object.keys(e).forEach(function(n) {
      var i = e[n], a = i.queryType, s = i.mutationType, o = i.subscriptionType, c = lt(i, ["queryType", "mutationType", "subscriptionType"]);
      a && t.setRootTypename("Query", n), s && t.setRootTypename("Mutation", n), o && t.setRootTypename("Subscription", n), te.call(t.toBeAdded, n) ? t.toBeAdded[n].push(c) : t.toBeAdded[n] = [c];
    });
  }, r.prototype.updateTypePolicy = function(e, t) {
    var n = this, i = this.getTypePolicy(e), a = t.keyFields, s = t.fields;
    function o(c, u) {
      c.merge = typeof u == "function" ? u : u === !0 ? Pi : u === !1 ? Fi : c.merge;
    }
    o(i, t.merge), i.keyFn = a === !1 ? Zu : ee(a) ? Ci(a) : typeof a == "function" ? a : i.keyFn, s && Object.keys(s).forEach(function(c) {
      var u = n.getFieldPolicy(e, c, !0), f = s[c];
      if (typeof f == "function")
        u.read = f;
      else {
        var d = f.keyArgs, h = f.read, p = f.merge;
        u.keyFn = d === !1 ? Ni : ee(d) ? Ai(d) : typeof d == "function" ? d : u.keyFn, typeof h == "function" && (u.read = h), o(u, p);
      }
      u.read && u.merge && (u.keyFn = u.keyFn || Ni);
    });
  }, r.prototype.setRootTypename = function(e, t) {
    t === void 0 && (t = e);
    var n = "ROOT_" + e.toUpperCase(), i = this.rootTypenamesById[n];
    t !== i && (__DEV__ ? E(!i || i === e, "Cannot change root ".concat(e, " __typename more than once")) : E(!i || i === e, 3), i && delete this.rootIdsByTypename[i], this.rootIdsByTypename[t] = n, this.rootTypenamesById[n] = t);
  }, r.prototype.addPossibleTypes = function(e) {
    var t = this;
    this.usingPossibleTypes = !0, Object.keys(e).forEach(function(n) {
      t.getSupertypeSet(n, !0), e[n].forEach(function(i) {
        t.getSupertypeSet(i, !0).add(n);
        var a = i.match(Da);
        (!a || a[0] !== i) && t.fuzzySubtypes.set(i, new RegExp(i));
      });
    });
  }, r.prototype.getTypePolicy = function(e) {
    var t = this;
    if (!te.call(this.typePolicies, e)) {
      var n = this.typePolicies[e] = /* @__PURE__ */ Object.create(null);
      n.fields = /* @__PURE__ */ Object.create(null);
      var i = this.supertypeMap.get(e);
      i && i.size && i.forEach(function(s) {
        var o = t.getTypePolicy(s), c = o.fields, u = lt(o, ["fields"]);
        Object.assign(n, u), Object.assign(n.fields, c);
      });
    }
    var a = this.toBeAdded[e];
    return a && a.length && a.splice(0).forEach(function(s) {
      t.updateTypePolicy(e, s);
    }), this.typePolicies[e];
  }, r.prototype.getFieldPolicy = function(e, t, n) {
    if (e) {
      var i = this.getTypePolicy(e).fields;
      return i[t] || n && (i[t] = /* @__PURE__ */ Object.create(null));
    }
  }, r.prototype.getSupertypeSet = function(e, t) {
    var n = this.supertypeMap.get(e);
    return !n && t && this.supertypeMap.set(e, n = /* @__PURE__ */ new Set()), n;
  }, r.prototype.fragmentMatches = function(e, t, n, i) {
    var a = this;
    if (!e.typeCondition)
      return !0;
    if (!t)
      return !1;
    var s = e.typeCondition.name.value;
    if (t === s)
      return !0;
    if (this.usingPossibleTypes && this.supertypeMap.has(s))
      for (var o = this.getSupertypeSet(t, !0), c = [o], u = function(m) {
        var v = a.getSupertypeSet(m, !1);
        v && v.size && c.indexOf(v) < 0 && c.push(v);
      }, f = !!(n && this.fuzzySubtypes.size), d = !1, h = 0; h < c.length; ++h) {
        var p = c[h];
        if (p.has(s))
          return o.has(s) || (d && __DEV__ && E.warn("Inferring subtype ".concat(t, " of supertype ").concat(s)), o.add(s)), !0;
        p.forEach(u), f && h === c.length - 1 && an(e.selectionSet, n, i) && (f = !1, d = !0, this.fuzzySubtypes.forEach(function(m, v) {
          var b = t.match(m);
          b && b[0] === t && u(v);
        }));
      }
    return !1;
  }, r.prototype.hasKeyArgs = function(e, t) {
    var n = this.getFieldPolicy(e, t, !1);
    return !!(n && n.keyFn);
  }, r.prototype.getStoreFieldName = function(e) {
    var t = e.typename, n = e.fieldName, i = this.getFieldPolicy(t, n, !1), a, s = i && i.keyFn;
    if (s && t)
      for (var o = {
        typename: t,
        fieldName: n,
        field: e.field || null,
        variables: e.variables
      }, c = cn(e); s; ) {
        var u = s(c, o);
        if (ee(u))
          s = Ai(u);
        else {
          a = u || n;
          break;
        }
      }
    return a === void 0 && (a = e.field ? Ks(e.field, e.variables) : kn(n, cn(e))), a === !1 ? n : n === Le(a) ? a : n + ":" + a;
  }, r.prototype.readField = function(e, t) {
    var n = e.from;
    if (n) {
      var i = e.field || e.fieldName;
      if (i) {
        if (e.typename === void 0) {
          var a = t.store.getFieldValue(n, "__typename");
          a && (e.typename = a);
        }
        var s = this.getStoreFieldName(e), o = Le(s), c = t.store.getFieldValue(n, s), u = this.getFieldPolicy(e.typename, o, !1), f = u && u.read;
        if (f) {
          var d = Mi(this, n, e, t, t.store.getStorage(U(n) ? n.__ref : n, s));
          return Ln.withValue(this.cache, f, [c, d]);
        }
        return c;
      }
    }
  }, r.prototype.getReadFunction = function(e, t) {
    var n = this.getFieldPolicy(e, t, !1);
    return n && n.read;
  }, r.prototype.getMergeFunction = function(e, t, n) {
    var i = this.getFieldPolicy(e, t, !1), a = i && i.merge;
    return !a && n && (i = this.getTypePolicy(n), a = i && i.merge), a;
  }, r.prototype.runMergeFunction = function(e, t, n, i, a) {
    var s = n.field, o = n.typename, c = n.merge;
    return c === Pi ? Na(i.store)(e, t) : c === Fi ? t : (i.overwrite && (e = void 0), c(e, t, Mi(this, void 0, { typename: o, fieldName: s.name.value, field: s, variables: i.variables }, i, a || /* @__PURE__ */ Object.create(null))));
  }, r;
}();
function Mi(r, e, t, n, i) {
  var a = r.getStoreFieldName(t), s = Le(a), o = t.variables || n.variables, c = n.store, u = c.toReference, f = c.canRead;
  return {
    args: cn(t),
    field: t.field || null,
    fieldName: s,
    storeFieldName: a,
    variables: o,
    isReference: U,
    toReference: u,
    storage: i,
    cache: r.cache,
    canRead: f,
    readField: function() {
      return r.readField(Bn(arguments, e, o), n);
    },
    mergeObjects: Na(n.store)
  };
}
function Bn(r, e, t) {
  var n = r[0], i = r[1], a = r.length, s;
  return typeof n == "string" ? s = {
    fieldName: n,
    from: a > 1 ? i : e
  } : (s = y({}, n), te.call(s, "from") || (s.from = e)), __DEV__ && s.from === void 0 && __DEV__ && E.warn("Undefined 'from' passed to readField with arguments ".concat(So(Array.from(r)))), s.variables === void 0 && (s.variables = t), s;
}
function Na(r) {
  return function(t, n) {
    if (ee(t) || ee(n))
      throw __DEV__ ? new B("Cannot automatically merge arrays") : new B(4);
    if (Y(t) && Y(n)) {
      var i = r.getFieldValue(t, "__typename"), a = r.getFieldValue(n, "__typename"), s = i && a && i !== a;
      if (s)
        return n;
      if (U(t) && it(n))
        return r.merge(t.__ref, n), t;
      if (it(t) && U(n))
        return r.merge(t, n.__ref), n;
      if (it(t) && it(n))
        return y(y({}, t), n);
    }
    return n;
  };
}
function Mr(r, e, t) {
  var n = "".concat(e).concat(t), i = r.flavors.get(n);
  return i || r.flavors.set(n, i = r.clientOnly === e && r.deferred === t ? r : y(y({}, r), { clientOnly: e, deferred: t })), i;
}
var zu = function() {
  function r(e, t, n) {
    this.cache = e, this.reader = t, this.fragments = n;
  }
  return r.prototype.writeToStore = function(e, t) {
    var n = this, i = t.query, a = t.result, s = t.dataId, o = t.variables, c = t.overwrite, u = zt(i), f = Ru();
    o = y(y({}, Sn(u)), o);
    var d = y(y({ store: e, written: /* @__PURE__ */ Object.create(null), merge: function(p, m) {
      return f.merge(p, m);
    }, variables: o, varString: We(o) }, Ia(i, this.fragments)), { overwrite: !!c, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), h = this.processSelectionSet({
      result: a || /* @__PURE__ */ Object.create(null),
      dataId: s,
      selectionSet: u.selectionSet,
      mergeTree: { map: /* @__PURE__ */ new Map() },
      context: d
    });
    if (!U(h))
      throw __DEV__ ? new B("Could not identify object ".concat(JSON.stringify(a))) : new B(7);
    return d.incomingById.forEach(function(p, m) {
      var v = p.storeObject, b = p.mergeTree, k = p.fieldNodeSet, I = ot(m);
      if (b && b.map.size) {
        var _ = n.applyMerges(b, I, v, d);
        if (U(_))
          return;
        v = _;
      }
      if (__DEV__ && !d.overwrite) {
        var S = /* @__PURE__ */ Object.create(null);
        k.forEach(function(D) {
          D.selectionSet && (S[D.name.value] = !0);
        });
        var N = function(D) {
          return S[Le(D)] === !0;
        }, j = function(D) {
          var R = b && b.map.get(D);
          return !!(R && R.info && R.info.merge);
        };
        Object.keys(v).forEach(function(D) {
          N(D) && !j(D) && $u(I, v, D, d.store);
        });
      }
      e.merge(m, v);
    }), e.retain(h.__ref), h;
  }, r.prototype.processSelectionSet = function(e) {
    var t = this, n = e.dataId, i = e.result, a = e.selectionSet, s = e.context, o = e.mergeTree, c = this.cache.policies, u = /* @__PURE__ */ Object.create(null), f = n && c.rootTypenamesById[n] || $r(i, a, s.fragmentMap) || n && s.store.get(n, "__typename");
    typeof f == "string" && (u.__typename = f);
    var d = function() {
      var _ = Bn(arguments, u, s.variables);
      if (U(_.from)) {
        var S = s.incomingById.get(_.from.__ref);
        if (S) {
          var N = c.readField(y(y({}, _), { from: S.storeObject }), s);
          if (N !== void 0)
            return N;
        }
      }
      return c.readField(_, s);
    }, h = /* @__PURE__ */ new Set();
    this.flattenFields(a, i, s, f).forEach(function(_, S) {
      var N, j = Je(S), D = i[j];
      if (h.add(S), D !== void 0) {
        var R = c.getStoreFieldName({
          typename: f,
          fieldName: S.name.value,
          field: S,
          variables: _.variables
        }), z = Vi(o, R), Z = t.processFieldValue(D, S, S.selectionSet ? Mr(_, !1, !1) : _, z), _e = void 0;
        S.selectionSet && (U(Z) || it(Z)) && (_e = d("__typename", Z));
        var De = c.getMergeFunction(f, S.name.value, _e);
        De ? z.info = {
          field: S,
          typename: f,
          merge: De
        } : Li(o, R), u = _.merge(u, (N = {}, N[R] = Z, N));
      } else __DEV__ && !_.clientOnly && !_.deferred && !xn.added(S) && !c.getReadFunction(f, S.name.value) && __DEV__ && E.error("Missing field '".concat(Je(S), "' while writing result ").concat(JSON.stringify(i, null, 2)).substring(0, 1e3));
    });
    try {
      var p = c.identify(i, {
        typename: f,
        selectionSet: a,
        fragmentMap: s.fragmentMap,
        storeObject: u,
        readField: d
      }), m = p[0], v = p[1];
      n = n || m, v && (u = s.merge(u, v));
    } catch (_) {
      if (!n)
        throw _;
    }
    if (typeof n == "string") {
      var b = ot(n), k = s.written[n] || (s.written[n] = []);
      if (k.indexOf(a) >= 0 || (k.push(a), this.reader && this.reader.isFresh(i, b, a, s)))
        return b;
      var I = s.incomingById.get(n);
      return I ? (I.storeObject = s.merge(I.storeObject, u), I.mergeTree = ln(I.mergeTree, o), h.forEach(function(_) {
        return I.fieldNodeSet.add(_);
      })) : s.incomingById.set(n, {
        storeObject: u,
        mergeTree: or(o) ? void 0 : o,
        fieldNodeSet: h
      }), b;
    }
    return u;
  }, r.prototype.processFieldValue = function(e, t, n, i) {
    var a = this;
    return !t.selectionSet || e === null ? __DEV__ ? Cn(e) : e : ee(e) ? e.map(function(s, o) {
      var c = a.processFieldValue(s, t, n, Vi(i, o));
      return Li(i, o), c;
    }) : this.processSelectionSet({
      result: e,
      selectionSet: t.selectionSet,
      context: n,
      mergeTree: i
    });
  }, r.prototype.flattenFields = function(e, t, n, i) {
    i === void 0 && (i = $r(t, e, n.fragmentMap));
    var a = /* @__PURE__ */ new Map(), s = this.cache.policies, o = new $t(!1);
    return function c(u, f) {
      var d = o.lookup(u, f.clientOnly, f.deferred);
      d.visited || (d.visited = !0, u.selections.forEach(function(h) {
        if (vr(h, n.variables)) {
          var p = f.clientOnly, m = f.deferred;
          if (!(p && m) && Ee(h.directives) && h.directives.forEach(function(k) {
            var I = k.name.value;
            if (I === "client" && (p = !0), I === "defer") {
              var _ = mr(k, n.variables);
              (!_ || _.if !== !1) && (m = !0);
            }
          }), je(h)) {
            var v = a.get(h);
            v && (p = p && v.clientOnly, m = m && v.deferred), a.set(h, Mr(n, p, m));
          } else {
            var b = wn(h, n.lookupFragment);
            if (!b && h.kind === Ji.FRAGMENT_SPREAD)
              throw __DEV__ ? new B("No fragment named ".concat(h.name.value)) : new B(8);
            b && s.fragmentMatches(b, i, t, n.variables) && c(b.selectionSet, Mr(n, p, m));
          }
        }
      }));
    }(e, n), a;
  }, r.prototype.applyMerges = function(e, t, n, i, a) {
    var s, o = this;
    if (e.map.size && !U(n)) {
      var c = !ee(n) && (U(t) || it(t)) ? t : void 0, u = n;
      c && !a && (a = [U(c) ? c.__ref : c]);
      var f, d = function(h, p) {
        return ee(h) ? typeof p == "number" ? h[p] : void 0 : i.store.getFieldValue(h, String(p));
      };
      e.map.forEach(function(h, p) {
        var m = d(c, p), v = d(u, p);
        if (v !== void 0) {
          a && a.push(p);
          var b = o.applyMerges(h, m, v, i, a);
          b !== v && (f = f || /* @__PURE__ */ new Map(), f.set(p, b)), a && E(a.pop() === p);
        }
      }), f && (n = ee(u) ? u.slice(0) : y({}, u), f.forEach(function(h, p) {
        n[p] = h;
      }));
    }
    return e.info ? this.cache.policies.runMergeFunction(t, n, e.info, i, a && (s = i.store).getStorage.apply(s, a)) : n;
  }, r;
}(), Pa = [];
function Vi(r, e) {
  var t = r.map;
  return t.has(e) || t.set(e, Pa.pop() || { map: /* @__PURE__ */ new Map() }), t.get(e);
}
function ln(r, e) {
  if (r === e || !e || or(e))
    return r;
  if (!r || or(r))
    return e;
  var t = r.info && e.info ? y(y({}, r.info), e.info) : r.info || e.info, n = r.map.size && e.map.size, i = n ? /* @__PURE__ */ new Map() : r.map.size ? r.map : e.map, a = { info: t, map: i };
  if (n) {
    var s = new Set(e.map.keys());
    r.map.forEach(function(o, c) {
      a.map.set(c, ln(o, e.map.get(c))), s.delete(c);
    }), s.forEach(function(o) {
      a.map.set(o, ln(e.map.get(o), r.map.get(o)));
    });
  }
  return a;
}
function or(r) {
  return !r || !(r.info || r.map.size);
}
function Li(r, e) {
  var t = r.map, n = t.get(e);
  n && or(n) && (Pa.push(n), t.delete(e));
}
var qi = /* @__PURE__ */ new Set();
function $u(r, e, t, n) {
  var i = function(d) {
    var h = n.getFieldValue(d, t);
    return typeof h == "object" && h;
  }, a = i(r);
  if (a) {
    var s = i(e);
    if (s && !U(a) && !re(a, s) && !Object.keys(a).every(function(d) {
      return n.getFieldValue(s, d) !== void 0;
    })) {
      var o = n.getFieldValue(r, "__typename") || n.getFieldValue(e, "__typename"), c = Le(t), u = "".concat(o, ".").concat(c);
      if (!qi.has(u)) {
        qi.add(u);
        var f = [];
        !ee(a) && !ee(s) && [a, s].forEach(function(d) {
          var h = n.getFieldValue(d, "__typename");
          typeof h == "string" && !f.includes(h) && f.push(h);
        }), __DEV__ && E.warn("Cache data may be lost when replacing the ".concat(c, " field of a ").concat(o, ` object.

To address this problem (which is not a bug in Apollo Client), `).concat(f.length ? "either ensure all objects of type " + f.join(" and ") + " have an ID or a custom merge function, or " : "", "define a custom merge function for the ").concat(u, ` field, so InMemoryCache can safely merge these objects:

  existing: `).concat(JSON.stringify(a).slice(0, 1e3), `
  incoming: `).concat(JSON.stringify(s).slice(0, 1e3), `

For more information about these options, please refer to the documentation:

  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers
  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects
`));
      }
    }
  }
}
var Wu = function(r) {
  be(e, r);
  function e(t) {
    t === void 0 && (t = {});
    var n = r.call(this) || this;
    return n.watches = /* @__PURE__ */ new Set(), n.typenameDocumentCache = /* @__PURE__ */ new Map(), n.makeVar = Qu, n.txCount = 0, n.config = Du(t), n.addTypename = !!n.config.addTypename, n.policies = new Uu({
      cache: n,
      dataIdFromObject: n.config.dataIdFromObject,
      possibleTypes: n.config.possibleTypes,
      typePolicies: n.config.typePolicies
    }), n.init(), n;
  }
  return e.prototype.init = function() {
    var t = this.data = new Rt.Root({
      policies: this.policies,
      resultCaching: this.config.resultCaching
    });
    this.optimisticData = t.stump, this.resetResultCache();
  }, e.prototype.resetResultCache = function(t) {
    var n = this, i = this.storeReader, a = this.config.fragments;
    this.storeWriter = new zu(this, this.storeReader = new Nu({
      cache: this,
      addTypename: this.addTypename,
      resultCacheMaxSize: this.config.resultCacheMaxSize,
      canonizeResults: Ta(this.config),
      canon: t ? void 0 : i && i.canon,
      fragments: a
    }), a), this.maybeBroadcastWatch = sr(function(s, o) {
      return n.broadcastWatch(s, o);
    }, {
      max: this.config.resultCacheMaxSize,
      makeCacheKey: function(s) {
        var o = s.optimistic ? n.optimisticData : n.data;
        if (Tt(o)) {
          var c = s.optimistic, u = s.id, f = s.variables;
          return o.makeCacheKey(s.query, s.callback, We({ optimistic: c, id: u, variables: f }));
        }
      }
    }), (/* @__PURE__ */ new Set([
      this.data.group,
      this.optimisticData.group
    ])).forEach(function(s) {
      return s.resetCaching();
    });
  }, e.prototype.restore = function(t) {
    return this.init(), t && this.data.replace(t), this;
  }, e.prototype.extract = function(t) {
    return t === void 0 && (t = !1), (t ? this.optimisticData : this.data).extract();
  }, e.prototype.read = function(t) {
    var n = t.returnPartialData, i = n === void 0 ? !1 : n;
    try {
      return this.storeReader.diffQueryAgainstStore(y(y({}, t), { store: t.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: i })).result || null;
    } catch (a) {
      if (a instanceof Sa)
        return null;
      throw a;
    }
  }, e.prototype.write = function(t) {
    try {
      return ++this.txCount, this.storeWriter.writeToStore(this.data, t);
    } finally {
      !--this.txCount && t.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.modify = function(t) {
    if (te.call(t, "id") && !t.id)
      return !1;
    var n = t.optimistic ? this.optimisticData : this.data;
    try {
      return ++this.txCount, n.modify(t.id || "ROOT_QUERY", t.fields);
    } finally {
      !--this.txCount && t.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.diff = function(t) {
    return this.storeReader.diffQueryAgainstStore(y(y({}, t), { store: t.optimistic ? this.optimisticData : this.data, rootId: t.id || "ROOT_QUERY", config: this.config }));
  }, e.prototype.watch = function(t) {
    var n = this;
    return this.watches.size || qu(this), this.watches.add(t), t.immediate && this.maybeBroadcastWatch(t), function() {
      n.watches.delete(t) && !n.watches.size && Ri(n), n.maybeBroadcastWatch.forget(t);
    };
  }, e.prototype.gc = function(t) {
    We.reset();
    var n = this.optimisticData.gc();
    return t && !this.txCount && (t.resetResultCache ? this.resetResultCache(t.resetResultIdentities) : t.resetResultIdentities && this.storeReader.resetCanon()), n;
  }, e.prototype.retain = function(t, n) {
    return (n ? this.optimisticData : this.data).retain(t);
  }, e.prototype.release = function(t, n) {
    return (n ? this.optimisticData : this.data).release(t);
  }, e.prototype.identify = function(t) {
    if (U(t))
      return t.__ref;
    try {
      return this.policies.identify(t)[0];
    } catch (n) {
      __DEV__ && E.warn(n);
    }
  }, e.prototype.evict = function(t) {
    if (!t.id) {
      if (te.call(t, "id"))
        return !1;
      t = y(y({}, t), { id: "ROOT_QUERY" });
    }
    try {
      return ++this.txCount, this.optimisticData.evict(t, this.data);
    } finally {
      !--this.txCount && t.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.reset = function(t) {
    var n = this;
    return this.init(), We.reset(), t && t.discardWatches ? (this.watches.forEach(function(i) {
      return n.maybeBroadcastWatch.forget(i);
    }), this.watches.clear(), Ri(this)) : this.broadcastWatches(), Promise.resolve();
  }, e.prototype.removeOptimistic = function(t) {
    var n = this.optimisticData.removeLayer(t);
    n !== this.optimisticData && (this.optimisticData = n, this.broadcastWatches());
  }, e.prototype.batch = function(t) {
    var n = this, i = t.update, a = t.optimistic, s = a === void 0 ? !0 : a, o = t.removeOptimistic, c = t.onWatchUpdated, u, f = function(h) {
      var p = n, m = p.data, v = p.optimisticData;
      ++n.txCount, h && (n.data = n.optimisticData = h);
      try {
        return u = i(n);
      } finally {
        --n.txCount, n.data = m, n.optimisticData = v;
      }
    }, d = /* @__PURE__ */ new Set();
    return c && !this.txCount && this.broadcastWatches(y(y({}, t), { onWatchUpdated: function(h) {
      return d.add(h), !1;
    } })), typeof s == "string" ? this.optimisticData = this.optimisticData.addLayer(s, f) : s === !1 ? f(this.data) : f(), typeof o == "string" && (this.optimisticData = this.optimisticData.removeLayer(o)), c && d.size ? (this.broadcastWatches(y(y({}, t), { onWatchUpdated: function(h, p) {
      var m = c.call(this, h, p);
      return m !== !1 && d.delete(h), m;
    } })), d.size && d.forEach(function(h) {
      return n.maybeBroadcastWatch.dirty(h);
    })) : this.broadcastWatches(t), u;
  }, e.prototype.performTransaction = function(t, n) {
    return this.batch({
      update: t,
      optimistic: n || n !== null
    });
  }, e.prototype.transformDocument = function(t) {
    if (this.addTypename) {
      var n = this.typenameDocumentCache.get(t);
      return n || (n = xn(t), this.typenameDocumentCache.set(t, n), this.typenameDocumentCache.set(n, n)), n;
    }
    return t;
  }, e.prototype.transformForLink = function(t) {
    var n = this.config.fragments;
    return n ? n.transform(t) : t;
  }, e.prototype.broadcastWatches = function(t) {
    var n = this;
    this.txCount || this.watches.forEach(function(i) {
      return n.maybeBroadcastWatch(i, t);
    });
  }, e.prototype.broadcastWatch = function(t, n) {
    var i = t.lastDiff, a = this.diff(t);
    n && (t.optimistic && typeof n.optimistic == "string" && (a.fromOptimisticTransaction = !0), n.onWatchUpdated && n.onWatchUpdated.call(this, t, a, i) === !1) || (!i || !re(i.result, a.result)) && t.callback(t.lastDiff = a, i);
  }, e;
}(Tu);
function Gu(r) {
  return r.hasOwnProperty("graphQLErrors");
}
var Ju = function(r) {
  var e = "";
  if (Ee(r.graphQLErrors) || Ee(r.clientErrors)) {
    var t = (r.graphQLErrors || []).concat(r.clientErrors || []);
    t.forEach(function(n) {
      var i = n ? n.message : "Error message not found.";
      e += "".concat(i, `
`);
    });
  }
  return r.networkError && (e += "".concat(r.networkError.message, `
`)), e = e.replace(/\n$/, ""), e;
}, ze = function(r) {
  be(e, r);
  function e(t) {
    var n = t.graphQLErrors, i = t.clientErrors, a = t.networkError, s = t.errorMessage, o = t.extraInfo, c = r.call(this, s) || this;
    return c.graphQLErrors = n || [], c.clientErrors = i || [], c.networkError = a || null, c.message = s || Ju(c), c.extraInfo = o, c.__proto__ = e.prototype, c;
  }
  return e;
}(Error), W;
(function(r) {
  r[r.loading = 1] = "loading", r[r.setVariables = 2] = "setVariables", r[r.fetchMore = 3] = "fetchMore", r[r.refetch = 4] = "refetch", r[r.poll = 6] = "poll", r[r.ready = 7] = "ready", r[r.error = 8] = "error";
})(W || (W = {}));
function jt(r) {
  return r ? r < 7 : !1;
}
var Hu = Object.assign, Yu = Object.hasOwnProperty, fn = function(r) {
  be(e, r);
  function e(t) {
    var n = t.queryManager, i = t.queryInfo, a = t.options, s = r.call(this, function(b) {
      try {
        var k = b._subscription._observer;
        k && !k.error && (k.error = Ku);
      } catch {
      }
      var I = !s.observers.size;
      s.observers.add(b);
      var _ = s.last;
      return _ && _.error ? b.error && b.error(_.error) : _ && _.result && b.next && b.next(_.result), I && s.reobserve().catch(function() {
      }), function() {
        s.observers.delete(b) && !s.observers.size && s.tearDownQuery();
      };
    }) || this;
    s.observers = /* @__PURE__ */ new Set(), s.subscriptions = /* @__PURE__ */ new Set(), s.queryInfo = i, s.queryManager = n, s.isTornDown = !1;
    var o = n.defaultOptions.watchQuery, c = o === void 0 ? {} : o, u = c.fetchPolicy, f = u === void 0 ? "cache-first" : u, d = a.fetchPolicy, h = d === void 0 ? f : d, p = a.initialFetchPolicy, m = p === void 0 ? h === "standby" ? f : h : p;
    s.options = y(y({}, a), { initialFetchPolicy: m, fetchPolicy: h }), s.queryId = i.queryId || n.generateQueryId();
    var v = zt(s.query);
    return s.queryName = v && v.name && v.name.value, s;
  }
  return Object.defineProperty(e.prototype, "query", {
    get: function() {
      return this.queryManager.transform(this.options.query).document;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "variables", {
    get: function() {
      return this.options.variables;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.result = function() {
    var t = this;
    return new Promise(function(n, i) {
      var a = {
        next: function(o) {
          n(o), t.observers.delete(a), t.observers.size || t.queryManager.removeQuery(t.queryId), setTimeout(function() {
            s.unsubscribe();
          }, 0);
        },
        error: i
      }, s = t.subscribe(a);
    });
  }, e.prototype.getCurrentResult = function(t) {
    t === void 0 && (t = !0);
    var n = this.getLastResult(!0), i = this.queryInfo.networkStatus || n && n.networkStatus || W.ready, a = y(y({}, n), { loading: jt(i), networkStatus: i }), s = this.options.fetchPolicy, o = s === void 0 ? "cache-first" : s;
    if (!(o === "network-only" || o === "no-cache" || o === "standby" || this.queryManager.transform(this.options.query).hasForcedResolvers)) {
      var c = this.queryInfo.getDiff();
      (c.complete || this.options.returnPartialData) && (a.data = c.result), re(a.data, {}) && (a.data = void 0), c.complete ? (delete a.partial, c.complete && a.networkStatus === W.loading && (o === "cache-first" || o === "cache-only") && (a.networkStatus = W.ready, a.loading = !1)) : a.partial = !0, __DEV__ && !c.complete && !this.options.partialRefetch && !a.loading && !a.data && !a.error && Ma(c.missing);
    }
    return t && this.updateLastResult(a), a;
  }, e.prototype.isDifferentFromLastResult = function(t) {
    return !this.last || !re(this.last.result, t);
  }, e.prototype.getLast = function(t, n) {
    var i = this.last;
    if (i && i[t] && (!n || re(i.variables, this.variables)))
      return i[t];
  }, e.prototype.getLastResult = function(t) {
    return this.getLast("result", t);
  }, e.prototype.getLastError = function(t) {
    return this.getLast("error", t);
  }, e.prototype.resetLastResults = function() {
    delete this.last, this.isTornDown = !1;
  }, e.prototype.resetQueryStoreErrors = function() {
    this.queryManager.resetErrors(this.queryId);
  }, e.prototype.refetch = function(t) {
    var n, i = {
      pollInterval: 0
    }, a = this.options.fetchPolicy;
    if (a === "cache-and-network" ? i.fetchPolicy = a : a === "no-cache" ? i.fetchPolicy = "no-cache" : i.fetchPolicy = "network-only", __DEV__ && t && Yu.call(t, "variables")) {
      var s = ta(this.query), o = s.variableDefinitions;
      (!o || !o.some(function(c) {
        return c.variable.name.value === "variables";
      })) && __DEV__ && E.warn("Called refetch(".concat(JSON.stringify(t), ") for query ").concat(((n = s.name) === null || n === void 0 ? void 0 : n.value) || JSON.stringify(s), `, which does not declare a $variables variable.
Did you mean to call refetch(variables) instead of refetch({ variables })?`));
    }
    return t && !re(this.options.variables, t) && (i.variables = this.options.variables = y(y({}, this.options.variables), t)), this.queryInfo.resetLastWrite(), this.reobserve(i, W.refetch);
  }, e.prototype.fetchMore = function(t) {
    var n = this, i = y(y({}, t.query ? t : y(y(y(y({}, this.options), { query: this.query }), t), { variables: y(y({}, this.options.variables), t.variables) })), { fetchPolicy: "no-cache" }), a = this.queryManager.generateQueryId(), s = this.queryInfo, o = s.networkStatus;
    s.networkStatus = W.fetchMore, i.notifyOnNetworkStatusChange && this.observe();
    var c = /* @__PURE__ */ new Set();
    return this.queryManager.fetchQuery(a, i, W.fetchMore).then(function(u) {
      return n.queryManager.removeQuery(a), s.networkStatus === W.fetchMore && (s.networkStatus = o), n.queryManager.cache.batch({
        update: function(f) {
          var d = t.updateQuery;
          d ? f.updateQuery({
            query: n.query,
            variables: n.variables,
            returnPartialData: !0,
            optimistic: !1
          }, function(h) {
            return d(h, {
              fetchMoreResult: u.data,
              variables: i.variables
            });
          }) : f.writeQuery({
            query: i.query,
            variables: i.variables,
            data: u.data
          });
        },
        onWatchUpdated: function(f) {
          c.add(f.query);
        }
      }), u;
    }).finally(function() {
      c.has(n.query) || Fa(n);
    });
  }, e.prototype.subscribeToMore = function(t) {
    var n = this, i = this.queryManager.startGraphQLSubscription({
      query: t.document,
      variables: t.variables,
      context: t.context
    }).subscribe({
      next: function(a) {
        var s = t.updateQuery;
        s && n.updateQuery(function(o, c) {
          var u = c.variables;
          return s(o, {
            subscriptionData: a,
            variables: u
          });
        });
      },
      error: function(a) {
        if (t.onError) {
          t.onError(a);
          return;
        }
        __DEV__ && E.error("Unhandled GraphQL subscription error", a);
      }
    });
    return this.subscriptions.add(i), function() {
      n.subscriptions.delete(i) && i.unsubscribe();
    };
  }, e.prototype.setOptions = function(t) {
    return this.reobserve(t);
  }, e.prototype.setVariables = function(t) {
    return re(this.variables, t) ? this.observers.size ? this.result() : Promise.resolve() : (this.options.variables = t, this.observers.size ? this.reobserve({
      fetchPolicy: this.options.initialFetchPolicy,
      variables: t
    }, W.setVariables) : Promise.resolve());
  }, e.prototype.updateQuery = function(t) {
    var n = this.queryManager, i = n.cache.diff({
      query: this.options.query,
      variables: this.variables,
      returnPartialData: !0,
      optimistic: !1
    }).result, a = t(i, {
      variables: this.variables
    });
    a && (n.cache.writeQuery({
      query: this.options.query,
      data: a,
      variables: this.variables
    }), n.broadcastQueries());
  }, e.prototype.startPolling = function(t) {
    this.options.pollInterval = t, this.updatePolling();
  }, e.prototype.stopPolling = function() {
    this.options.pollInterval = 0, this.updatePolling();
  }, e.prototype.applyNextFetchPolicy = function(t, n) {
    if (n.nextFetchPolicy) {
      var i = n.fetchPolicy, a = i === void 0 ? "cache-first" : i, s = n.initialFetchPolicy, o = s === void 0 ? a : s;
      a === "standby" || (typeof n.nextFetchPolicy == "function" ? n.fetchPolicy = n.nextFetchPolicy(a, {
        reason: t,
        options: n,
        observable: this,
        initialFetchPolicy: o
      }) : t === "variables-changed" ? n.fetchPolicy = o : n.fetchPolicy = n.nextFetchPolicy);
    }
    return n.fetchPolicy;
  }, e.prototype.fetch = function(t, n) {
    return this.queryManager.setObservableQuery(this), this.queryManager.fetchQueryObservable(this.queryId, t, n);
  }, e.prototype.updatePolling = function() {
    var t = this;
    if (!this.queryManager.ssrMode) {
      var n = this, i = n.pollingInfo, a = n.options.pollInterval;
      if (!a) {
        i && (clearTimeout(i.timeout), delete this.pollingInfo);
        return;
      }
      if (!(i && i.interval === a)) {
        __DEV__ ? E(a, "Attempted to start a polling query without a polling interval.") : E(a, 12);
        var s = i || (this.pollingInfo = {});
        s.interval = a;
        var o = function() {
          t.pollingInfo && (jt(t.queryInfo.networkStatus) ? c() : t.reobserve({
            fetchPolicy: t.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
          }, W.poll).then(c, c));
        }, c = function() {
          var u = t.pollingInfo;
          u && (clearTimeout(u.timeout), u.timeout = setTimeout(o, u.interval));
        };
        c();
      }
    }
  }, e.prototype.updateLastResult = function(t, n) {
    return n === void 0 && (n = this.variables), this.last = y(y({}, this.last), { result: this.queryManager.assumeImmutableResults ? t : Cn(t), variables: n }), Ee(t.errors) || delete this.last.error, this.last;
  }, e.prototype.reobserve = function(t, n) {
    var i = this;
    this.isTornDown = !1;
    var a = n === W.refetch || n === W.fetchMore || n === W.poll, s = this.options.variables, o = this.options.fetchPolicy, c = wr(this.options, t || {}), u = a ? c : Hu(this.options, c);
    a || (this.updatePolling(), t && t.variables && !re(t.variables, s) && u.fetchPolicy !== "standby" && u.fetchPolicy === o && (this.applyNextFetchPolicy("variables-changed", u), n === void 0 && (n = W.setVariables)));
    var f = u.variables && y({}, u.variables), d = this.fetch(u, n), h = {
      next: function(p) {
        i.reportResult(p, f);
      },
      error: function(p) {
        i.reportError(p, f);
      }
    };
    return a || (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = d, this.observer = h), d.addObserver(h), d.promise;
  }, e.prototype.observe = function() {
    this.reportResult(this.getCurrentResult(!1), this.variables);
  }, e.prototype.reportResult = function(t, n) {
    var i = this.getLastError();
    (i || this.isDifferentFromLastResult(t)) && ((i || !t.partial || this.options.returnPartialData) && this.updateLastResult(t, n), xt(this.observers, "next", t));
  }, e.prototype.reportError = function(t, n) {
    var i = y(y({}, this.getLastResult()), { error: t, errors: t.graphQLErrors, networkStatus: W.error, loading: !1 });
    this.updateLastResult(i, n), xt(this.observers, "error", this.last.error = t);
  }, e.prototype.hasObservers = function() {
    return this.observers.size > 0;
  }, e.prototype.tearDownQuery = function() {
    this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(t) {
      return t.unsubscribe();
    }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
  }, e;
}(G);
ca(fn);
function Fa(r) {
  var e = r.options, t = e.fetchPolicy, n = e.nextFetchPolicy;
  return t === "cache-and-network" || t === "network-only" ? r.reobserve({
    fetchPolicy: "cache-first",
    nextFetchPolicy: function() {
      return this.nextFetchPolicy = n, typeof n == "function" ? n.apply(this, arguments) : t;
    }
  }) : r.reobserve();
}
function Ku(r) {
  __DEV__ && E.error("Unhandled error", r.message, r.stack);
}
function Ma(r) {
  __DEV__ && r && __DEV__ && E.debug("Missing cache result fields: ".concat(JSON.stringify(r)), r);
}
var Va = function() {
  function r(e) {
    var t = e.cache, n = e.client, i = e.resolvers, a = e.fragmentMatcher;
    this.cache = t, n && (this.client = n), i && this.addResolvers(i), a && this.setFragmentMatcher(a);
  }
  return r.prototype.addResolvers = function(e) {
    var t = this;
    this.resolvers = this.resolvers || {}, Array.isArray(e) ? e.forEach(function(n) {
      t.resolvers = ii(t.resolvers, n);
    }) : this.resolvers = ii(this.resolvers, e);
  }, r.prototype.setResolvers = function(e) {
    this.resolvers = {}, this.addResolvers(e);
  }, r.prototype.getResolvers = function() {
    return this.resolvers || {};
  }, r.prototype.runResolvers = function(e) {
    var t = e.document, n = e.remoteResult, i = e.context, a = e.variables, s = e.onlyRunForcedResolvers, o = s === void 0 ? !1 : s;
    return Fe(this, void 0, void 0, function() {
      return Me(this, function(c) {
        return t ? [2, this.resolveDocument(t, n.data, i, a, this.fragmentMatcher, o).then(function(u) {
          return y(y({}, n), { data: u.result });
        })] : [2, n];
      });
    });
  }, r.prototype.setFragmentMatcher = function(e) {
    this.fragmentMatcher = e;
  }, r.prototype.getFragmentMatcher = function() {
    return this.fragmentMatcher;
  }, r.prototype.clientQuery = function(e) {
    return bn(["client"], e) && this.resolvers ? e : null;
  }, r.prototype.serverQuery = function(e) {
    return uo(e);
  }, r.prototype.prepareContext = function(e) {
    var t = this.cache;
    return y(y({}, e), { cache: t, getCacheKey: function(n) {
      return t.identify(n);
    } });
  }, r.prototype.addExportedVariables = function(e, t, n) {
    return t === void 0 && (t = {}), n === void 0 && (n = {}), Fe(this, void 0, void 0, function() {
      return Me(this, function(i) {
        return e ? [2, this.resolveDocument(e, this.buildRootValueFromCache(e, t) || {}, this.prepareContext(n), t).then(function(a) {
          return y(y({}, t), a.exportedVariables);
        })] : [2, y({}, t)];
      });
    });
  }, r.prototype.shouldForceResolvers = function(e) {
    var t = !1;
    return Te(e, {
      Directive: {
        enter: function(n) {
          if (n.name.value === "client" && n.arguments && (t = n.arguments.some(function(i) {
            return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
          }), t))
            return gn;
        }
      }
    }), t;
  }, r.prototype.buildRootValueFromCache = function(e, t) {
    return this.cache.diff({
      query: oo(e),
      variables: t,
      returnPartialData: !0,
      optimistic: !1
    }).result;
  }, r.prototype.resolveDocument = function(e, t, n, i, a, s) {
    return n === void 0 && (n = {}), i === void 0 && (i = {}), a === void 0 && (a = function() {
      return !0;
    }), s === void 0 && (s = !1), Fe(this, void 0, void 0, function() {
      var o, c, u, f, d, h, p, m, v;
      return Me(this, function(b) {
        return o = br(e), c = En(e), u = _n(c), f = o.operation, d = f ? f.charAt(0).toUpperCase() + f.slice(1) : "Query", h = this, p = h.cache, m = h.client, v = {
          fragmentMap: u,
          context: y(y({}, n), { cache: p, client: m }),
          variables: i,
          fragmentMatcher: a,
          defaultOperationType: d,
          exportedVariables: {},
          onlyRunForcedResolvers: s
        }, [2, this.resolveSelectionSet(o.selectionSet, t, v).then(function(k) {
          return {
            result: k,
            exportedVariables: v.exportedVariables
          };
        })];
      });
    });
  }, r.prototype.resolveSelectionSet = function(e, t, n) {
    return Fe(this, void 0, void 0, function() {
      var i, a, s, o, c, u = this;
      return Me(this, function(f) {
        return i = n.fragmentMap, a = n.context, s = n.variables, o = [t], c = function(d) {
          return Fe(u, void 0, void 0, function() {
            var h, p;
            return Me(this, function(m) {
              return vr(d, s) ? je(d) ? [2, this.resolveField(d, t, n).then(function(v) {
                var b;
                typeof v < "u" && o.push((b = {}, b[Je(d)] = v, b));
              })] : (ea(d) ? h = d : (h = i[d.name.value], __DEV__ ? E(h, "No fragment named ".concat(d.name.value)) : E(h, 11)), h && h.typeCondition && (p = h.typeCondition.name.value, n.fragmentMatcher(t, p, a)) ? [2, this.resolveSelectionSet(h.selectionSet, t, n).then(function(v) {
                o.push(v);
              })] : [2]) : [2];
            });
          });
        }, [2, Promise.all(e.selections.map(c)).then(function() {
          return Tn(o);
        })];
      });
    });
  }, r.prototype.resolveField = function(e, t, n) {
    return Fe(this, void 0, void 0, function() {
      var i, a, s, o, c, u, f, d, h, p = this;
      return Me(this, function(m) {
        return i = n.variables, a = e.name.value, s = Je(e), o = a !== s, c = t[s] || t[a], u = Promise.resolve(c), (!n.onlyRunForcedResolvers || this.shouldForceResolvers(e)) && (f = t.__typename || n.defaultOperationType, d = this.resolvers && this.resolvers[f], d && (h = d[o ? a : s], h && (u = Promise.resolve(Ln.withValue(this.cache, h, [
          t,
          mr(e, i),
          n.context,
          { field: e, fragmentMap: n.fragmentMap }
        ]))))), [2, u.then(function(v) {
          if (v === void 0 && (v = c), e.directives && e.directives.forEach(function(b) {
            b.name.value === "export" && b.arguments && b.arguments.forEach(function(k) {
              k.name.value === "as" && k.value.kind === "StringValue" && (n.exportedVariables[k.value.value] = v);
            });
          }), !e.selectionSet || v == null)
            return v;
          if (Array.isArray(v))
            return p.resolveSubSelectedArray(e, v, n);
          if (e.selectionSet)
            return p.resolveSelectionSet(e.selectionSet, v, n);
        })];
      });
    });
  }, r.prototype.resolveSubSelectedArray = function(e, t, n) {
    var i = this;
    return Promise.all(t.map(function(a) {
      if (a === null)
        return null;
      if (Array.isArray(a))
        return i.resolveSubSelectedArray(e, a, n);
      if (e.selectionSet)
        return i.resolveSelectionSet(e.selectionSet, a, n);
    }));
  }, r;
}(), at = new (et ? WeakMap : Map)();
function Vr(r, e) {
  var t = r[e];
  typeof t == "function" && (r[e] = function() {
    return at.set(r, (at.get(r) + 1) % 1e15), t.apply(this, arguments);
  });
}
function Qi(r) {
  r.notifyTimeout && (clearTimeout(r.notifyTimeout), r.notifyTimeout = void 0);
}
var Lr = function() {
  function r(e, t) {
    t === void 0 && (t = e.generateQueryId()), this.queryId = t, this.listeners = /* @__PURE__ */ new Set(), this.document = null, this.lastRequestId = 1, this.subscriptions = /* @__PURE__ */ new Set(), this.stopped = !1, this.dirty = !1, this.observableQuery = null;
    var n = this.cache = e.cache;
    at.has(n) || (at.set(n, 0), Vr(n, "evict"), Vr(n, "modify"), Vr(n, "reset"));
  }
  return r.prototype.init = function(e) {
    var t = e.networkStatus || W.loading;
    return this.variables && this.networkStatus !== W.loading && !re(this.variables, e.variables) && (t = W.setVariables), re(e.variables, this.variables) || (this.lastDiff = void 0), Object.assign(this, {
      document: e.document,
      variables: e.variables,
      networkError: null,
      graphQLErrors: this.graphQLErrors || [],
      networkStatus: t
    }), e.observableQuery && this.setObservableQuery(e.observableQuery), e.lastRequestId && (this.lastRequestId = e.lastRequestId), this;
  }, r.prototype.reset = function() {
    Qi(this), this.dirty = !1;
  }, r.prototype.getDiff = function(e) {
    e === void 0 && (e = this.variables);
    var t = this.getDiffOptions(e);
    if (this.lastDiff && re(t, this.lastDiff.options))
      return this.lastDiff.diff;
    this.updateWatch(this.variables = e);
    var n = this.observableQuery;
    if (n && n.options.fetchPolicy === "no-cache")
      return { complete: !1 };
    var i = this.cache.diff(t);
    return this.updateLastDiff(i, t), i;
  }, r.prototype.updateLastDiff = function(e, t) {
    this.lastDiff = e ? {
      diff: e,
      options: t || this.getDiffOptions()
    } : void 0;
  }, r.prototype.getDiffOptions = function(e) {
    var t;
    return e === void 0 && (e = this.variables), {
      query: this.document,
      variables: e,
      returnPartialData: !0,
      optimistic: !0,
      canonizeResults: (t = this.observableQuery) === null || t === void 0 ? void 0 : t.options.canonizeResults
    };
  }, r.prototype.setDiff = function(e) {
    var t = this, n = this.lastDiff && this.lastDiff.diff;
    this.updateLastDiff(e), !this.dirty && !re(n && n.result, e && e.result) && (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
      return t.notify();
    }, 0)));
  }, r.prototype.setObservableQuery = function(e) {
    var t = this;
    e !== this.observableQuery && (this.oqListener && this.listeners.delete(this.oqListener), this.observableQuery = e, e ? (e.queryInfo = this, this.listeners.add(this.oqListener = function() {
      var n = t.getDiff();
      n.fromOptimisticTransaction ? e.observe() : Fa(e);
    })) : delete this.oqListener);
  }, r.prototype.notify = function() {
    var e = this;
    Qi(this), this.shouldNotify() && this.listeners.forEach(function(t) {
      return t(e);
    }), this.dirty = !1;
  }, r.prototype.shouldNotify = function() {
    if (!this.dirty || !this.listeners.size)
      return !1;
    if (jt(this.networkStatus) && this.observableQuery) {
      var e = this.observableQuery.options.fetchPolicy;
      if (e !== "cache-only" && e !== "cache-and-network")
        return !1;
    }
    return !0;
  }, r.prototype.stop = function() {
    if (!this.stopped) {
      this.stopped = !0, this.reset(), this.cancel(), this.cancel = r.prototype.cancel, this.subscriptions.forEach(function(t) {
        return t.unsubscribe();
      });
      var e = this.observableQuery;
      e && e.stopPolling();
    }
  }, r.prototype.cancel = function() {
  }, r.prototype.updateWatch = function(e) {
    var t = this;
    e === void 0 && (e = this.variables);
    var n = this.observableQuery;
    if (!(n && n.options.fetchPolicy === "no-cache")) {
      var i = y(y({}, this.getDiffOptions(e)), { watcher: this, callback: function(a) {
        return t.setDiff(a);
      } });
      (!this.lastWatch || !re(i, this.lastWatch)) && (this.cancel(), this.cancel = this.cache.watch(this.lastWatch = i));
    }
  }, r.prototype.resetLastWrite = function() {
    this.lastWrite = void 0;
  }, r.prototype.shouldWrite = function(e, t) {
    var n = this.lastWrite;
    return !(n && n.dmCount === at.get(this.cache) && re(t, n.variables) && re(e.data, n.result.data));
  }, r.prototype.markResult = function(e, t, n, i) {
    var a = this, s = Ee(e.errors) ? e.errors.slice(0) : [];
    if (this.reset(), "incremental" in e && Ee(e.incremental)) {
      var o = this.getDiff().result, c = new He();
      e.incremental.forEach(function(u) {
        for (var f = u.data, d = u.path, h = u.errors, p = d.length - 1; p >= 0; --p) {
          var m = d[p], v = !isNaN(+m), b = v ? [] : {};
          b[m] = f, f = b;
        }
        h && s.push.apply(s, h), o = c.merge(o, f);
      }), e.data = o;
    }
    this.graphQLErrors = s, n.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: e.data, complete: !0 }, this.getDiffOptions(n.variables)) : i !== 0 && (dn(e, n.errorPolicy) ? this.cache.performTransaction(function(u) {
      if (a.shouldWrite(e, n.variables))
        u.writeQuery({
          query: t,
          data: e.data,
          variables: n.variables,
          overwrite: i === 1
        }), a.lastWrite = {
          result: e,
          variables: n.variables,
          dmCount: at.get(a.cache)
        };
      else if (a.lastDiff && a.lastDiff.diff.complete) {
        e.data = a.lastDiff.diff.result;
        return;
      }
      var f = a.getDiffOptions(n.variables), d = u.diff(f);
      a.stopped || a.updateWatch(n.variables), a.updateLastDiff(d, f), d.complete && (e.data = d.result);
    }) : this.lastWrite = void 0);
  }, r.prototype.markReady = function() {
    return this.networkError = null, this.networkStatus = W.ready;
  }, r.prototype.markError = function(e) {
    return this.networkStatus = W.error, this.lastWrite = void 0, this.reset(), e.graphQLErrors && (this.graphQLErrors = e.graphQLErrors), e.networkError && (this.networkError = e.networkError), e;
  }, r;
}();
function dn(r, e) {
  e === void 0 && (e = "none");
  var t = e === "ignore" || e === "all", n = !rr(r);
  return !n && t && r.data && (n = !0), n;
}
var Xu = Object.prototype.hasOwnProperty, ec = function() {
  function r(e) {
    var t = e.cache, n = e.link, i = e.defaultOptions, a = e.queryDeduplication, s = a === void 0 ? !1 : a, o = e.onBroadcast, c = e.ssrMode, u = c === void 0 ? !1 : c, f = e.clientAwareness, d = f === void 0 ? {} : f, h = e.localState, p = e.assumeImmutableResults;
    this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new (et ? WeakMap : Map)(), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = /* @__PURE__ */ new Map(), this.cache = t, this.link = n, this.defaultOptions = i || /* @__PURE__ */ Object.create(null), this.queryDeduplication = s, this.clientAwareness = d, this.localState = h || new Va({ cache: t }), this.ssrMode = u, this.assumeImmutableResults = !!p, (this.onBroadcast = o) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
  }
  return r.prototype.stop = function() {
    var e = this;
    this.queries.forEach(function(t, n) {
      e.stopQueryNoBroadcast(n);
    }), this.cancelPendingFetches(__DEV__ ? new B("QueryManager stopped while query was in flight") : new B(13));
  }, r.prototype.cancelPendingFetches = function(e) {
    this.fetchCancelFns.forEach(function(t) {
      return t(e);
    }), this.fetchCancelFns.clear();
  }, r.prototype.mutate = function(e) {
    var t, n, i = e.mutation, a = e.variables, s = e.optimisticResponse, o = e.updateQueries, c = e.refetchQueries, u = c === void 0 ? [] : c, f = e.awaitRefetchQueries, d = f === void 0 ? !1 : f, h = e.update, p = e.onQueryUpdated, m = e.fetchPolicy, v = m === void 0 ? ((t = this.defaultOptions.mutate) === null || t === void 0 ? void 0 : t.fetchPolicy) || "network-only" : m, b = e.errorPolicy, k = b === void 0 ? ((n = this.defaultOptions.mutate) === null || n === void 0 ? void 0 : n.errorPolicy) || "none" : b, I = e.keepRootFields, _ = e.context;
    return Fe(this, void 0, void 0, function() {
      var S, N, j, D, R, z;
      return Me(this, function(Z) {
        switch (Z.label) {
          case 0:
            return __DEV__ ? E(i, "mutation option is required. You must specify your GraphQL document in the mutation option.") : E(i, 14), __DEV__ ? E(v === "network-only" || v === "no-cache", "Mutations support only 'network-only' or 'no-cache' fetchPolicy strings. The default `network-only` behavior automatically writes mutation results to the cache. Passing `no-cache` skips the cache write.") : E(v === "network-only" || v === "no-cache", 15), S = this.generateMutationId(), N = this.transform(i), j = N.document, D = N.hasClientExports, i = this.cache.transformForLink(j), a = this.getVariables(i, a), D ? [4, this.localState.addExportedVariables(i, a, _)] : [3, 2];
          case 1:
            a = Z.sent(), Z.label = 2;
          case 2:
            return R = this.mutationStore && (this.mutationStore[S] = {
              mutation: i,
              variables: a,
              loading: !0,
              error: null
            }), s && this.markMutationOptimistic(s, {
              mutationId: S,
              document: i,
              variables: a,
              fetchPolicy: v,
              errorPolicy: k,
              context: _,
              updateQueries: o,
              update: h,
              keepRootFields: I
            }), this.broadcastQueries(), z = this, [2, new Promise(function(_e, De) {
              return Dr(z.getObservableFromLink(i, y(y({}, _), { optimisticResponse: s }), a, !1), function(ue) {
                if (rr(ue) && k === "none")
                  throw new ze({
                    graphQLErrors: ue.errors
                  });
                R && (R.loading = !1, R.error = null);
                var F = y({}, ue);
                return typeof u == "function" && (u = u(F)), k === "ignore" && rr(F) && delete F.errors, z.markMutationResult({
                  mutationId: S,
                  result: F,
                  document: i,
                  variables: a,
                  fetchPolicy: v,
                  errorPolicy: k,
                  context: _,
                  update: h,
                  updateQueries: o,
                  awaitRefetchQueries: d,
                  refetchQueries: u,
                  removeOptimistic: s ? S : void 0,
                  onQueryUpdated: p,
                  keepRootFields: I
                });
              }).subscribe({
                next: function(ue) {
                  z.broadcastQueries(), _e(ue);
                },
                error: function(ue) {
                  R && (R.loading = !1, R.error = ue), s && z.cache.removeOptimistic(S), z.broadcastQueries(), De(ue instanceof ze ? ue : new ze({
                    networkError: ue
                  }));
                }
              });
            })];
        }
      });
    });
  }, r.prototype.markMutationResult = function(e, t) {
    var n = this;
    t === void 0 && (t = this.cache);
    var i = e.result, a = [], s = e.fetchPolicy === "no-cache";
    if (!s && dn(i, e.errorPolicy)) {
      a.push({
        result: i.data,
        dataId: "ROOT_MUTATION",
        query: e.document,
        variables: e.variables
      });
      var o = e.updateQueries;
      o && this.queries.forEach(function(u, f) {
        var d = u.observableQuery, h = d && d.queryName;
        if (!(!h || !Xu.call(o, h))) {
          var p = o[h], m = n.queries.get(f), v = m.document, b = m.variables, k = t.diff({
            query: v,
            variables: b,
            returnPartialData: !0,
            optimistic: !1
          }), I = k.result, _ = k.complete;
          if (_ && I) {
            var S = p(I, {
              mutationResult: i,
              queryName: v && Wr(v) || void 0,
              queryVariables: b
            });
            S && a.push({
              result: S,
              dataId: "ROOT_QUERY",
              query: v,
              variables: b
            });
          }
        }
      });
    }
    if (a.length > 0 || e.refetchQueries || e.update || e.onQueryUpdated || e.removeOptimistic) {
      var c = [];
      if (this.refetchQueries({
        updateCache: function(u) {
          s || a.forEach(function(h) {
            return u.write(h);
          });
          var f = e.update;
          if (f) {
            if (!s) {
              var d = u.diff({
                id: "ROOT_MUTATION",
                query: n.transform(e.document).asQuery,
                variables: e.variables,
                optimistic: !1,
                returnPartialData: !0
              });
              d.complete && !uu(i) && (i = y(y({}, i), { data: d.result }));
            }
            f(u, i, {
              context: e.context,
              variables: e.variables
            });
          }
          !s && !e.keepRootFields && u.modify({
            id: "ROOT_MUTATION",
            fields: function(h, p) {
              var m = p.fieldName, v = p.DELETE;
              return m === "__typename" ? h : v;
            }
          });
        },
        include: e.refetchQueries,
        optimistic: !1,
        removeOptimistic: e.removeOptimistic,
        onQueryUpdated: e.onQueryUpdated || null
      }).forEach(function(u) {
        return c.push(u);
      }), e.awaitRefetchQueries || e.onQueryUpdated)
        return Promise.all(c).then(function() {
          return i;
        });
    }
    return Promise.resolve(i);
  }, r.prototype.markMutationOptimistic = function(e, t) {
    var n = this, i = typeof e == "function" ? e(t.variables) : e;
    return this.cache.recordOptimisticTransaction(function(a) {
      try {
        n.markMutationResult(y(y({}, t), { result: { data: i } }), a);
      } catch (s) {
        __DEV__ && E.error(s);
      }
    }, t.mutationId);
  }, r.prototype.fetchQuery = function(e, t, n) {
    return this.fetchQueryObservable(e, t, n).promise;
  }, r.prototype.getQueryStore = function() {
    var e = /* @__PURE__ */ Object.create(null);
    return this.queries.forEach(function(t, n) {
      e[n] = {
        variables: t.variables,
        networkStatus: t.networkStatus,
        networkError: t.networkError,
        graphQLErrors: t.graphQLErrors
      };
    }), e;
  }, r.prototype.resetErrors = function(e) {
    var t = this.queries.get(e);
    t && (t.networkError = void 0, t.graphQLErrors = []);
  }, r.prototype.transform = function(e) {
    var t = this.transformCache;
    if (!t.has(e)) {
      var n = this.cache.transformDocument(e), i = no(n), a = this.localState.clientQuery(n), s = i && this.localState.serverQuery(i), o = {
        document: n,
        hasClientExports: Vs(n),
        hasForcedResolvers: this.localState.shouldForceResolvers(n),
        clientQuery: a,
        serverQuery: s,
        defaultVars: Sn(zt(n)),
        asQuery: y(y({}, n), { definitions: n.definitions.map(function(u) {
          return u.kind === "OperationDefinition" && u.operation !== "query" ? y(y({}, u), { operation: "query" }) : u;
        }) })
      }, c = function(u) {
        u && !t.has(u) && t.set(u, o);
      };
      c(e), c(n), c(a), c(s);
    }
    return t.get(e);
  }, r.prototype.getVariables = function(e, t) {
    return y(y({}, this.transform(e).defaultVars), t);
  }, r.prototype.watchQuery = function(e) {
    e = y(y({}, e), { variables: this.getVariables(e.query, e.variables) }), typeof e.notifyOnNetworkStatusChange > "u" && (e.notifyOnNetworkStatusChange = !1);
    var t = new Lr(this), n = new fn({
      queryManager: this,
      queryInfo: t,
      options: e
    });
    return this.queries.set(n.queryId, t), t.init({
      document: n.query,
      observableQuery: n,
      variables: n.variables
    }), n;
  }, r.prototype.query = function(e, t) {
    var n = this;
    return t === void 0 && (t = this.generateQueryId()), __DEV__ ? E(e.query, "query option is required. You must specify your GraphQL document in the query option.") : E(e.query, 16), __DEV__ ? E(e.query.kind === "Document", 'You must wrap the query string in a "gql" tag.') : E(e.query.kind === "Document", 17), __DEV__ ? E(!e.returnPartialData, "returnPartialData option only supported on watchQuery.") : E(!e.returnPartialData, 18), __DEV__ ? E(!e.pollInterval, "pollInterval option only supported on watchQuery.") : E(!e.pollInterval, 19), this.fetchQuery(t, e).finally(function() {
      return n.stopQuery(t);
    });
  }, r.prototype.generateQueryId = function() {
    return String(this.queryIdCounter++);
  }, r.prototype.generateRequestId = function() {
    return this.requestIdCounter++;
  }, r.prototype.generateMutationId = function() {
    return String(this.mutationIdCounter++);
  }, r.prototype.stopQueryInStore = function(e) {
    this.stopQueryInStoreNoBroadcast(e), this.broadcastQueries();
  }, r.prototype.stopQueryInStoreNoBroadcast = function(e) {
    var t = this.queries.get(e);
    t && t.stop();
  }, r.prototype.clearStore = function(e) {
    return e === void 0 && (e = {
      discardWatches: !0
    }), this.cancelPendingFetches(__DEV__ ? new B("Store reset while query was in flight (not completed in link chain)") : new B(20)), this.queries.forEach(function(t) {
      t.observableQuery ? t.networkStatus = W.loading : t.stop();
    }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(e);
  }, r.prototype.getObservableQueries = function(e) {
    var t = this;
    e === void 0 && (e = "active");
    var n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set();
    return Array.isArray(e) && e.forEach(function(s) {
      typeof s == "string" ? i.set(s, !1) : Bs(s) ? i.set(t.transform(s).document, !1) : Y(s) && s.query && a.add(s);
    }), this.queries.forEach(function(s, o) {
      var c = s.observableQuery, u = s.document;
      if (c) {
        if (e === "all") {
          n.set(o, c);
          return;
        }
        var f = c.queryName, d = c.options.fetchPolicy;
        if (d === "standby" || e === "active" && !c.hasObservers())
          return;
        (e === "active" || f && i.has(f) || u && i.has(u)) && (n.set(o, c), f && i.set(f, !0), u && i.set(u, !0));
      }
    }), a.size && a.forEach(function(s) {
      var o = Kr("legacyOneTimeQuery"), c = t.getQuery(o).init({
        document: s.query,
        variables: s.variables
      }), u = new fn({
        queryManager: t,
        queryInfo: c,
        options: y(y({}, s), { fetchPolicy: "network-only" })
      });
      E(u.queryId === o), c.setObservableQuery(u), n.set(o, u);
    }), __DEV__ && i.size && i.forEach(function(s, o) {
      s || __DEV__ && E.warn("Unknown query ".concat(typeof o == "string" ? "named " : "").concat(JSON.stringify(o, null, 2), " requested in refetchQueries options.include array"));
    }), n;
  }, r.prototype.reFetchObservableQueries = function(e) {
    var t = this;
    e === void 0 && (e = !1);
    var n = [];
    return this.getObservableQueries(e ? "all" : "active").forEach(function(i, a) {
      var s = i.options.fetchPolicy;
      i.resetLastResults(), (e || s !== "standby" && s !== "cache-only") && n.push(i.refetch()), t.getQuery(a).setDiff(null);
    }), this.broadcastQueries(), Promise.all(n);
  }, r.prototype.setObservableQuery = function(e) {
    this.getQuery(e.queryId).setObservableQuery(e);
  }, r.prototype.startGraphQLSubscription = function(e) {
    var t = this, n = e.query, i = e.fetchPolicy, a = e.errorPolicy, s = e.variables, o = e.context, c = o === void 0 ? {} : o;
    n = this.transform(n).document, s = this.getVariables(n, s);
    var u = function(d) {
      return t.getObservableFromLink(n, c, d).map(function(h) {
        if (i !== "no-cache" && (dn(h, a) && t.cache.write({
          query: n,
          result: h.data,
          dataId: "ROOT_SUBSCRIPTION",
          variables: d
        }), t.broadcastQueries()), rr(h))
          throw new ze({
            graphQLErrors: h.errors
          });
        return h;
      });
    };
    if (this.transform(n).hasClientExports) {
      var f = this.localState.addExportedVariables(n, s, c).then(u);
      return new G(function(d) {
        var h = null;
        return f.then(function(p) {
          return h = p.subscribe(d);
        }, d.error), function() {
          return h && h.unsubscribe();
        };
      });
    }
    return u(s);
  }, r.prototype.stopQuery = function(e) {
    this.stopQueryNoBroadcast(e), this.broadcastQueries();
  }, r.prototype.stopQueryNoBroadcast = function(e) {
    this.stopQueryInStoreNoBroadcast(e), this.removeQuery(e);
  }, r.prototype.removeQuery = function(e) {
    this.fetchCancelFns.delete(e), this.queries.has(e) && (this.getQuery(e).stop(), this.queries.delete(e));
  }, r.prototype.broadcastQueries = function() {
    this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(e) {
      return e.notify();
    });
  }, r.prototype.getLocalState = function() {
    return this.localState;
  }, r.prototype.getObservableFromLink = function(e, t, n, i) {
    var a = this, s;
    i === void 0 && (i = (s = t == null ? void 0 : t.queryDeduplication) !== null && s !== void 0 ? s : this.queryDeduplication);
    var o, c = this.transform(e).serverQuery;
    if (c) {
      var u = this, f = u.inFlightLinkObservables, d = u.link, h = {
        query: c,
        variables: n,
        operationName: Wr(c) || void 0,
        context: this.prepareContext(y(y({}, t), { forceFetch: !i }))
      };
      if (t = h.context, i) {
        var p = f.get(c) || /* @__PURE__ */ new Map();
        f.set(c, p);
        var m = We(n);
        if (o = p.get(m), !o) {
          var v = new Et([
            en(d, h)
          ]);
          p.set(m, o = v), v.beforeNext(function() {
            p.delete(m) && p.size < 1 && f.delete(c);
          });
        }
      } else
        o = new Et([
          en(d, h)
        ]);
    } else
      o = new Et([
        G.of({ data: {} })
      ]), t = this.prepareContext(t);
    var b = this.transform(e).clientQuery;
    return b && (o = Dr(o, function(k) {
      return a.localState.runResolvers({
        document: b,
        remoteResult: k,
        context: t,
        variables: n
      });
    })), o;
  }, r.prototype.getResultsFromLink = function(e, t, n) {
    var i = e.lastRequestId = this.generateRequestId();
    n = Cn(n);
    var a = this.cache.transformForLink(this.transform(e.document).document);
    return Dr(this.getObservableFromLink(a, n.context, n.variables), function(s) {
      var o = Ee(s.errors) ? s.errors.slice(0) : [];
      "incremental" in s && Ee(s.incremental) && s.incremental.forEach(function(f) {
        f.errors && o.push.apply(o, f.errors);
      });
      var c = Ee(o);
      if (i >= e.lastRequestId) {
        if (c && n.errorPolicy === "none")
          throw e.markError(new ze({
            graphQLErrors: o
          }));
        e.markResult(s, a, n, t), e.markReady();
      }
      var u = {
        data: s.data,
        loading: !1,
        networkStatus: W.ready
      };
      return c && n.errorPolicy !== "ignore" && (u.errors = o, u.networkStatus = W.error), u;
    }, function(s) {
      var o = Gu(s) ? s : new ze({ networkError: s });
      throw i >= e.lastRequestId && e.markError(o), o;
    });
  }, r.prototype.fetchQueryObservable = function(e, t, n) {
    var i = this;
    n === void 0 && (n = W.loading);
    var a = this.transform(t.query).document, s = this.getVariables(a, t.variables), o = this.getQuery(e), c = this.defaultOptions.watchQuery, u = t.fetchPolicy, f = u === void 0 ? c && c.fetchPolicy || "cache-first" : u, d = t.errorPolicy, h = d === void 0 ? c && c.errorPolicy || "none" : d, p = t.returnPartialData, m = p === void 0 ? !1 : p, v = t.notifyOnNetworkStatusChange, b = v === void 0 ? !1 : v, k = t.context, I = k === void 0 ? {} : k, _ = Object.assign({}, t, {
      query: a,
      variables: s,
      fetchPolicy: f,
      errorPolicy: h,
      returnPartialData: m,
      notifyOnNetworkStatusChange: b,
      context: I
    }), S = function(D) {
      _.variables = D;
      var R = i.fetchQueryByPolicy(o, _, n);
      return _.fetchPolicy !== "standby" && R.length > 0 && o.observableQuery && o.observableQuery.applyNextFetchPolicy("after-fetch", t), R;
    }, N = function() {
      return i.fetchCancelFns.delete(e);
    };
    this.fetchCancelFns.set(e, function(D) {
      N(), setTimeout(function() {
        return j.cancel(D);
      });
    });
    var j = new Et(this.transform(_.query).hasClientExports ? this.localState.addExportedVariables(_.query, _.variables, _.context).then(S) : S(_.variables));
    return j.promise.then(N, N), j;
  }, r.prototype.refetchQueries = function(e) {
    var t = this, n = e.updateCache, i = e.include, a = e.optimistic, s = a === void 0 ? !1 : a, o = e.removeOptimistic, c = o === void 0 ? s ? Kr("refetchQueries") : void 0 : o, u = e.onQueryUpdated, f = /* @__PURE__ */ new Map();
    i && this.getObservableQueries(i).forEach(function(h, p) {
      f.set(p, {
        oq: h,
        lastDiff: t.getQuery(p).getDiff()
      });
    });
    var d = /* @__PURE__ */ new Map();
    return n && this.cache.batch({
      update: n,
      optimistic: s && c || !1,
      removeOptimistic: c,
      onWatchUpdated: function(h, p, m) {
        var v = h.watcher instanceof Lr && h.watcher.observableQuery;
        if (v) {
          if (u) {
            f.delete(v.queryId);
            var b = u(v, p, m);
            return b === !0 && (b = v.refetch()), b !== !1 && d.set(v, b), b;
          }
          u !== null && f.set(v.queryId, { oq: v, lastDiff: m, diff: p });
        }
      }
    }), f.size && f.forEach(function(h, p) {
      var m = h.oq, v = h.lastDiff, b = h.diff, k;
      if (u) {
        if (!b) {
          var I = m.queryInfo;
          I.reset(), b = I.getDiff();
        }
        k = u(m, b, v);
      }
      (!u || k === !0) && (k = m.refetch()), k !== !1 && d.set(m, k), p.indexOf("legacyOneTimeQuery") >= 0 && t.stopQueryNoBroadcast(p);
    }), c && this.cache.removeOptimistic(c), d;
  }, r.prototype.fetchQueryByPolicy = function(e, t, n) {
    var i = this, a = t.query, s = t.variables, o = t.fetchPolicy, c = t.refetchWritePolicy, u = t.errorPolicy, f = t.returnPartialData, d = t.context, h = t.notifyOnNetworkStatusChange, p = e.networkStatus;
    e.init({
      document: this.transform(a).document,
      variables: s,
      networkStatus: n
    });
    var m = function() {
      return e.getDiff(s);
    }, v = function(S, N) {
      N === void 0 && (N = e.networkStatus || W.loading);
      var j = S.result;
      __DEV__ && !f && !re(j, {}) && Ma(S.missing);
      var D = function(R) {
        return G.of(y({ data: R, loading: jt(N), networkStatus: N }, S.complete ? null : { partial: !0 }));
      };
      return j && i.transform(a).hasForcedResolvers ? i.localState.runResolvers({
        document: a,
        remoteResult: { data: j },
        context: d,
        variables: s,
        onlyRunForcedResolvers: !0
      }).then(function(R) {
        return D(R.data || void 0);
      }) : D(j);
    }, b = o === "no-cache" ? 0 : n === W.refetch && c !== "merge" ? 1 : 2, k = function() {
      return i.getResultsFromLink(e, b, {
        variables: s,
        context: d,
        fetchPolicy: o,
        errorPolicy: u
      });
    }, I = h && typeof p == "number" && p !== n && jt(n);
    switch (o) {
      default:
      case "cache-first": {
        var _ = m();
        return _.complete ? [
          v(_, e.markReady())
        ] : f || I ? [
          v(_),
          k()
        ] : [
          k()
        ];
      }
      case "cache-and-network": {
        var _ = m();
        return _.complete || f || I ? [
          v(_),
          k()
        ] : [
          k()
        ];
      }
      case "cache-only":
        return [
          v(m(), e.markReady())
        ];
      case "network-only":
        return I ? [
          v(m()),
          k()
        ] : [k()];
      case "no-cache":
        return I ? [
          v(e.getDiff()),
          k()
        ] : [k()];
      case "standby":
        return [];
    }
  }, r.prototype.getQuery = function(e) {
    return e && !this.queries.has(e) && this.queries.set(e, new Lr(this, e)), this.queries.get(e);
  }, r.prototype.prepareContext = function(e) {
    e === void 0 && (e = {});
    var t = this.localState.prepareContext(e);
    return y(y({}, t), { clientAwareness: this.clientAwareness });
  }, r;
}(), Bi = !1, tc = function() {
  function r(e) {
    var t = this;
    this.resetStoreCallbacks = [], this.clearStoreCallbacks = [];
    var n = e.uri, i = e.credentials, a = e.headers, s = e.cache, o = e.ssrMode, c = o === void 0 ? !1 : o, u = e.ssrForceFetchDelay, f = u === void 0 ? 0 : u, d = e.connectToDevTools, h = d === void 0 ? typeof window == "object" && !window.__APOLLO_CLIENT__ && __DEV__ : d, p = e.queryDeduplication, m = p === void 0 ? !0 : p, v = e.defaultOptions, b = e.assumeImmutableResults, k = b === void 0 ? !1 : b, I = e.resolvers, _ = e.typeDefs, S = e.fragmentMatcher, N = e.name, j = e.version, D = e.link;
    if (D || (D = n ? new fa({ uri: n, credentials: i, headers: a }) : Ue.empty()), !s)
      throw __DEV__ ? new B(`To initialize Apollo Client, you must specify a 'cache' property in the options object. 
For more information, please visit: https://go.apollo.dev/c/docs`) : new B(9);
    if (this.link = D, this.cache = s, this.disableNetworkFetches = c || f > 0, this.queryDeduplication = m, this.defaultOptions = v || /* @__PURE__ */ Object.create(null), this.typeDefs = _, f && setTimeout(function() {
      return t.disableNetworkFetches = !1;
    }, f), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), h && typeof window == "object" && (window.__APOLLO_CLIENT__ = this), !Bi && __DEV__ && (Bi = !0, typeof window < "u" && window.document && window.top === window.self && !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__)) {
      var R = window.navigator, z = R && R.userAgent, Z = void 0;
      typeof z == "string" && (z.indexOf("Chrome/") > -1 ? Z = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : z.indexOf("Firefox/") > -1 && (Z = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), Z && __DEV__ && E.log("Download the Apollo DevTools for a better development experience: " + Z);
    }
    this.version = jo, this.localState = new Va({
      cache: s,
      client: this,
      resolvers: I,
      fragmentMatcher: S
    }), this.queryManager = new ec({
      cache: this.cache,
      link: this.link,
      defaultOptions: this.defaultOptions,
      queryDeduplication: m,
      ssrMode: c,
      clientAwareness: {
        name: N,
        version: j
      },
      localState: this.localState,
      assumeImmutableResults: k,
      onBroadcast: h ? function() {
        t.devToolsHookCb && t.devToolsHookCb({
          action: {},
          state: {
            queries: t.queryManager.getQueryStore(),
            mutations: t.queryManager.mutationStore || {}
          },
          dataWithOptimisticResults: t.cache.extract(!0)
        });
      } : void 0
    });
  }
  return r.prototype.stop = function() {
    this.queryManager.stop();
  }, r.prototype.watchQuery = function(e) {
    return this.defaultOptions.watchQuery && (e = Ir(this.defaultOptions.watchQuery, e)), this.disableNetworkFetches && (e.fetchPolicy === "network-only" || e.fetchPolicy === "cache-and-network") && (e = y(y({}, e), { fetchPolicy: "cache-first" })), this.queryManager.watchQuery(e);
  }, r.prototype.query = function(e) {
    return this.defaultOptions.query && (e = Ir(this.defaultOptions.query, e)), __DEV__ ? E(e.fetchPolicy !== "cache-and-network", "The cache-and-network fetchPolicy does not work with client.query, because client.query can only return a single result. Please use client.watchQuery to receive multiple results from the cache and the network, or consider using a different fetchPolicy, such as cache-first or network-only.") : E(e.fetchPolicy !== "cache-and-network", 10), this.disableNetworkFetches && e.fetchPolicy === "network-only" && (e = y(y({}, e), { fetchPolicy: "cache-first" })), this.queryManager.query(e);
  }, r.prototype.mutate = function(e) {
    return this.defaultOptions.mutate && (e = Ir(this.defaultOptions.mutate, e)), this.queryManager.mutate(e);
  }, r.prototype.subscribe = function(e) {
    return this.queryManager.startGraphQLSubscription(e);
  }, r.prototype.readQuery = function(e, t) {
    return t === void 0 && (t = !1), this.cache.readQuery(e, t);
  }, r.prototype.readFragment = function(e, t) {
    return t === void 0 && (t = !1), this.cache.readFragment(e, t);
  }, r.prototype.writeQuery = function(e) {
    this.cache.writeQuery(e), this.queryManager.broadcastQueries();
  }, r.prototype.writeFragment = function(e) {
    this.cache.writeFragment(e), this.queryManager.broadcastQueries();
  }, r.prototype.__actionHookForDevTools = function(e) {
    this.devToolsHookCb = e;
  }, r.prototype.__requestRaw = function(e) {
    return en(this.link, e);
  }, r.prototype.resetStore = function() {
    var e = this;
    return Promise.resolve().then(function() {
      return e.queryManager.clearStore({
        discardWatches: !1
      });
    }).then(function() {
      return Promise.all(e.resetStoreCallbacks.map(function(t) {
        return t();
      }));
    }).then(function() {
      return e.reFetchObservableQueries();
    });
  }, r.prototype.clearStore = function() {
    var e = this;
    return Promise.resolve().then(function() {
      return e.queryManager.clearStore({
        discardWatches: !0
      });
    }).then(function() {
      return Promise.all(e.clearStoreCallbacks.map(function(t) {
        return t();
      }));
    });
  }, r.prototype.onResetStore = function(e) {
    var t = this;
    return this.resetStoreCallbacks.push(e), function() {
      t.resetStoreCallbacks = t.resetStoreCallbacks.filter(function(n) {
        return n !== e;
      });
    };
  }, r.prototype.onClearStore = function(e) {
    var t = this;
    return this.clearStoreCallbacks.push(e), function() {
      t.clearStoreCallbacks = t.clearStoreCallbacks.filter(function(n) {
        return n !== e;
      });
    };
  }, r.prototype.reFetchObservableQueries = function(e) {
    return this.queryManager.reFetchObservableQueries(e);
  }, r.prototype.refetchQueries = function(e) {
    var t = this.queryManager.refetchQueries(e), n = [], i = [];
    t.forEach(function(s, o) {
      n.push(o), i.push(s);
    });
    var a = Promise.all(i);
    return a.queries = n, a.results = i, a.catch(function(s) {
      __DEV__ && E.debug("In client.refetchQueries, Promise.all promise rejected with error ".concat(s));
    }), a;
  }, r.prototype.getObservableQueries = function(e) {
    return e === void 0 && (e = "active"), this.queryManager.getObservableQueries(e);
  }, r.prototype.extract = function(e) {
    return this.cache.extract(e);
  }, r.prototype.restore = function(e) {
    return this.cache.restore(e);
  }, r.prototype.addResolvers = function(e) {
    this.localState.addResolvers(e);
  }, r.prototype.setResolvers = function(e) {
    this.localState.setResolvers(e);
  }, r.prototype.getResolvers = function() {
    return this.localState.getResolvers();
  }, r.prototype.setLocalStateFragmentMatcher = function(e) {
    this.localState.setFragmentMatcher(e);
  }, r.prototype.setLink = function(e) {
    this.link = this.queryManager.link = e;
  }, r;
}();
function rc(r) {
  return Y(r) && "code" in r && "reason" in r;
}
var nc = function(r) {
  be(e, r);
  function e(t) {
    var n = r.call(this) || this;
    return n.client = t, n;
  }
  return e.prototype.request = function(t) {
    var n = this;
    return new G(function(i) {
      return n.client.subscribe(y(y({}, t), { query: Xi(t.query) }), {
        next: i.next.bind(i),
        complete: i.complete.bind(i),
        error: function(a) {
          return a instanceof Error ? i.error(a) : rc(a) ? i.error(new Error("Socket closed with event ".concat(a.code, " ").concat(a.reason || ""))) : i.error(new ze({
            graphQLErrors: Array.isArray(a) ? a : [a]
          }));
        }
      });
    });
  }, e;
}(Ue);
function le(r) {
  return r === null ? "null" : Array.isArray(r) ? "array" : typeof r;
}
function $e(r) {
  return le(r) === "object";
}
function ic(r) {
  return Array.isArray(r) && // must be at least one error
  r.length > 0 && // error has at least a message
  r.every((e) => "message" in e);
}
function Zi(r, e) {
  return r.length < 124 ? r : e;
}
const ac = "graphql-transport-ws";
var fe;
(function(r) {
  r[r.InternalServerError = 4500] = "InternalServerError", r[r.InternalClientError = 4005] = "InternalClientError", r[r.BadRequest = 4400] = "BadRequest", r[r.BadResponse = 4004] = "BadResponse", r[r.Unauthorized = 4401] = "Unauthorized", r[r.Forbidden = 4403] = "Forbidden", r[r.SubprotocolNotAcceptable = 4406] = "SubprotocolNotAcceptable", r[r.ConnectionInitialisationTimeout = 4408] = "ConnectionInitialisationTimeout", r[r.ConnectionAcknowledgementTimeout = 4504] = "ConnectionAcknowledgementTimeout", r[r.SubscriberAlreadyExists = 4409] = "SubscriberAlreadyExists", r[r.TooManyInitialisationRequests = 4429] = "TooManyInitialisationRequests";
})(fe || (fe = {}));
var X;
(function(r) {
  r.ConnectionInit = "connection_init", r.ConnectionAck = "connection_ack", r.Ping = "ping", r.Pong = "pong", r.Subscribe = "subscribe", r.Next = "next", r.Error = "error", r.Complete = "complete";
})(X || (X = {}));
function La(r) {
  if (!$e(r))
    throw new Error(`Message is expected to be an object, but got ${le(r)}`);
  if (!r.type)
    throw new Error("Message is missing the 'type' property");
  if (typeof r.type != "string")
    throw new Error(`Message is expects the 'type' property to be a string, but got ${le(r.type)}`);
  switch (r.type) {
    case X.ConnectionInit:
    case X.ConnectionAck:
    case X.Ping:
    case X.Pong: {
      if ("payload" in r && !$e(r.payload))
        throw new Error(`"${r.type}" message expects the 'payload' property to be an object or missing, but got "${r.payload}"`);
      break;
    }
    case X.Subscribe: {
      if (typeof r.id != "string")
        throw new Error(`"${r.type}" message expects the 'id' property to be a string, but got ${le(r.id)}`);
      if (!r.id)
        throw new Error(`"${r.type}" message requires a non-empty 'id' property`);
      if (!$e(r.payload))
        throw new Error(`"${r.type}" message expects the 'payload' property to be an object, but got ${le(r.payload)}`);
      if (typeof r.payload.query != "string")
        throw new Error(`"${r.type}" message payload expects the 'query' property to be a string, but got ${le(r.payload.query)}`);
      if (r.payload.variables != null && !$e(r.payload.variables))
        throw new Error(`"${r.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${le(r.payload.variables)}`);
      if (r.payload.operationName != null && le(r.payload.operationName) !== "string")
        throw new Error(`"${r.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${le(r.payload.operationName)}`);
      if (r.payload.extensions != null && !$e(r.payload.extensions))
        throw new Error(`"${r.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${le(r.payload.extensions)}`);
      break;
    }
    case X.Next: {
      if (typeof r.id != "string")
        throw new Error(`"${r.type}" message expects the 'id' property to be a string, but got ${le(r.id)}`);
      if (!r.id)
        throw new Error(`"${r.type}" message requires a non-empty 'id' property`);
      if (!$e(r.payload))
        throw new Error(`"${r.type}" message expects the 'payload' property to be an object, but got ${le(r.payload)}`);
      break;
    }
    case X.Error: {
      if (typeof r.id != "string")
        throw new Error(`"${r.type}" message expects the 'id' property to be a string, but got ${le(r.id)}`);
      if (!r.id)
        throw new Error(`"${r.type}" message requires a non-empty 'id' property`);
      if (!ic(r.payload))
        throw new Error(`"${r.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(r.payload)}`);
      break;
    }
    case X.Complete: {
      if (typeof r.id != "string")
        throw new Error(`"${r.type}" message expects the 'id' property to be a string, but got ${le(r.id)}`);
      if (!r.id)
        throw new Error(`"${r.type}" message requires a non-empty 'id' property`);
      break;
    }
    default:
      throw new Error(`Invalid message 'type' property "${r.type}"`);
  }
  return r;
}
function sc(r, e) {
  return La(typeof r == "string" ? JSON.parse(r, e) : r);
}
function kt(r, e) {
  return La(r), JSON.stringify(r, e);
}
function oc(r) {
  const {
    url: e,
    connectionParams: t,
    lazy: n = !0,
    onNonLazyError: i = console.error,
    lazyCloseTimeout: a = 0,
    keepAlive: s = 0,
    disablePong: o,
    connectionAckWaitTimeout: c = 0,
    retryAttempts: u = 5,
    retryWait: f = async function(K) {
      let $ = 1e3;
      for (let L = 0; L < K; L++)
        $ *= 2;
      await new Promise((L) => setTimeout(L, $ + // add random timeout from 300ms to 3s
      Math.floor(Math.random() * 2700 + 300)));
    },
    shouldRetry: d = Kt,
    isFatalConnectionProblem: h,
    on: p,
    webSocketImpl: m,
    /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */
    generateID: v = function() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (K) => {
        const $ = Math.random() * 16 | 0;
        return (K == "x" ? $ : $ & 3 | 8).toString(16);
      });
    },
    jsonMessageReplacer: b,
    jsonMessageReviver: k
  } = r;
  let I;
  if (m) {
    if (!cc(m))
      throw new Error("Invalid WebSocket implementation provided");
    I = m;
  } else typeof WebSocket < "u" ? I = WebSocket : typeof global < "u" ? I = global.WebSocket || // @ts-expect-error: Support more browsers
  global.MozWebSocket : typeof window < "u" && (I = window.WebSocket || // @ts-expect-error: Support more browsers
  window.MozWebSocket);
  if (!I)
    throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
  const _ = I, S = (() => {
    const F = /* @__PURE__ */ (() => {
      const $ = {};
      return {
        on(L, q) {
          return $[L] = q, () => {
            delete $[L];
          };
        },
        emit(L) {
          var q;
          "id" in L && ((q = $[L.id]) === null || q === void 0 || q.call($, L));
        }
      };
    })(), K = {
      connecting: p != null && p.connecting ? [p.connecting] : [],
      opened: p != null && p.opened ? [p.opened] : [],
      connected: p != null && p.connected ? [p.connected] : [],
      ping: p != null && p.ping ? [p.ping] : [],
      pong: p != null && p.pong ? [p.pong] : [],
      message: p != null && p.message ? [F.emit, p.message] : [F.emit],
      closed: p != null && p.closed ? [p.closed] : [],
      error: p != null && p.error ? [p.error] : []
    };
    return {
      onMessage: F.on,
      on($, L) {
        const q = K[$];
        return q.push(L), () => {
          q.splice(q.indexOf(L), 1);
        };
      },
      emit($, ...L) {
        for (const q of [...K[$]])
          q(...L);
      }
    };
  })();
  function N(F) {
    const K = [
      // errors are fatal and more critical than close events, throw them first
      S.on("error", ($) => {
        K.forEach((L) => L()), F($);
      }),
      // closes can be graceful and not fatal, throw them second (if error didnt throw)
      S.on("closed", ($) => {
        K.forEach((L) => L()), F($);
      })
    ];
  }
  let j, D = 0, R, z = !1, Z = 0, _e = !1;
  async function De() {
    clearTimeout(R);
    const [F, K] = await (j ?? (j = new Promise((q, we) => (async () => {
      if (z) {
        if (await f(Z), !D)
          return j = void 0, we({ code: 1e3, reason: "All Subscriptions Gone" });
        Z++;
      }
      S.emit("connecting");
      const V = new _(typeof e == "function" ? await e() : e, ac);
      let ke, Ae;
      function Jt() {
        isFinite(s) && s > 0 && (clearTimeout(Ae), Ae = setTimeout(() => {
          V.readyState === _.OPEN && (V.send(kt({ type: X.Ping })), S.emit("ping", !1, void 0));
        }, s));
      }
      N((ne) => {
        j = void 0, clearTimeout(ke), clearTimeout(Ae), we(ne), Kt(ne) && ne.code === 4499 && (V.close(4499, "Terminated"), V.onerror = null, V.onclose = null);
      }), V.onerror = (ne) => S.emit("error", ne), V.onclose = (ne) => S.emit("closed", ne), V.onopen = async () => {
        try {
          S.emit("opened", V);
          const ne = typeof t == "function" ? await t() : t;
          if (V.readyState !== _.OPEN)
            return;
          V.send(kt(ne ? {
            type: X.ConnectionInit,
            payload: ne
          } : {
            type: X.ConnectionInit
            // payload is completely absent if not provided
          }, b)), isFinite(c) && c > 0 && (ke = setTimeout(() => {
            V.close(fe.ConnectionAcknowledgementTimeout, "Connection acknowledgement timeout");
          }, c)), Jt();
        } catch (ne) {
          S.emit("error", ne), V.close(fe.InternalClientError, Zi(ne instanceof Error ? ne.message : new Error(ne).message, "Internal client error"));
        }
      };
      let tt = !1;
      V.onmessage = ({ data: ne }) => {
        try {
          const ie = sc(ne, k);
          if (S.emit("message", ie), ie.type === "ping" || ie.type === "pong") {
            S.emit(ie.type, !0, ie.payload), ie.type === "pong" ? Jt() : o || (V.send(kt(ie.payload ? {
              type: X.Pong,
              payload: ie.payload
            } : {
              type: X.Pong
              // payload is completely absent if not provided
            })), S.emit("pong", !1, ie.payload));
            return;
          }
          if (tt)
            return;
          if (ie.type !== X.ConnectionAck)
            throw new Error(`First message cannot be of type ${ie.type}`);
          clearTimeout(ke), tt = !0, S.emit("connected", V, ie.payload), z = !1, Z = 0, q([
            V,
            new Promise((Tf, cs) => N(cs))
          ]);
        } catch (ie) {
          V.onmessage = null, S.emit("error", ie), V.close(fe.BadResponse, Zi(ie instanceof Error ? ie.message : new Error(ie).message, "Bad response"));
        }
      };
    })())));
    F.readyState === _.CLOSING && await K;
    let $ = () => {
    };
    const L = new Promise((q) => $ = q);
    return [
      F,
      $,
      Promise.race([
        // wait for
        L.then(() => {
          if (!D) {
            const q = () => F.close(1e3, "Normal Closure");
            isFinite(a) && a > 0 ? R = setTimeout(() => {
              F.readyState === _.OPEN && q();
            }, a) : q();
          }
        }),
        // or
        K
      ])
    ];
  }
  function ue(F) {
    if (Kt(F) && (uc(F.code) || [
      fe.InternalServerError,
      fe.InternalClientError,
      fe.BadRequest,
      fe.BadResponse,
      fe.Unauthorized,
      // CloseCode.Forbidden, might grant access out after retry
      fe.SubprotocolNotAcceptable,
      // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
      // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
      fe.SubscriberAlreadyExists,
      fe.TooManyInitialisationRequests
      // 4499, // Terminated, probably because the socket froze, we want to retry
    ].includes(F.code)))
      throw F;
    if (_e)
      return !1;
    if (Kt(F) && F.code === 1e3)
      return D > 0;
    if (!u || Z >= u || !d(F) || h != null && h(F))
      throw F;
    return z = !0;
  }
  return n || (async () => {
    for (D++; ; )
      try {
        const [, , F] = await De();
        await F;
      } catch (F) {
        try {
          if (!ue(F))
            return;
        } catch (K) {
          return i == null ? void 0 : i(K);
        }
      }
  })(), {
    on: S.on,
    subscribe(F, K) {
      const $ = v(F);
      let L = !1, q = !1, we = () => {
        D--, L = !0;
      };
      return (async () => {
        for (D++; ; )
          try {
            const [V, ke, Ae] = await De();
            if (L)
              return ke();
            const Jt = S.onMessage($, (tt) => {
              switch (tt.type) {
                case X.Next: {
                  K.next(tt.payload);
                  return;
                }
                case X.Error: {
                  q = !0, L = !0, K.error(tt.payload), we();
                  return;
                }
                case X.Complete: {
                  L = !0, we();
                  return;
                }
              }
            });
            V.send(kt({
              id: $,
              type: X.Subscribe,
              payload: F
            }, b)), we = () => {
              !L && V.readyState === _.OPEN && V.send(kt({
                id: $,
                type: X.Complete
              }, b)), D--, L = !0, ke();
            }, await Ae.finally(Jt);
            return;
          } catch (V) {
            if (!ue(V))
              return;
          }
      })().then(() => {
        q || K.complete();
      }).catch((V) => {
        K.error(V);
      }), () => {
        L || we();
      };
    },
    async dispose() {
      if (_e = !0, j) {
        const [F] = await j;
        F.close(1e3, "Normal Closure");
      }
    },
    terminate() {
      j && S.emit("closed", {
        code: 4499,
        reason: "Terminated",
        wasClean: !1
      });
    }
  };
}
function Kt(r) {
  return $e(r) && "code" in r && "reason" in r;
}
function uc(r) {
  return [
    1e3,
    1001,
    1006,
    1005,
    1012,
    1013,
    1013
    // Bad Gateway
  ].includes(r) ? !1 : r >= 1e3 && r <= 1999;
}
function cc(r) {
  return typeof r == "function" && "constructor" in r && "CLOSED" in r && "CLOSING" in r && "CONNECTING" in r && "OPEN" in r;
}
const lc = (r, e) => {
  const t = new fa({
    credentials: "include",
    uri: r
  }), n = new nc(
    oc({
      url: e,
      lazy: !0
    })
  ), i = Ro(
    ({ query: s }) => {
      const o = br(s);
      return o.kind === "OperationDefinition" && o.operation === "subscription";
    },
    n,
    t
  );
  return new tc({
    cache: new Wu(),
    link: Io([i]),
    credentials: "include"
  });
};
class If {
  constructor(e, t) {
    mt(this, "endpoint");
    mt(this, "apolloClient");
    mt(this, "uploadToS3", async (e, t, n) => {
      const i = {};
      return new G((a) => {
        const s = new FormData(), { url: o } = i.data.presignedFormData, c = JSON.parse(
          i.data.presignedFormData.fields
        );
        Object.keys(c).forEach((f) => {
          s.append(f, c[f]);
        }), s.append("file", e);
        const u = new XMLHttpRequest();
        u.open("POST", o), u.upload.addEventListener("progress", (f) => {
          const d = f.loaded / f.total;
          a.next({ progress: d });
        }), u.upload.addEventListener("load", () => {
          u.upload.removeEventListener("progress", () => null), a.complete();
        }), u.send(s);
      });
    });
    this.endpoint = e;
    try {
      this.apolloClient = lc(
        `${e}/graphql`,
        `${t}`
      );
    } catch (n) {
      throw console.error(n), new Error("Failed to create apollo client");
    }
  }
  downloadS3File(e, t = null) {
    return new Promise((n) => {
      const i = `${this.endpoint}/download?bucket=${e.bucket}&key=${e.key}&isFolder=${e.isFolder ? 1 : 0}${t ? `&limit=${t}` : ""}`, a = new XMLHttpRequest();
      a.withCredentials = !0, a.open("GET", i, !0), a.setRequestHeader("Content-Type", "application/json"), a.responseType = "blob", a.addEventListener("load", function() {
        return n(this.response);
      }), a.send(JSON.stringify({ ...e, limit: t }));
    });
  }
  async refreshToken() {
    fetch(`${this.endpoint}/refreshToken`, {
      method: "POST",
      credentials: "include"
    });
  }
}
var Q;
(function(r) {
  r.assertEqual = (i) => i;
  function e(i) {
  }
  r.assertIs = e;
  function t(i) {
    throw new Error();
  }
  r.assertNever = t, r.arrayToEnum = (i) => {
    const a = {};
    for (const s of i)
      a[s] = s;
    return a;
  }, r.getValidEnumValues = (i) => {
    const a = r.objectKeys(i).filter((o) => typeof i[i[o]] != "number"), s = {};
    for (const o of a)
      s[o] = i[o];
    return r.objectValues(s);
  }, r.objectValues = (i) => r.objectKeys(i).map(function(a) {
    return i[a];
  }), r.objectKeys = typeof Object.keys == "function" ? (i) => Object.keys(i) : (i) => {
    const a = [];
    for (const s in i)
      Object.prototype.hasOwnProperty.call(i, s) && a.push(s);
    return a;
  }, r.find = (i, a) => {
    for (const s of i)
      if (a(s))
        return s;
  }, r.isInteger = typeof Number.isInteger == "function" ? (i) => Number.isInteger(i) : (i) => typeof i == "number" && isFinite(i) && Math.floor(i) === i;
  function n(i, a = " | ") {
    return i.map((s) => typeof s == "string" ? `'${s}'` : s).join(a);
  }
  r.joinValues = n, r.jsonStringifyReplacer = (i, a) => typeof a == "bigint" ? a.toString() : a;
})(Q || (Q = {}));
var hn;
(function(r) {
  r.mergeShapes = (e, t) => ({
    ...e,
    ...t
    // second overwrites first
  });
})(hn || (hn = {}));
const O = Q.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Re = (r) => {
  switch (typeof r) {
    case "undefined":
      return O.undefined;
    case "string":
      return O.string;
    case "number":
      return isNaN(r) ? O.nan : O.number;
    case "boolean":
      return O.boolean;
    case "function":
      return O.function;
    case "bigint":
      return O.bigint;
    case "symbol":
      return O.symbol;
    case "object":
      return Array.isArray(r) ? O.array : r === null ? O.null : r.then && typeof r.then == "function" && r.catch && typeof r.catch == "function" ? O.promise : typeof Map < "u" && r instanceof Map ? O.map : typeof Set < "u" && r instanceof Set ? O.set : typeof Date < "u" && r instanceof Date ? O.date : O.object;
    default:
      return O.unknown;
  }
}, g = Q.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), fc = (r) => JSON.stringify(r, null, 2).replace(/"([^"]+)":/g, "$1:");
class de extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const t = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, t) : this.__proto__ = t, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const t = e || function(a) {
      return a.message;
    }, n = { _errors: [] }, i = (a) => {
      for (const s of a.issues)
        if (s.code === "invalid_union")
          s.unionErrors.map(i);
        else if (s.code === "invalid_return_type")
          i(s.returnTypeError);
        else if (s.code === "invalid_arguments")
          i(s.argumentsError);
        else if (s.path.length === 0)
          n._errors.push(t(s));
        else {
          let o = n, c = 0;
          for (; c < s.path.length; ) {
            const u = s.path[c];
            c === s.path.length - 1 ? (o[u] = o[u] || { _errors: [] }, o[u]._errors.push(t(s))) : o[u] = o[u] || { _errors: [] }, o = o[u], c++;
          }
        }
    };
    return i(this), n;
  }
  static assert(e) {
    if (!(e instanceof de))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Q.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (t) => t.message) {
    const t = {}, n = [];
    for (const i of this.issues)
      i.path.length > 0 ? (t[i.path[0]] = t[i.path[0]] || [], t[i.path[0]].push(e(i))) : n.push(e(i));
    return { formErrors: n, fieldErrors: t };
  }
  get formErrors() {
    return this.flatten();
  }
}
de.create = (r) => new de(r);
const pt = (r, e) => {
  let t;
  switch (r.code) {
    case g.invalid_type:
      r.received === O.undefined ? t = "Required" : t = `Expected ${r.expected}, received ${r.received}`;
      break;
    case g.invalid_literal:
      t = `Invalid literal value, expected ${JSON.stringify(r.expected, Q.jsonStringifyReplacer)}`;
      break;
    case g.unrecognized_keys:
      t = `Unrecognized key(s) in object: ${Q.joinValues(r.keys, ", ")}`;
      break;
    case g.invalid_union:
      t = "Invalid input";
      break;
    case g.invalid_union_discriminator:
      t = `Invalid discriminator value. Expected ${Q.joinValues(r.options)}`;
      break;
    case g.invalid_enum_value:
      t = `Invalid enum value. Expected ${Q.joinValues(r.options)}, received '${r.received}'`;
      break;
    case g.invalid_arguments:
      t = "Invalid function arguments";
      break;
    case g.invalid_return_type:
      t = "Invalid function return type";
      break;
    case g.invalid_date:
      t = "Invalid date";
      break;
    case g.invalid_string:
      typeof r.validation == "object" ? "includes" in r.validation ? (t = `Invalid input: must include "${r.validation.includes}"`, typeof r.validation.position == "number" && (t = `${t} at one or more positions greater than or equal to ${r.validation.position}`)) : "startsWith" in r.validation ? t = `Invalid input: must start with "${r.validation.startsWith}"` : "endsWith" in r.validation ? t = `Invalid input: must end with "${r.validation.endsWith}"` : Q.assertNever(r.validation) : r.validation !== "regex" ? t = `Invalid ${r.validation}` : t = "Invalid";
      break;
    case g.too_small:
      r.type === "array" ? t = `Array must contain ${r.exact ? "exactly" : r.inclusive ? "at least" : "more than"} ${r.minimum} element(s)` : r.type === "string" ? t = `String must contain ${r.exact ? "exactly" : r.inclusive ? "at least" : "over"} ${r.minimum} character(s)` : r.type === "number" ? t = `Number must be ${r.exact ? "exactly equal to " : r.inclusive ? "greater than or equal to " : "greater than "}${r.minimum}` : r.type === "date" ? t = `Date must be ${r.exact ? "exactly equal to " : r.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(r.minimum))}` : t = "Invalid input";
      break;
    case g.too_big:
      r.type === "array" ? t = `Array must contain ${r.exact ? "exactly" : r.inclusive ? "at most" : "less than"} ${r.maximum} element(s)` : r.type === "string" ? t = `String must contain ${r.exact ? "exactly" : r.inclusive ? "at most" : "under"} ${r.maximum} character(s)` : r.type === "number" ? t = `Number must be ${r.exact ? "exactly" : r.inclusive ? "less than or equal to" : "less than"} ${r.maximum}` : r.type === "bigint" ? t = `BigInt must be ${r.exact ? "exactly" : r.inclusive ? "less than or equal to" : "less than"} ${r.maximum}` : r.type === "date" ? t = `Date must be ${r.exact ? "exactly" : r.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(r.maximum))}` : t = "Invalid input";
      break;
    case g.custom:
      t = "Invalid input";
      break;
    case g.invalid_intersection_types:
      t = "Intersection results could not be merged";
      break;
    case g.not_multiple_of:
      t = `Number must be a multiple of ${r.multipleOf}`;
      break;
    case g.not_finite:
      t = "Number must be finite";
      break;
    default:
      t = e.defaultError, Q.assertNever(r);
  }
  return { message: t };
};
let qa = pt;
function dc(r) {
  qa = r;
}
function ur() {
  return qa;
}
const cr = (r) => {
  const { data: e, path: t, errorMaps: n, issueData: i } = r, a = [...t, ...i.path || []], s = {
    ...i,
    path: a
  };
  if (i.message !== void 0)
    return {
      ...i,
      path: a,
      message: i.message
    };
  let o = "";
  const c = n.filter((u) => !!u).slice().reverse();
  for (const u of c)
    o = u(s, { data: e, defaultError: o }).message;
  return {
    ...i,
    path: a,
    message: o
  };
}, hc = [];
function w(r, e) {
  const t = ur(), n = cr({
    issueData: e,
    data: r.data,
    path: r.path,
    errorMaps: [
      r.common.contextualErrorMap,
      // contextual error map is first priority
      r.schemaErrorMap,
      // then schema-bound map if available
      t,
      // then global override map
      t === pt ? void 0 : pt
      // then global default map
    ].filter((i) => !!i)
  });
  r.common.issues.push(n);
}
class oe {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, t) {
    const n = [];
    for (const i of t) {
      if (i.status === "aborted")
        return A;
      i.status === "dirty" && e.dirty(), n.push(i.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, t) {
    const n = [];
    for (const i of t) {
      const a = await i.key, s = await i.value;
      n.push({
        key: a,
        value: s
      });
    }
    return oe.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, t) {
    const n = {};
    for (const i of t) {
      const { key: a, value: s } = i;
      if (a.status === "aborted" || s.status === "aborted")
        return A;
      a.status === "dirty" && e.dirty(), s.status === "dirty" && e.dirty(), a.value !== "__proto__" && (typeof s.value < "u" || i.alwaysSet) && (n[a.value] = s.value);
    }
    return { status: e.value, value: n };
  }
}
const A = Object.freeze({
  status: "aborted"
}), st = (r) => ({ status: "dirty", value: r }), ce = (r) => ({ status: "valid", value: r }), pn = (r) => r.status === "aborted", yn = (r) => r.status === "dirty", Ye = (r) => r.status === "valid", Ct = (r) => typeof Promise < "u" && r instanceof Promise;
function lr(r, e, t, n) {
  if (typeof e == "function" ? r !== e || !0 : !e.has(r)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(r);
}
function Qa(r, e, t, n, i) {
  if (typeof e == "function" ? r !== e || !0 : !e.has(r)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(r, t), t;
}
var T;
(function(r) {
  r.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, r.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(T || (T = {}));
var St, Ot;
class Oe {
  constructor(e, t, n, i) {
    this._cachedPath = [], this.parent = e, this.data = t, this._path = n, this._key = i;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Ui = (r, e) => {
  if (Ye(e))
    return { success: !0, data: e.value };
  if (!r.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const t = new de(r.common.issues);
      return this._error = t, this._error;
    }
  };
};
function P(r) {
  if (!r)
    return {};
  const { errorMap: e, invalid_type_error: t, required_error: n, description: i } = r;
  if (e && (t || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: i } : { errorMap: (s, o) => {
    var c, u;
    const { message: f } = r;
    return s.code === "invalid_enum_value" ? { message: f ?? o.defaultError } : typeof o.data > "u" ? { message: (c = f ?? n) !== null && c !== void 0 ? c : o.defaultError } : s.code !== "invalid_type" ? { message: o.defaultError } : { message: (u = f ?? t) !== null && u !== void 0 ? u : o.defaultError };
  }, description: i };
}
class M {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return Re(e.data);
  }
  _getOrReturnCtx(e, t) {
    return t || {
      common: e.parent.common,
      data: e.data,
      parsedType: Re(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new oe(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: Re(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const t = this._parse(e);
    if (Ct(t))
      throw new Error("Synchronous parse encountered promise.");
    return t;
  }
  _parseAsync(e) {
    const t = this._parse(e);
    return Promise.resolve(t);
  }
  parse(e, t) {
    const n = this.safeParse(e, t);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, t) {
    var n;
    const i = {
      common: {
        issues: [],
        async: (n = t == null ? void 0 : t.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: t == null ? void 0 : t.errorMap
      },
      path: (t == null ? void 0 : t.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Re(e)
    }, a = this._parseSync({ data: e, path: i.path, parent: i });
    return Ui(i, a);
  }
  "~validate"(e) {
    var t, n;
    const i = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Re(e)
    };
    if (!this["~standard"].async)
      try {
        const a = this._parseSync({ data: e, path: [], parent: i });
        return Ye(a) ? {
          value: a.value
        } : {
          issues: i.common.issues
        };
      } catch (a) {
        !((n = (t = a == null ? void 0 : a.message) === null || t === void 0 ? void 0 : t.toLowerCase()) === null || n === void 0) && n.includes("encountered") && (this["~standard"].async = !0), i.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: i }).then((a) => Ye(a) ? {
      value: a.value
    } : {
      issues: i.common.issues
    });
  }
  async parseAsync(e, t) {
    const n = await this.safeParseAsync(e, t);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, t) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: t == null ? void 0 : t.errorMap,
        async: !0
      },
      path: (t == null ? void 0 : t.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Re(e)
    }, i = this._parse({ data: e, path: n.path, parent: n }), a = await (Ct(i) ? i : Promise.resolve(i));
    return Ui(n, a);
  }
  refine(e, t) {
    const n = (i) => typeof t == "string" || typeof t > "u" ? { message: t } : typeof t == "function" ? t(i) : t;
    return this._refinement((i, a) => {
      const s = e(i), o = () => a.addIssue({
        code: g.custom,
        ...n(i)
      });
      return typeof Promise < "u" && s instanceof Promise ? s.then((c) => c ? !0 : (o(), !1)) : s ? !0 : (o(), !1);
    });
  }
  refinement(e, t) {
    return this._refinement((n, i) => e(n) ? !0 : (i.addIssue(typeof t == "function" ? t(n, i) : t), !1));
  }
  _refinement(e) {
    return new ge({
      schema: this,
      typeName: C.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (t) => this["~validate"](t)
    };
  }
  optional() {
    return Se.create(this, this._def);
  }
  nullable() {
    return Ze.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return me.create(this);
  }
  promise() {
    return vt.create(this, this._def);
  }
  or(e) {
    return Ft.create([this, e], this._def);
  }
  and(e) {
    return Mt.create(this, e, this._def);
  }
  transform(e) {
    return new ge({
      ...P(this._def),
      schema: this,
      typeName: C.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const t = typeof e == "function" ? e : () => e;
    return new Bt({
      ...P(this._def),
      innerType: this,
      defaultValue: t,
      typeName: C.ZodDefault
    });
  }
  brand() {
    return new Zn({
      typeName: C.ZodBranded,
      type: this,
      ...P(this._def)
    });
  }
  catch(e) {
    const t = typeof e == "function" ? e : () => e;
    return new Zt({
      ...P(this._def),
      innerType: this,
      catchValue: t,
      typeName: C.ZodCatch
    });
  }
  describe(e) {
    const t = this.constructor;
    return new t({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return Wt.create(this, e);
  }
  readonly() {
    return Ut.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const pc = /^c[^\s-]{8,}$/i, yc = /^[0-9a-z]+$/, vc = /^[0-9A-HJKMNP-TV-Z]{26}$/i, mc = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, gc = /^[a-z0-9_-]{21}$/i, bc = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, _c = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, wc = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, kc = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let qr;
const Ec = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Sc = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Oc = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, xc = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Tc = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Dc = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Ba = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Ic = new RegExp(`^${Ba}$`);
function Za(r) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return r.precision ? e = `${e}\\.\\d{${r.precision}}` : r.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function Rc(r) {
  return new RegExp(`^${Za(r)}$`);
}
function Ua(r) {
  let e = `${Ba}T${Za(r)}`;
  const t = [];
  return t.push(r.local ? "Z?" : "Z"), r.offset && t.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${t.join("|")})`, new RegExp(`^${e}$`);
}
function jc(r, e) {
  return !!((e === "v4" || !e) && Ec.test(r) || (e === "v6" || !e) && Oc.test(r));
}
function Cc(r, e) {
  if (!bc.test(r))
    return !1;
  try {
    const [t] = r.split("."), n = t.replace(/-/g, "+").replace(/_/g, "/").padEnd(t.length + (4 - t.length % 4) % 4, "="), i = JSON.parse(atob(n));
    return !(typeof i != "object" || i === null || !i.typ || !i.alg || e && i.alg !== e);
  } catch {
    return !1;
  }
}
function Ac(r, e) {
  return !!((e === "v4" || !e) && Sc.test(r) || (e === "v6" || !e) && xc.test(r));
}
class ve extends M {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== O.string) {
      const a = this._getOrReturnCtx(e);
      return w(a, {
        code: g.invalid_type,
        expected: O.string,
        received: a.parsedType
      }), A;
    }
    const n = new oe();
    let i;
    for (const a of this._def.checks)
      if (a.kind === "min")
        e.data.length < a.value && (i = this._getOrReturnCtx(e, i), w(i, {
          code: g.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), n.dirty());
      else if (a.kind === "max")
        e.data.length > a.value && (i = this._getOrReturnCtx(e, i), w(i, {
          code: g.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), n.dirty());
      else if (a.kind === "length") {
        const s = e.data.length > a.value, o = e.data.length < a.value;
        (s || o) && (i = this._getOrReturnCtx(e, i), s ? w(i, {
          code: g.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : o && w(i, {
          code: g.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), n.dirty());
      } else if (a.kind === "email")
        wc.test(e.data) || (i = this._getOrReturnCtx(e, i), w(i, {
          validation: "email",
          code: g.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "emoji")
        qr || (qr = new RegExp(kc, "u")), qr.test(e.data) || (i = this._getOrReturnCtx(e, i), w(i, {
          validation: "emoji",
          code: g.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "uuid")
        mc.test(e.data) || (i = this._getOrReturnCtx(e, i), w(i, {
          validation: "uuid",
          code: g.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "nanoid")
        gc.test(e.data) || (i = this._getOrReturnCtx(e, i), w(i, {
          validation: "nanoid",
          code: g.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "cuid")
        pc.test(e.data) || (i = this._getOrReturnCtx(e, i), w(i, {
          validation: "cuid",
          code: g.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "cuid2")
        yc.test(e.data) || (i = this._getOrReturnCtx(e, i), w(i, {
          validation: "cuid2",
          code: g.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "ulid")
        vc.test(e.data) || (i = this._getOrReturnCtx(e, i), w(i, {
          validation: "ulid",
          code: g.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "url")
        try {
          new URL(e.data);
        } catch {
          i = this._getOrReturnCtx(e, i), w(i, {
            validation: "url",
            code: g.invalid_string,
            message: a.message
          }), n.dirty();
        }
      else a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(e.data) || (i = this._getOrReturnCtx(e, i), w(i, {
        validation: "regex",
        code: g.invalid_string,
        message: a.message
      }), n.dirty())) : a.kind === "trim" ? e.data = e.data.trim() : a.kind === "includes" ? e.data.includes(a.value, a.position) || (i = this._getOrReturnCtx(e, i), w(i, {
        code: g.invalid_string,
        validation: { includes: a.value, position: a.position },
        message: a.message
      }), n.dirty()) : a.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : a.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : a.kind === "startsWith" ? e.data.startsWith(a.value) || (i = this._getOrReturnCtx(e, i), w(i, {
        code: g.invalid_string,
        validation: { startsWith: a.value },
        message: a.message
      }), n.dirty()) : a.kind === "endsWith" ? e.data.endsWith(a.value) || (i = this._getOrReturnCtx(e, i), w(i, {
        code: g.invalid_string,
        validation: { endsWith: a.value },
        message: a.message
      }), n.dirty()) : a.kind === "datetime" ? Ua(a).test(e.data) || (i = this._getOrReturnCtx(e, i), w(i, {
        code: g.invalid_string,
        validation: "datetime",
        message: a.message
      }), n.dirty()) : a.kind === "date" ? Ic.test(e.data) || (i = this._getOrReturnCtx(e, i), w(i, {
        code: g.invalid_string,
        validation: "date",
        message: a.message
      }), n.dirty()) : a.kind === "time" ? Rc(a).test(e.data) || (i = this._getOrReturnCtx(e, i), w(i, {
        code: g.invalid_string,
        validation: "time",
        message: a.message
      }), n.dirty()) : a.kind === "duration" ? _c.test(e.data) || (i = this._getOrReturnCtx(e, i), w(i, {
        validation: "duration",
        code: g.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "ip" ? jc(e.data, a.version) || (i = this._getOrReturnCtx(e, i), w(i, {
        validation: "ip",
        code: g.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "jwt" ? Cc(e.data, a.alg) || (i = this._getOrReturnCtx(e, i), w(i, {
        validation: "jwt",
        code: g.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "cidr" ? Ac(e.data, a.version) || (i = this._getOrReturnCtx(e, i), w(i, {
        validation: "cidr",
        code: g.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "base64" ? Tc.test(e.data) || (i = this._getOrReturnCtx(e, i), w(i, {
        validation: "base64",
        code: g.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "base64url" ? Dc.test(e.data) || (i = this._getOrReturnCtx(e, i), w(i, {
        validation: "base64url",
        code: g.invalid_string,
        message: a.message
      }), n.dirty()) : Q.assertNever(a);
    return { status: n.value, value: e.data };
  }
  _regex(e, t, n) {
    return this.refinement((i) => e.test(i), {
      validation: t,
      code: g.invalid_string,
      ...T.errToObj(n)
    });
  }
  _addCheck(e) {
    return new ve({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...T.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...T.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...T.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...T.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...T.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...T.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...T.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...T.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...T.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...T.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...T.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...T.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...T.errToObj(e) });
  }
  datetime(e) {
    var t, n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (t = e == null ? void 0 : e.offset) !== null && t !== void 0 ? t : !1,
      local: (n = e == null ? void 0 : e.local) !== null && n !== void 0 ? n : !1,
      ...T.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...T.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...T.errToObj(e) });
  }
  regex(e, t) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...T.errToObj(t)
    });
  }
  includes(e, t) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: t == null ? void 0 : t.position,
      ...T.errToObj(t == null ? void 0 : t.message)
    });
  }
  startsWith(e, t) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...T.errToObj(t)
    });
  }
  endsWith(e, t) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...T.errToObj(t)
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...T.errToObj(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...T.errToObj(t)
    });
  }
  length(e, t) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...T.errToObj(t)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, T.errToObj(e));
  }
  trim() {
    return new ve({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new ve({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new ve({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
ve.create = (r) => {
  var e;
  return new ve({
    checks: [],
    typeName: C.ZodString,
    coerce: (e = r == null ? void 0 : r.coerce) !== null && e !== void 0 ? e : !1,
    ...P(r)
  });
};
function Nc(r, e) {
  const t = (r.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, i = t > n ? t : n, a = parseInt(r.toFixed(i).replace(".", "")), s = parseInt(e.toFixed(i).replace(".", ""));
  return a % s / Math.pow(10, i);
}
class qe extends M {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== O.number) {
      const a = this._getOrReturnCtx(e);
      return w(a, {
        code: g.invalid_type,
        expected: O.number,
        received: a.parsedType
      }), A;
    }
    let n;
    const i = new oe();
    for (const a of this._def.checks)
      a.kind === "int" ? Q.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), w(n, {
        code: g.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), i.dirty()) : a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (n = this._getOrReturnCtx(e, n), w(n, {
        code: g.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), i.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (n = this._getOrReturnCtx(e, n), w(n, {
        code: g.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), i.dirty()) : a.kind === "multipleOf" ? Nc(e.data, a.value) !== 0 && (n = this._getOrReturnCtx(e, n), w(n, {
        code: g.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), i.dirty()) : a.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), w(n, {
        code: g.not_finite,
        message: a.message
      }), i.dirty()) : Q.assertNever(a);
    return { status: i.value, value: e.data };
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, T.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, T.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, T.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, T.toString(t));
  }
  setLimit(e, t, n, i) {
    return new qe({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: n,
          message: T.toString(i)
        }
      ]
    });
  }
  _addCheck(e) {
    return new qe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: T.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: T.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: T.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: T.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: T.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: T.toString(t)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: T.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: T.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: T.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && Q.isInteger(e.value));
  }
  get isFinite() {
    let e = null, t = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (t === null || n.value > t) && (t = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(t) && Number.isFinite(e);
  }
}
qe.create = (r) => new qe({
  checks: [],
  typeName: C.ZodNumber,
  coerce: (r == null ? void 0 : r.coerce) || !1,
  ...P(r)
});
class Qe extends M {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== O.bigint)
      return this._getInvalidInput(e);
    let n;
    const i = new oe();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (n = this._getOrReturnCtx(e, n), w(n, {
        code: g.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), i.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (n = this._getOrReturnCtx(e, n), w(n, {
        code: g.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), i.dirty()) : a.kind === "multipleOf" ? e.data % a.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), w(n, {
        code: g.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), i.dirty()) : Q.assertNever(a);
    return { status: i.value, value: e.data };
  }
  _getInvalidInput(e) {
    const t = this._getOrReturnCtx(e);
    return w(t, {
      code: g.invalid_type,
      expected: O.bigint,
      received: t.parsedType
    }), A;
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, T.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, T.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, T.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, T.toString(t));
  }
  setLimit(e, t, n, i) {
    return new Qe({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: n,
          message: T.toString(i)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Qe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: T.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: T.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: T.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: T.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: T.toString(t)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
Qe.create = (r) => {
  var e;
  return new Qe({
    checks: [],
    typeName: C.ZodBigInt,
    coerce: (e = r == null ? void 0 : r.coerce) !== null && e !== void 0 ? e : !1,
    ...P(r)
  });
};
class At extends M {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== O.boolean) {
      const n = this._getOrReturnCtx(e);
      return w(n, {
        code: g.invalid_type,
        expected: O.boolean,
        received: n.parsedType
      }), A;
    }
    return ce(e.data);
  }
}
At.create = (r) => new At({
  typeName: C.ZodBoolean,
  coerce: (r == null ? void 0 : r.coerce) || !1,
  ...P(r)
});
class Ke extends M {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== O.date) {
      const a = this._getOrReturnCtx(e);
      return w(a, {
        code: g.invalid_type,
        expected: O.date,
        received: a.parsedType
      }), A;
    }
    if (isNaN(e.data.getTime())) {
      const a = this._getOrReturnCtx(e);
      return w(a, {
        code: g.invalid_date
      }), A;
    }
    const n = new oe();
    let i;
    for (const a of this._def.checks)
      a.kind === "min" ? e.data.getTime() < a.value && (i = this._getOrReturnCtx(e, i), w(i, {
        code: g.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), n.dirty()) : a.kind === "max" ? e.data.getTime() > a.value && (i = this._getOrReturnCtx(e, i), w(i, {
        code: g.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), n.dirty()) : Q.assertNever(a);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new Ke({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: T.toString(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: T.toString(t)
    });
  }
  get minDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
}
Ke.create = (r) => new Ke({
  checks: [],
  coerce: (r == null ? void 0 : r.coerce) || !1,
  typeName: C.ZodDate,
  ...P(r)
});
class fr extends M {
  _parse(e) {
    if (this._getType(e) !== O.symbol) {
      const n = this._getOrReturnCtx(e);
      return w(n, {
        code: g.invalid_type,
        expected: O.symbol,
        received: n.parsedType
      }), A;
    }
    return ce(e.data);
  }
}
fr.create = (r) => new fr({
  typeName: C.ZodSymbol,
  ...P(r)
});
class Nt extends M {
  _parse(e) {
    if (this._getType(e) !== O.undefined) {
      const n = this._getOrReturnCtx(e);
      return w(n, {
        code: g.invalid_type,
        expected: O.undefined,
        received: n.parsedType
      }), A;
    }
    return ce(e.data);
  }
}
Nt.create = (r) => new Nt({
  typeName: C.ZodUndefined,
  ...P(r)
});
class Pt extends M {
  _parse(e) {
    if (this._getType(e) !== O.null) {
      const n = this._getOrReturnCtx(e);
      return w(n, {
        code: g.invalid_type,
        expected: O.null,
        received: n.parsedType
      }), A;
    }
    return ce(e.data);
  }
}
Pt.create = (r) => new Pt({
  typeName: C.ZodNull,
  ...P(r)
});
class yt extends M {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return ce(e.data);
  }
}
yt.create = (r) => new yt({
  typeName: C.ZodAny,
  ...P(r)
});
class Ge extends M {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return ce(e.data);
  }
}
Ge.create = (r) => new Ge({
  typeName: C.ZodUnknown,
  ...P(r)
});
class Ce extends M {
  _parse(e) {
    const t = this._getOrReturnCtx(e);
    return w(t, {
      code: g.invalid_type,
      expected: O.never,
      received: t.parsedType
    }), A;
  }
}
Ce.create = (r) => new Ce({
  typeName: C.ZodNever,
  ...P(r)
});
class dr extends M {
  _parse(e) {
    if (this._getType(e) !== O.undefined) {
      const n = this._getOrReturnCtx(e);
      return w(n, {
        code: g.invalid_type,
        expected: O.void,
        received: n.parsedType
      }), A;
    }
    return ce(e.data);
  }
}
dr.create = (r) => new dr({
  typeName: C.ZodVoid,
  ...P(r)
});
class me extends M {
  _parse(e) {
    const { ctx: t, status: n } = this._processInputParams(e), i = this._def;
    if (t.parsedType !== O.array)
      return w(t, {
        code: g.invalid_type,
        expected: O.array,
        received: t.parsedType
      }), A;
    if (i.exactLength !== null) {
      const s = t.data.length > i.exactLength.value, o = t.data.length < i.exactLength.value;
      (s || o) && (w(t, {
        code: s ? g.too_big : g.too_small,
        minimum: o ? i.exactLength.value : void 0,
        maximum: s ? i.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: i.exactLength.message
      }), n.dirty());
    }
    if (i.minLength !== null && t.data.length < i.minLength.value && (w(t, {
      code: g.too_small,
      minimum: i.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.minLength.message
    }), n.dirty()), i.maxLength !== null && t.data.length > i.maxLength.value && (w(t, {
      code: g.too_big,
      maximum: i.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.maxLength.message
    }), n.dirty()), t.common.async)
      return Promise.all([...t.data].map((s, o) => i.type._parseAsync(new Oe(t, s, t.path, o)))).then((s) => oe.mergeArray(n, s));
    const a = [...t.data].map((s, o) => i.type._parseSync(new Oe(t, s, t.path, o)));
    return oe.mergeArray(n, a);
  }
  get element() {
    return this._def.type;
  }
  min(e, t) {
    return new me({
      ...this._def,
      minLength: { value: e, message: T.toString(t) }
    });
  }
  max(e, t) {
    return new me({
      ...this._def,
      maxLength: { value: e, message: T.toString(t) }
    });
  }
  length(e, t) {
    return new me({
      ...this._def,
      exactLength: { value: e, message: T.toString(t) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
me.create = (r, e) => new me({
  type: r,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: C.ZodArray,
  ...P(e)
});
function nt(r) {
  if (r instanceof H) {
    const e = {};
    for (const t in r.shape) {
      const n = r.shape[t];
      e[t] = Se.create(nt(n));
    }
    return new H({
      ...r._def,
      shape: () => e
    });
  } else return r instanceof me ? new me({
    ...r._def,
    type: nt(r.element)
  }) : r instanceof Se ? Se.create(nt(r.unwrap())) : r instanceof Ze ? Ze.create(nt(r.unwrap())) : r instanceof xe ? xe.create(r.items.map((e) => nt(e))) : r;
}
class H extends M {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), t = Q.objectKeys(e);
    return this._cached = { shape: e, keys: t };
  }
  _parse(e) {
    if (this._getType(e) !== O.object) {
      const u = this._getOrReturnCtx(e);
      return w(u, {
        code: g.invalid_type,
        expected: O.object,
        received: u.parsedType
      }), A;
    }
    const { status: n, ctx: i } = this._processInputParams(e), { shape: a, keys: s } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof Ce && this._def.unknownKeys === "strip"))
      for (const u in i.data)
        s.includes(u) || o.push(u);
    const c = [];
    for (const u of s) {
      const f = a[u], d = i.data[u];
      c.push({
        key: { status: "valid", value: u },
        value: f._parse(new Oe(i, d, i.path, u)),
        alwaysSet: u in i.data
      });
    }
    if (this._def.catchall instanceof Ce) {
      const u = this._def.unknownKeys;
      if (u === "passthrough")
        for (const f of o)
          c.push({
            key: { status: "valid", value: f },
            value: { status: "valid", value: i.data[f] }
          });
      else if (u === "strict")
        o.length > 0 && (w(i, {
          code: g.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const f of o) {
        const d = i.data[f];
        c.push({
          key: { status: "valid", value: f },
          value: u._parse(
            new Oe(i, d, i.path, f)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: f in i.data
        });
      }
    }
    return i.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const f of c) {
        const d = await f.key, h = await f.value;
        u.push({
          key: d,
          value: h,
          alwaysSet: f.alwaysSet
        });
      }
      return u;
    }).then((u) => oe.mergeObjectSync(n, u)) : oe.mergeObjectSync(n, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return T.errToObj, new H({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (t, n) => {
          var i, a, s, o;
          const c = (s = (a = (i = this._def).errorMap) === null || a === void 0 ? void 0 : a.call(i, t, n).message) !== null && s !== void 0 ? s : n.defaultError;
          return t.code === "unrecognized_keys" ? {
            message: (o = T.errToObj(e).message) !== null && o !== void 0 ? o : c
          } : {
            message: c
          };
        }
      } : {}
    });
  }
  strip() {
    return new H({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new H({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new H({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new H({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: C.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, t) {
    return this.augment({ [e]: t });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new H({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const t = {};
    return Q.objectKeys(e).forEach((n) => {
      e[n] && this.shape[n] && (t[n] = this.shape[n]);
    }), new H({
      ...this._def,
      shape: () => t
    });
  }
  omit(e) {
    const t = {};
    return Q.objectKeys(this.shape).forEach((n) => {
      e[n] || (t[n] = this.shape[n]);
    }), new H({
      ...this._def,
      shape: () => t
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return nt(this);
  }
  partial(e) {
    const t = {};
    return Q.objectKeys(this.shape).forEach((n) => {
      const i = this.shape[n];
      e && !e[n] ? t[n] = i : t[n] = i.optional();
    }), new H({
      ...this._def,
      shape: () => t
    });
  }
  required(e) {
    const t = {};
    return Q.objectKeys(this.shape).forEach((n) => {
      if (e && !e[n])
        t[n] = this.shape[n];
      else {
        let a = this.shape[n];
        for (; a instanceof Se; )
          a = a._def.innerType;
        t[n] = a;
      }
    }), new H({
      ...this._def,
      shape: () => t
    });
  }
  keyof() {
    return za(Q.objectKeys(this.shape));
  }
}
H.create = (r, e) => new H({
  shape: () => r,
  unknownKeys: "strip",
  catchall: Ce.create(),
  typeName: C.ZodObject,
  ...P(e)
});
H.strictCreate = (r, e) => new H({
  shape: () => r,
  unknownKeys: "strict",
  catchall: Ce.create(),
  typeName: C.ZodObject,
  ...P(e)
});
H.lazycreate = (r, e) => new H({
  shape: r,
  unknownKeys: "strip",
  catchall: Ce.create(),
  typeName: C.ZodObject,
  ...P(e)
});
class Ft extends M {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), n = this._def.options;
    function i(a) {
      for (const o of a)
        if (o.result.status === "valid")
          return o.result;
      for (const o of a)
        if (o.result.status === "dirty")
          return t.common.issues.push(...o.ctx.common.issues), o.result;
      const s = a.map((o) => new de(o.ctx.common.issues));
      return w(t, {
        code: g.invalid_union,
        unionErrors: s
      }), A;
    }
    if (t.common.async)
      return Promise.all(n.map(async (a) => {
        const s = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: t.data,
            path: t.path,
            parent: s
          }),
          ctx: s
        };
      })).then(i);
    {
      let a;
      const s = [];
      for (const c of n) {
        const u = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        }, f = c._parseSync({
          data: t.data,
          path: t.path,
          parent: u
        });
        if (f.status === "valid")
          return f;
        f.status === "dirty" && !a && (a = { result: f, ctx: u }), u.common.issues.length && s.push(u.common.issues);
      }
      if (a)
        return t.common.issues.push(...a.ctx.common.issues), a.result;
      const o = s.map((c) => new de(c));
      return w(t, {
        code: g.invalid_union,
        unionErrors: o
      }), A;
    }
  }
  get options() {
    return this._def.options;
  }
}
Ft.create = (r, e) => new Ft({
  options: r,
  typeName: C.ZodUnion,
  ...P(e)
});
const Ie = (r) => r instanceof Lt ? Ie(r.schema) : r instanceof ge ? Ie(r.innerType()) : r instanceof qt ? [r.value] : r instanceof Be ? r.options : r instanceof Qt ? Q.objectValues(r.enum) : r instanceof Bt ? Ie(r._def.innerType) : r instanceof Nt ? [void 0] : r instanceof Pt ? [null] : r instanceof Se ? [void 0, ...Ie(r.unwrap())] : r instanceof Ze ? [null, ...Ie(r.unwrap())] : r instanceof Zn || r instanceof Ut ? Ie(r.unwrap()) : r instanceof Zt ? Ie(r._def.innerType) : [];
class Er extends M {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== O.object)
      return w(t, {
        code: g.invalid_type,
        expected: O.object,
        received: t.parsedType
      }), A;
    const n = this.discriminator, i = t.data[n], a = this.optionsMap.get(i);
    return a ? t.common.async ? a._parseAsync({
      data: t.data,
      path: t.path,
      parent: t
    }) : a._parseSync({
      data: t.data,
      path: t.path,
      parent: t
    }) : (w(t, {
      code: g.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), A);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, t, n) {
    const i = /* @__PURE__ */ new Map();
    for (const a of t) {
      const s = Ie(a.shape[e]);
      if (!s.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const o of s) {
        if (i.has(o))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);
        i.set(o, a);
      }
    }
    return new Er({
      typeName: C.ZodDiscriminatedUnion,
      discriminator: e,
      options: t,
      optionsMap: i,
      ...P(n)
    });
  }
}
function vn(r, e) {
  const t = Re(r), n = Re(e);
  if (r === e)
    return { valid: !0, data: r };
  if (t === O.object && n === O.object) {
    const i = Q.objectKeys(e), a = Q.objectKeys(r).filter((o) => i.indexOf(o) !== -1), s = { ...r, ...e };
    for (const o of a) {
      const c = vn(r[o], e[o]);
      if (!c.valid)
        return { valid: !1 };
      s[o] = c.data;
    }
    return { valid: !0, data: s };
  } else if (t === O.array && n === O.array) {
    if (r.length !== e.length)
      return { valid: !1 };
    const i = [];
    for (let a = 0; a < r.length; a++) {
      const s = r[a], o = e[a], c = vn(s, o);
      if (!c.valid)
        return { valid: !1 };
      i.push(c.data);
    }
    return { valid: !0, data: i };
  } else return t === O.date && n === O.date && +r == +e ? { valid: !0, data: r } : { valid: !1 };
}
class Mt extends M {
  _parse(e) {
    const { status: t, ctx: n } = this._processInputParams(e), i = (a, s) => {
      if (pn(a) || pn(s))
        return A;
      const o = vn(a.value, s.value);
      return o.valid ? ((yn(a) || yn(s)) && t.dirty(), { status: t.value, value: o.data }) : (w(n, {
        code: g.invalid_intersection_types
      }), A);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([a, s]) => i(a, s)) : i(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
Mt.create = (r, e, t) => new Mt({
  left: r,
  right: e,
  typeName: C.ZodIntersection,
  ...P(t)
});
class xe extends M {
  _parse(e) {
    const { status: t, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== O.array)
      return w(n, {
        code: g.invalid_type,
        expected: O.array,
        received: n.parsedType
      }), A;
    if (n.data.length < this._def.items.length)
      return w(n, {
        code: g.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), A;
    !this._def.rest && n.data.length > this._def.items.length && (w(n, {
      code: g.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), t.dirty());
    const a = [...n.data].map((s, o) => {
      const c = this._def.items[o] || this._def.rest;
      return c ? c._parse(new Oe(n, s, n.path, o)) : null;
    }).filter((s) => !!s);
    return n.common.async ? Promise.all(a).then((s) => oe.mergeArray(t, s)) : oe.mergeArray(t, a);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new xe({
      ...this._def,
      rest: e
    });
  }
}
xe.create = (r, e) => {
  if (!Array.isArray(r))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new xe({
    items: r,
    typeName: C.ZodTuple,
    rest: null,
    ...P(e)
  });
};
class Vt extends M {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== O.object)
      return w(n, {
        code: g.invalid_type,
        expected: O.object,
        received: n.parsedType
      }), A;
    const i = [], a = this._def.keyType, s = this._def.valueType;
    for (const o in n.data)
      i.push({
        key: a._parse(new Oe(n, o, n.path, o)),
        value: s._parse(new Oe(n, n.data[o], n.path, o)),
        alwaysSet: o in n.data
      });
    return n.common.async ? oe.mergeObjectAsync(t, i) : oe.mergeObjectSync(t, i);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, t, n) {
    return t instanceof M ? new Vt({
      keyType: e,
      valueType: t,
      typeName: C.ZodRecord,
      ...P(n)
    }) : new Vt({
      keyType: ve.create(),
      valueType: e,
      typeName: C.ZodRecord,
      ...P(t)
    });
  }
}
class hr extends M {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== O.map)
      return w(n, {
        code: g.invalid_type,
        expected: O.map,
        received: n.parsedType
      }), A;
    const i = this._def.keyType, a = this._def.valueType, s = [...n.data.entries()].map(([o, c], u) => ({
      key: i._parse(new Oe(n, o, n.path, [u, "key"])),
      value: a._parse(new Oe(n, c, n.path, [u, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of s) {
          const u = await c.key, f = await c.value;
          if (u.status === "aborted" || f.status === "aborted")
            return A;
          (u.status === "dirty" || f.status === "dirty") && t.dirty(), o.set(u.value, f.value);
        }
        return { status: t.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const c of s) {
        const u = c.key, f = c.value;
        if (u.status === "aborted" || f.status === "aborted")
          return A;
        (u.status === "dirty" || f.status === "dirty") && t.dirty(), o.set(u.value, f.value);
      }
      return { status: t.value, value: o };
    }
  }
}
hr.create = (r, e, t) => new hr({
  valueType: e,
  keyType: r,
  typeName: C.ZodMap,
  ...P(t)
});
class Xe extends M {
  _parse(e) {
    const { status: t, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== O.set)
      return w(n, {
        code: g.invalid_type,
        expected: O.set,
        received: n.parsedType
      }), A;
    const i = this._def;
    i.minSize !== null && n.data.size < i.minSize.value && (w(n, {
      code: g.too_small,
      minimum: i.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.minSize.message
    }), t.dirty()), i.maxSize !== null && n.data.size > i.maxSize.value && (w(n, {
      code: g.too_big,
      maximum: i.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.maxSize.message
    }), t.dirty());
    const a = this._def.valueType;
    function s(c) {
      const u = /* @__PURE__ */ new Set();
      for (const f of c) {
        if (f.status === "aborted")
          return A;
        f.status === "dirty" && t.dirty(), u.add(f.value);
      }
      return { status: t.value, value: u };
    }
    const o = [...n.data.values()].map((c, u) => a._parse(new Oe(n, c, n.path, u)));
    return n.common.async ? Promise.all(o).then((c) => s(c)) : s(o);
  }
  min(e, t) {
    return new Xe({
      ...this._def,
      minSize: { value: e, message: T.toString(t) }
    });
  }
  max(e, t) {
    return new Xe({
      ...this._def,
      maxSize: { value: e, message: T.toString(t) }
    });
  }
  size(e, t) {
    return this.min(e, t).max(e, t);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
Xe.create = (r, e) => new Xe({
  valueType: r,
  minSize: null,
  maxSize: null,
  typeName: C.ZodSet,
  ...P(e)
});
class ct extends M {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== O.function)
      return w(t, {
        code: g.invalid_type,
        expected: O.function,
        received: t.parsedType
      }), A;
    function n(o, c) {
      return cr({
        data: o,
        path: t.path,
        errorMaps: [
          t.common.contextualErrorMap,
          t.schemaErrorMap,
          ur(),
          pt
        ].filter((u) => !!u),
        issueData: {
          code: g.invalid_arguments,
          argumentsError: c
        }
      });
    }
    function i(o, c) {
      return cr({
        data: o,
        path: t.path,
        errorMaps: [
          t.common.contextualErrorMap,
          t.schemaErrorMap,
          ur(),
          pt
        ].filter((u) => !!u),
        issueData: {
          code: g.invalid_return_type,
          returnTypeError: c
        }
      });
    }
    const a = { errorMap: t.common.contextualErrorMap }, s = t.data;
    if (this._def.returns instanceof vt) {
      const o = this;
      return ce(async function(...c) {
        const u = new de([]), f = await o._def.args.parseAsync(c, a).catch((p) => {
          throw u.addIssue(n(c, p)), u;
        }), d = await Reflect.apply(s, this, f);
        return await o._def.returns._def.type.parseAsync(d, a).catch((p) => {
          throw u.addIssue(i(d, p)), u;
        });
      });
    } else {
      const o = this;
      return ce(function(...c) {
        const u = o._def.args.safeParse(c, a);
        if (!u.success)
          throw new de([n(c, u.error)]);
        const f = Reflect.apply(s, this, u.data), d = o._def.returns.safeParse(f, a);
        if (!d.success)
          throw new de([i(f, d.error)]);
        return d.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new ct({
      ...this._def,
      args: xe.create(e).rest(Ge.create())
    });
  }
  returns(e) {
    return new ct({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, t, n) {
    return new ct({
      args: e || xe.create([]).rest(Ge.create()),
      returns: t || Ge.create(),
      typeName: C.ZodFunction,
      ...P(n)
    });
  }
}
class Lt extends M {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    return this._def.getter()._parse({ data: t.data, path: t.path, parent: t });
  }
}
Lt.create = (r, e) => new Lt({
  getter: r,
  typeName: C.ZodLazy,
  ...P(e)
});
class qt extends M {
  _parse(e) {
    if (e.data !== this._def.value) {
      const t = this._getOrReturnCtx(e);
      return w(t, {
        received: t.data,
        code: g.invalid_literal,
        expected: this._def.value
      }), A;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
qt.create = (r, e) => new qt({
  value: r,
  typeName: C.ZodLiteral,
  ...P(e)
});
function za(r, e) {
  return new Be({
    values: r,
    typeName: C.ZodEnum,
    ...P(e)
  });
}
class Be extends M {
  constructor() {
    super(...arguments), St.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const t = this._getOrReturnCtx(e), n = this._def.values;
      return w(t, {
        expected: Q.joinValues(n),
        received: t.parsedType,
        code: g.invalid_type
      }), A;
    }
    if (lr(this, St) || Qa(this, St, new Set(this._def.values)), !lr(this, St).has(e.data)) {
      const t = this._getOrReturnCtx(e), n = this._def.values;
      return w(t, {
        received: t.data,
        code: g.invalid_enum_value,
        options: n
      }), A;
    }
    return ce(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Values() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  extract(e, t = this._def) {
    return Be.create(e, {
      ...this._def,
      ...t
    });
  }
  exclude(e, t = this._def) {
    return Be.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...t
    });
  }
}
St = /* @__PURE__ */ new WeakMap();
Be.create = za;
class Qt extends M {
  constructor() {
    super(...arguments), Ot.set(this, void 0);
  }
  _parse(e) {
    const t = Q.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== O.string && n.parsedType !== O.number) {
      const i = Q.objectValues(t);
      return w(n, {
        expected: Q.joinValues(i),
        received: n.parsedType,
        code: g.invalid_type
      }), A;
    }
    if (lr(this, Ot) || Qa(this, Ot, new Set(Q.getValidEnumValues(this._def.values))), !lr(this, Ot).has(e.data)) {
      const i = Q.objectValues(t);
      return w(n, {
        received: n.data,
        code: g.invalid_enum_value,
        options: i
      }), A;
    }
    return ce(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
Ot = /* @__PURE__ */ new WeakMap();
Qt.create = (r, e) => new Qt({
  values: r,
  typeName: C.ZodNativeEnum,
  ...P(e)
});
class vt extends M {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== O.promise && t.common.async === !1)
      return w(t, {
        code: g.invalid_type,
        expected: O.promise,
        received: t.parsedType
      }), A;
    const n = t.parsedType === O.promise ? t.data : Promise.resolve(t.data);
    return ce(n.then((i) => this._def.type.parseAsync(i, {
      path: t.path,
      errorMap: t.common.contextualErrorMap
    })));
  }
}
vt.create = (r, e) => new vt({
  type: r,
  typeName: C.ZodPromise,
  ...P(e)
});
class ge extends M {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === C.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: t, ctx: n } = this._processInputParams(e), i = this._def.effect || null, a = {
      addIssue: (s) => {
        w(n, s), s.fatal ? t.abort() : t.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), i.type === "preprocess") {
      const s = i.transform(n.data, a);
      if (n.common.async)
        return Promise.resolve(s).then(async (o) => {
          if (t.value === "aborted")
            return A;
          const c = await this._def.schema._parseAsync({
            data: o,
            path: n.path,
            parent: n
          });
          return c.status === "aborted" ? A : c.status === "dirty" || t.value === "dirty" ? st(c.value) : c;
        });
      {
        if (t.value === "aborted")
          return A;
        const o = this._def.schema._parseSync({
          data: s,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? A : o.status === "dirty" || t.value === "dirty" ? st(o.value) : o;
      }
    }
    if (i.type === "refinement") {
      const s = (o) => {
        const c = i.refinement(o, a);
        if (n.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? A : (o.status === "dirty" && t.dirty(), s(o.value), { status: t.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? A : (o.status === "dirty" && t.dirty(), s(o.value).then(() => ({ status: t.value, value: o.value }))));
    }
    if (i.type === "transform")
      if (n.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!Ye(s))
          return s;
        const o = i.transform(s.value, a);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: t.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((s) => Ye(s) ? Promise.resolve(i.transform(s.value, a)).then((o) => ({ status: t.value, value: o })) : s);
    Q.assertNever(i);
  }
}
ge.create = (r, e, t) => new ge({
  schema: r,
  typeName: C.ZodEffects,
  effect: e,
  ...P(t)
});
ge.createWithPreprocess = (r, e, t) => new ge({
  schema: e,
  effect: { type: "preprocess", transform: r },
  typeName: C.ZodEffects,
  ...P(t)
});
class Se extends M {
  _parse(e) {
    return this._getType(e) === O.undefined ? ce(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Se.create = (r, e) => new Se({
  innerType: r,
  typeName: C.ZodOptional,
  ...P(e)
});
class Ze extends M {
  _parse(e) {
    return this._getType(e) === O.null ? ce(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ze.create = (r, e) => new Ze({
  innerType: r,
  typeName: C.ZodNullable,
  ...P(e)
});
class Bt extends M {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    let n = t.data;
    return t.parsedType === O.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: t.path,
      parent: t
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Bt.create = (r, e) => new Bt({
  innerType: r,
  typeName: C.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...P(e)
});
class Zt extends M {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), n = {
      ...t,
      common: {
        ...t.common,
        issues: []
      }
    }, i = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return Ct(i) ? i.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new de(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new de(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Zt.create = (r, e) => new Zt({
  innerType: r,
  typeName: C.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...P(e)
});
class pr extends M {
  _parse(e) {
    if (this._getType(e) !== O.nan) {
      const n = this._getOrReturnCtx(e);
      return w(n, {
        code: g.invalid_type,
        expected: O.nan,
        received: n.parsedType
      }), A;
    }
    return { status: "valid", value: e.data };
  }
}
pr.create = (r) => new pr({
  typeName: C.ZodNaN,
  ...P(r)
});
const Pc = Symbol("zod_brand");
class Zn extends M {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), n = t.data;
    return this._def.type._parse({
      data: n,
      path: t.path,
      parent: t
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Wt extends M {
  _parse(e) {
    const { status: t, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return a.status === "aborted" ? A : a.status === "dirty" ? (t.dirty(), st(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const i = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return i.status === "aborted" ? A : i.status === "dirty" ? (t.dirty(), {
        status: "dirty",
        value: i.value
      }) : this._def.out._parseSync({
        data: i.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, t) {
    return new Wt({
      in: e,
      out: t,
      typeName: C.ZodPipeline
    });
  }
}
class Ut extends M {
  _parse(e) {
    const t = this._def.innerType._parse(e), n = (i) => (Ye(i) && (i.value = Object.freeze(i.value)), i);
    return Ct(t) ? t.then((i) => n(i)) : n(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ut.create = (r, e) => new Ut({
  innerType: r,
  typeName: C.ZodReadonly,
  ...P(e)
});
function zi(r, e) {
  const t = typeof r == "function" ? r(e) : typeof r == "string" ? { message: r } : r;
  return typeof t == "string" ? { message: t } : t;
}
function $a(r, e = {}, t) {
  return r ? yt.create().superRefine((n, i) => {
    var a, s;
    const o = r(n);
    if (o instanceof Promise)
      return o.then((c) => {
        var u, f;
        if (!c) {
          const d = zi(e, n), h = (f = (u = d.fatal) !== null && u !== void 0 ? u : t) !== null && f !== void 0 ? f : !0;
          i.addIssue({ code: "custom", ...d, fatal: h });
        }
      });
    if (!o) {
      const c = zi(e, n), u = (s = (a = c.fatal) !== null && a !== void 0 ? a : t) !== null && s !== void 0 ? s : !0;
      i.addIssue({ code: "custom", ...c, fatal: u });
    }
  }) : yt.create();
}
const Fc = {
  object: H.lazycreate
};
var C;
(function(r) {
  r.ZodString = "ZodString", r.ZodNumber = "ZodNumber", r.ZodNaN = "ZodNaN", r.ZodBigInt = "ZodBigInt", r.ZodBoolean = "ZodBoolean", r.ZodDate = "ZodDate", r.ZodSymbol = "ZodSymbol", r.ZodUndefined = "ZodUndefined", r.ZodNull = "ZodNull", r.ZodAny = "ZodAny", r.ZodUnknown = "ZodUnknown", r.ZodNever = "ZodNever", r.ZodVoid = "ZodVoid", r.ZodArray = "ZodArray", r.ZodObject = "ZodObject", r.ZodUnion = "ZodUnion", r.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", r.ZodIntersection = "ZodIntersection", r.ZodTuple = "ZodTuple", r.ZodRecord = "ZodRecord", r.ZodMap = "ZodMap", r.ZodSet = "ZodSet", r.ZodFunction = "ZodFunction", r.ZodLazy = "ZodLazy", r.ZodLiteral = "ZodLiteral", r.ZodEnum = "ZodEnum", r.ZodEffects = "ZodEffects", r.ZodNativeEnum = "ZodNativeEnum", r.ZodOptional = "ZodOptional", r.ZodNullable = "ZodNullable", r.ZodDefault = "ZodDefault", r.ZodCatch = "ZodCatch", r.ZodPromise = "ZodPromise", r.ZodBranded = "ZodBranded", r.ZodPipeline = "ZodPipeline", r.ZodReadonly = "ZodReadonly";
})(C || (C = {}));
const Mc = (r, e = {
  message: `Input not instance of ${r.name}`
}) => $a((t) => t instanceof r, e), Wa = ve.create, Ga = qe.create, Vc = pr.create, Lc = Qe.create, Ja = At.create, qc = Ke.create, Qc = fr.create, Bc = Nt.create, Zc = Pt.create, Uc = yt.create, zc = Ge.create, $c = Ce.create, Wc = dr.create, Gc = me.create, Jc = H.create, Hc = H.strictCreate, Yc = Ft.create, Kc = Er.create, Xc = Mt.create, el = xe.create, tl = Vt.create, rl = hr.create, nl = Xe.create, il = ct.create, al = Lt.create, sl = qt.create, ol = Be.create, ul = Qt.create, cl = vt.create, $i = ge.create, ll = Se.create, fl = Ze.create, dl = ge.createWithPreprocess, hl = Wt.create, pl = () => Wa().optional(), yl = () => Ga().optional(), vl = () => Ja().optional(), ml = {
  string: (r) => ve.create({ ...r, coerce: !0 }),
  number: (r) => qe.create({ ...r, coerce: !0 }),
  boolean: (r) => At.create({
    ...r,
    coerce: !0
  }),
  bigint: (r) => Qe.create({ ...r, coerce: !0 }),
  date: (r) => Ke.create({ ...r, coerce: !0 })
}, gl = A;
var l = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: pt,
  setErrorMap: dc,
  getErrorMap: ur,
  makeIssue: cr,
  EMPTY_PATH: hc,
  addIssueToContext: w,
  ParseStatus: oe,
  INVALID: A,
  DIRTY: st,
  OK: ce,
  isAborted: pn,
  isDirty: yn,
  isValid: Ye,
  isAsync: Ct,
  get util() {
    return Q;
  },
  get objectUtil() {
    return hn;
  },
  ZodParsedType: O,
  getParsedType: Re,
  ZodType: M,
  datetimeRegex: Ua,
  ZodString: ve,
  ZodNumber: qe,
  ZodBigInt: Qe,
  ZodBoolean: At,
  ZodDate: Ke,
  ZodSymbol: fr,
  ZodUndefined: Nt,
  ZodNull: Pt,
  ZodAny: yt,
  ZodUnknown: Ge,
  ZodNever: Ce,
  ZodVoid: dr,
  ZodArray: me,
  ZodObject: H,
  ZodUnion: Ft,
  ZodDiscriminatedUnion: Er,
  ZodIntersection: Mt,
  ZodTuple: xe,
  ZodRecord: Vt,
  ZodMap: hr,
  ZodSet: Xe,
  ZodFunction: ct,
  ZodLazy: Lt,
  ZodLiteral: qt,
  ZodEnum: Be,
  ZodNativeEnum: Qt,
  ZodPromise: vt,
  ZodEffects: ge,
  ZodTransformer: ge,
  ZodOptional: Se,
  ZodNullable: Ze,
  ZodDefault: Bt,
  ZodCatch: Zt,
  ZodNaN: pr,
  BRAND: Pc,
  ZodBranded: Zn,
  ZodPipeline: Wt,
  ZodReadonly: Ut,
  custom: $a,
  Schema: M,
  ZodSchema: M,
  late: Fc,
  get ZodFirstPartyTypeKind() {
    return C;
  },
  coerce: ml,
  any: Uc,
  array: Gc,
  bigint: Lc,
  boolean: Ja,
  date: qc,
  discriminatedUnion: Kc,
  effect: $i,
  enum: ol,
  function: il,
  instanceof: Mc,
  intersection: Xc,
  lazy: al,
  literal: sl,
  map: rl,
  nan: Vc,
  nativeEnum: ul,
  never: $c,
  null: Zc,
  nullable: fl,
  number: Ga,
  object: Jc,
  oboolean: vl,
  onumber: yl,
  optional: ll,
  ostring: pl,
  pipeline: hl,
  preprocess: dl,
  promise: cl,
  record: tl,
  set: nl,
  strictObject: Hc,
  string: Wa,
  symbol: Qc,
  transformer: $i,
  tuple: el,
  undefined: Bc,
  union: Yc,
  unknown: zc,
  void: Wc,
  NEVER: gl,
  ZodIssueCode: g,
  quotelessJson: fc,
  ZodError: de
});
const Ha = l.object({
  id: l.number(),
  name: l.string(),
  slug: l.string(),
  status: l.enum(["PENDING", "COMPLETED", "FAILED", "CANCELLED"]),
  input: l.object({}).partial().passthrough(),
  output: l.object({}).partial().passthrough().nullable(),
  createdAt: l.string(),
  startedAt: l.string().nullable(),
  endedAt: l.string().nullable()
}).passthrough(), bl = l.object({ analyses: l.array(Ha) }).passthrough(), _l = l.object({
  name: l.string().min(1).max(100),
  outputLocation: l.object({ s3BucketId: l.number(), path: l.string().optional() }).passthrough(),
  analysisSchemaId: l.number().int().gt(0),
  version: l.number(),
  input: l.unknown()
}).passthrough(), wl = l.object({
  analysisId: l.number().nullable(),
  analysisSlug: l.string().nullable(),
  success: l.boolean()
}).passthrough(), Ya = l.object({ id: l.number(), name: l.string(), versions: l.array(l.number()) }).passthrough(), kl = l.object({ analysisSchemas: l.array(Ya) }).passthrough(), Un = l.object({
  id: l.number(),
  name: l.string(),
  schema: l.object({}).partial().passthrough()
}).passthrough(), mn = l.object({ id: l.number(), name: l.string(), valueSchema: Un }).passthrough(), Ka = l.object({
  analysisSchemaId: l.number(),
  version: l.number(),
  createdAt: l.string(),
  description: l.object({ short: l.string().nullable(), long: l.string().nullable() }).partial().passthrough(),
  inputs: l.array(mn),
  outputs: l.array(mn)
}).passthrough(), El = l.object({ versions: l.array(Ka) }).passthrough(), Xa = l.object({
  analysisSchemaId: l.number(),
  version: l.number(),
  name: l.string()
}).passthrough(), Sl = l.object({ next: l.array(Xa) }).passthrough(), Ol = l.object({ valueSchemas: l.array(Un) }).passthrough(), es = l.enum([
  "ADMIN",
  "USER",
  "PROFESSOR",
  "PREMIUM_USER",
  "FREE_USER"
]), zn = l.object({
  id: l.string(),
  firstname: l.string().nullable(),
  lastname: l.string().nullable(),
  email: l.string().nullable(),
  keyPairId: l.number(),
  roles: l.array(es),
  permissions: l.array(l.string())
}).passthrough(), xl = l.object({ user: zn }).partial().passthrough(), Tl = l.object({ email: l.string() }).passthrough(), Dl = l.object({ success: l.boolean() }).passthrough(), Il = l.object({ otp: l.string() }).passthrough(), Rl = l.object({ success: l.boolean() }).passthrough(), jl = l.object({ success: l.boolean() }).passthrough(), Cl = l.object({ token: l.string() }).passthrough(), Al = l.object({ token: l.string() }).passthrough(), Nl = l.object({ valid: l.boolean() }).passthrough(), ts = l.object({ id: l.number(), permissionId: l.string() }).passthrough(), Pl = l.object({ name: l.string(), permissions: l.array(ts) }).passthrough(), rs = l.object({
  id: l.number(),
  instanceProfile: l.string().nullable(),
  securityGroup: l.string().nullable()
}).passthrough(), Gt = l.object({
  id: l.number(),
  name: l.string(),
  labId: l.number().nullish(),
  userId: l.string().nullish(),
  status: l.enum([
    "pending",
    "running",
    "stopping",
    "stopped",
    "shutting_down",
    "terminated"
  ]),
  ipAddress: l.string().nullish(),
  lastLogin: l.string().nullish(),
  keypairId: l.number().nullish()
}).passthrough(), Fl = l.object({
  infra: l.array(rs),
  keyPairs: l.array(l.string()),
  tinkerBoxes: l.array(Gt)
}).passthrough(), Ml = l.object({ count: l.number().gte(1).lte(15) }).passthrough(), Vl = l.object({
  firstname: l.string().min(1),
  lastname: l.string().min(1),
  email: l.string().email(),
  password: l.string().min(8)
}).passthrough(), Ll = l.object({ users: l.array(zn) }).passthrough(), ql = l.object({
  firstname: l.string().nullable(),
  lastname: l.string().nullable(),
  email: l.string().nullable()
}).partial().passthrough(), ns = l.object({ tinkerBox: Gt, keyMaterial: l.string() }).passthrough(), Ql = l.object({ tinkerBoxes: l.array(ns) }).passthrough(), is = l.object({
  labName: l.string(),
  ec2Cost: l.number(),
  s3Cost: l.number(),
  efsCost: l.number(),
  totalCost: l.number()
}).passthrough(), Bl = l.object({ clients: l.array(is) }).passthrough(), as = l.object({
  name: l.string(),
  labName: l.string(),
  usage: l.string(),
  cost: l.number()
}).passthrough(), Zl = l.object({ tinkerBoxes: l.array(as) }).passthrough(), Ul = l.object({ tinkerboxes: l.array(Gt) }).passthrough(), zl = l.object({ tinkerBox: Gt }).passthrough(), $l = l.object({ name: l.string().nullable() }).partial().passthrough(), ss = l.object({
  id: l.number(),
  name: l.string(),
  s3BucketId: l.number(),
  keyPairId: l.number()
}).passthrough(), Wl = l.object({ labs: l.array(ss) }).passthrough(), Gl = l.object({
  name: l.string(),
  numTinkerBoxes: l.number().optional().default(1)
}).passthrough(), Jl = l.object({ labId: l.number(), taskId: l.string() }).passthrough(), Hl = l.object({ id: l.string(), labId: l.number(), logs: l.string() }).passthrough(), $n = l.object({
  id: l.number(),
  labId: l.number(),
  userId: l.string(),
  role: l.enum(["OWNER", "MEMBER"]),
  user: l.object({
    firstname: l.string().nullable(),
    lastname: l.string().nullable(),
    email: l.string().nullable(),
    id: l.string()
  }).partial().passthrough()
}).passthrough(), Yl = l.object({ labMember: $n.nullable() }).passthrough(), Kl = l.object({ labMembers: l.array($n) }).passthrough(), Xl = l.object({
  labMember: l.object({
    id: l.number().int(),
    labId: l.number().int(),
    userId: l.string(),
    role: l.enum(["OWNER", "MEMBER"])
  }).passthrough()
}).passthrough(), ef = l.object({ role: l.string() }).passthrough(), tf = l.object({ labMemberId: l.number(), role: l.string() }).passthrough(), rf = l.object({ success: l.boolean() }).passthrough(), nf = l.object({
  client_secret: l.string().nullable(),
  status: l.string().nullable(),
  payment_status: l.string()
}).passthrough(), af = l.object({ name: l.string(), email: l.string().email(), message: l.string() }).passthrough(), sf = l.object({ path: l.string(), s3BucketId: l.number().optional() }).passthrough(), of = l.object({ success: l.boolean() }).passthrough(), uf = l.object({ url: l.string() }).passthrough(), os = l.object({
  isFolder: l.boolean(),
  bucketId: l.number().optional(),
  path: l.string()
}).passthrough(), cf = l.object({ contents: l.array(os) }).passthrough(), lf = l.object({ files: l.array(l.string()) }).passthrough(), ff = l.object({
  buckets: l.array(
    l.object({
      id: l.number().int(),
      bucket: l.string(),
      region: l.string(),
      prefix: l.string().nullish()
    }).passthrough()
  )
}).passthrough(), df = l.object({
  source: l.object({
    isFolder: l.boolean(),
    bucketId: l.number().optional(),
    path: l.string()
  }).passthrough(),
  target: l.object({
    isFolder: l.boolean(),
    bucketId: l.number().optional(),
    path: l.string()
  }).passthrough()
}).passthrough(), hf = l.object({
  fileTransfers: l.array(
    l.object({
      id: l.number().int(),
      name: l.string(),
      userId: l.string(),
      progress: l.number()
    }).passthrough()
  )
}).passthrough(), us = l.object({
  id: l.number(),
  name: l.string(),
  analysisSchemaId: l.number(),
  analysisSchemaVersion: l.number(),
  config: l.object({}).partial().passthrough()
}).passthrough(), pf = l.object({ templates: l.array(us) }).passthrough(), yf = l.object({
  name: l.string().min(1).max(255),
  analysisSchemaId: l.number().int(),
  analysisSchemaVersion: l.number().int().gt(0),
  triggerLocation: l.object({
    bucketId: l.number().int().gt(0),
    folderPath: l.string().max(2048)
  }).passthrough(),
  config: l.unknown()
}).passthrough(), vf = l.object({
  id: l.number(),
  name: l.string(),
  s3BucketId: l.number(),
  triggerFolder: l.string(),
  analysisSchemaId: l.number(),
  analysisSchemaVersion: l.number(),
  config: l.object({}).partial().passthrough()
}).passthrough(), mf = l.object({ name: l.string(), enabled: l.boolean() }).passthrough(), gf = l.object({
  id: l.number(),
  name: l.string(),
  schema: l.object({}).partial().passthrough()
}).passthrough(), bf = l.object({
  id: l.number(),
  formId: l.number(),
  data: l.object({}).partial().passthrough(),
  dateCreated: l.string()
}).passthrough(), _f = l.object({
  id: l.number(),
  name: l.string(),
  displayName: l.string(),
  hichip: l.string(),
  source: l.string(),
  bucket: l.string(),
  bedpeKey: l.string(),
  hicKey: l.string(),
  category: l.string()
}).passthrough(), wf = l.object({
  id: l.number(),
  sampleId: l.number(),
  cluster: l.string(),
  chr: l.string(),
  start: l.number(),
  end: l.number(),
  size: l.number(),
  genes: l.string()
}).passthrough(), kf = l.object({
  plotId: l.string(),
  status: l.enum(["PENDING", "COMPLETED", "FAILED", "CANCELLED"]),
  outputBucket: l.string(),
  outputKey: l.string(),
  inputs: l.object({}).partial().passthrough(),
  endedAt: l.string().nullable(),
  downloadUrl: l.string().nullable()
}).passthrough(), Ef = l.object({
  sample: l.string(),
  range: l.string(),
  genomeBuild: l.enum(["hg19", "hg38"]),
  color: l.string().regex(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/),
  inherent: l.string(),
  flank: l.number(),
  bedpe: l.string()
}).passthrough(), Wn = l.object({
  id: l.number(),
  title: l.string(),
  content: l.string(),
  createdAt: l.string(),
  updatedAt: l.string(),
  isActive: l.boolean()
}).passthrough(), Sf = l.object({ announcements: l.array(Wn) }).passthrough(), Of = l.object({ announcement: Wn.nullable() }).passthrough(), Wi = {
  AnalysisDto: Ha,
  AnalysesDto: bl,
  CreateAnalysisBodyDto: _l,
  CreateAndLaunchAnalysisResponseDto: wl,
  AnalysisSchemaDto: Ya,
  AnalysisSchemasDto: kl,
  ValueSchemaDto: Un,
  AnalysisSchemaInputOutput: mn,
  AnalysisSchemaVersionDto: Ka,
  AnalysisSchemaVersionsDto: El,
  AnalysisNextDto: Xa,
  AnalysisNextListDto: Sl,
  ValueSchemasDto: Ol,
  UserRole: es,
  UserDto: zn,
  MeResponse: xl,
  RequestOtpBody: Tl,
  RequestOtpResponse: Dl,
  LoginBody: Il,
  LoginResponse: Rl,
  SuccessDto: jl,
  LoginCliResponse: Cl,
  VerifyTokenBody: Al,
  VerifyTokenResponse: Nl,
  Permission: ts,
  RoleDto: Pl,
  Infra: rs,
  TinkerBox: Gt,
  InfraPool: Fl,
  CreateInfraPoolBody: Ml,
  CreateUserBody: Vl,
  UsersDto: Ll,
  UpdateUserBody: ql,
  TinkerBoxInventory: ns,
  TinkerBoxInventoryList: Ql,
  ClientUsage: is,
  ClientsUsage: Bl,
  TinkerBoxWithUsage: as,
  TinkerBoxesWithUsage: Zl,
  GetTinkerBoxesResponse: Ul,
  LaunchTinkerBoxResponse: zl,
  LaunchLabTinkerBoxBody: $l,
  Lab: ss,
  LabsResponse: Wl,
  CreateLabBody: Gl,
  CreateLabResponse: Jl,
  GetLabCreationTaskResponse: Hl,
  LabMemberDto: $n,
  LabMemberResponse: Yl,
  LabMembersResponse: Kl,
  AddLabMemberResponse: Xl,
  UpdateLabMemberBody: ef,
  UpdateLabMemberResponse: tf,
  DeleteLabMemberResponse: rf,
  CheckoutSession: nf,
  ContactBody: af,
  CreateDirectoryBody: sf,
  CreateDirectoryResponse: of,
  PresignedUrlResponse: uf,
  FilePath: os,
  ContentsResponse: cf,
  DeleteFilesResponse: lf,
  GetBucketsResponse: ff,
  MoveFileBody: df,
  FileTransfersResponse: hf,
  ActionTemplateDto: us,
  ActionTemplatesDto: pf,
  CreateActionBodyDto: yf,
  ActionDto: vf,
  FeatureFlagDto: mf,
  FormSchema: gf,
  FormSubmission: bf,
  SampleDto: _f,
  SampleClusterDto: wf,
  PlotDto: kf,
  PlotContactsArgs: Ef,
  Announcement: Wn,
  ActiveAnnouncements: Sf,
  LatestAnnouncement: Of
};
class Rf {
  constructor(e) {
    mt(this, "fetch");
    this.fetch = e;
  }
  async download(e, t, n = null, i = !0) {
    let s = `/files/presigned/${encodeURIComponent(t)}/url?method=download`;
    e && (s += `&bucket=${e}`), n && (s += `&limit=${n}`);
    const c = (await this.fetch(
      s,
      { method: "GET" },
      Wi.PresignedUrlResponse
    )).url;
    if (i) {
      const u = document.createElement("a");
      u.href = c, u.download = "", u.target = "_blank", u.click(), document.body.appendChild(u), u.click(), setTimeout(() => {
        document.body.removeChild(u);
      });
    }
    return c;
  }
  async upload(e, t, n) {
    const i = [];
    let s = `/files/presigned/${encodeURIComponent(n)}/url?method=upload`;
    t && (s = s += `&bucket=${t}`);
    const c = (await this.fetch(
      s,
      { method: "GET" },
      Wi.PresignedUrlResponse
    )).url, u = new XMLHttpRequest();
    return u.open("PUT", c), u.addEventListener("error", () => {
      for (const f of i)
        f.onError(new Error("Failed to upload file"));
    }), u.onerror = () => {
      for (const f of i)
        f.onError(new Error("Failed to upload file"));
    }, u.upload.addEventListener("progress", (f) => {
      const d = f.loaded / f.total;
      for (const h of i)
        h.onProgress(d);
    }), u.upload.addEventListener("load", () => {
      for (const f of i)
        f.onComplete();
      u.upload.removeEventListener("progress", () => null);
    }), u.send(e), {
      subscribe(f) {
        i.push(f);
      }
    };
  }
}
const xf = async (r) => {
  if (!(await fetch(r, {
    method: "GET",
    credentials: "include"
  })).ok)
    throw new Error("Failed to refresh token");
};
function jf(r) {
  async function e(t, n = {}, i, a = !0) {
    const s = { "Content-Type": "application/json", ...n.headers }, o = await fetch(`${r}${t}`, {
      ...n,
      headers: s,
      credentials: "include"
    });
    if ((o.status === 401 || o.status === 403) && a)
      return await xf(`${r}/auth/token/refresh`), e(
        t,
        { headers: s, ...n, credentials: "include" },
        i,
        !1
      );
    if (!o.ok) {
      const c = await o.text();
      throw new Error(c);
    }
    if (i) {
      const c = await o.json();
      return i.parse(c);
    } else
      return o;
  }
  return e;
}
export {
  If as APIClient,
  Rf as S3,
  jf as createFetch,
  xf as refreshToken,
  Wi as schemas
};
//# sourceMappingURL=client.js.map
